
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("foVrt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bXh4X = parcelRequire("bXh4X");


var $67wrw = parcelRequire("67wrw");


var $cDpdq = parcelRequire("cDpdq");


var $j2p1x = parcelRequire("j2p1x");


var $eSr5w = parcelRequire("eSr5w");


var $9wGTI = parcelRequire("9wGTI");


var $7QM6o = parcelRequire("7QM6o");


var $bQm3c = parcelRequire("bQm3c");


var $02cx8 = parcelRequire("02cx8");


var $lmEhP = parcelRequire("lmEhP");


var $hfIjM = parcelRequire("hfIjM");

const $820a39291628bd44$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $820a39291628bd44$var$defaultOptions = {
    appearance: 'full-page',
    onFeedbackClicked: ()=>{},
    onReviewStateEntered: ()=>{},
    onExperienceComplete: ()=>{},
    aiGlobalOptIn: {
        status: 'disabled',
        triggerOptInFlow: ()=>{}
    }
};
const $820a39291628bd44$export$ac968d961305af39 = (options)=>{
    const optionsToUse = options || $820a39291628bd44$var$defaultOptions;
    const createEditorPluginAIOptions = (0, $cozmU.useMemo)(()=>optionsToUse.appearance === 'page-comment' ? (0, $j2p1x.createPageCommentEditorPluginAIOptions) : (0, $j2p1x.createPageEditorPluginAIOptions), [
        optionsToUse.appearance
    ]);
    const optionsToUseRef = (0, $cozmU.useRef)(optionsToUse);
    optionsToUseRef.current = optionsToUse;
    const { cloudId: cloudId, userId: userId, isRovoEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = (0, $9wGTI.fg)('platform_editor_rovo_availability') ? isRovoLLMEnabled : undefined;
    // Memoize session data to avoid recreating the object on every render
    const sessionData = (0, $cozmU.useMemo)(()=>userId && cloudId ? {
            userId: userId,
            cloudId: cloudId
        } : undefined, [
        userId,
        cloudId
    ]);
    // Use the dedicated hook for auto-apply state management
    const autoApplyState = (0, $eSr5w.useAutoApplyState)((0, $9wGTI.fg)('enable_auto_apply_toggling') ? sessionData : undefined);
    const isInDocumentStreamingAllowed = (0, $9wGTI.fg)('enable_auto_apply_toggling') ? autoApplyState?.enabled ?? false : false;
    const refresh = autoApplyState?.refresh;
    // Listen for changes from other parts of the app
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('enable_auto_apply_toggling') || !refresh) return;
        const handleAutoApplyChange = ()=>{
            // Refresh the state from backend/localStorage when toggle changes
            refresh();
        };
        window.addEventListener('autoApplyChanged', handleAutoApplyChange);
        return ()=>window.removeEventListener('autoApplyChanged', handleAutoApplyChange);
    }, [
        refresh
    ]);
    // Use a ref to avoid recreating the options object on every state update
    const isInDocumentStreamingAllowedRef = (0, $cozmU.useRef)(isInDocumentStreamingAllowed);
    isInDocumentStreamingAllowedRef.current = isInDocumentStreamingAllowed;
    const productConfig = (0, $cozmU.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(undefined, productConfig);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId);
    const linkingProp = (0, $lmEhP.useLinkingFeatures)($820a39291628bd44$var$CARD_OPTIONS);
    const PromptEditor = (0, $cozmU.useMemo)(()=>(0, $67wrw.createPromptEditor)({
            linkPicker: linkPicker,
            enableLinks: true,
            linking: linkingProp.linking,
            mentionProvider: mentionProvider,
            featureFlags: {}
        }), [
        linkingProp.linking,
        linkPicker,
        mentionProvider
    ]);
    const editorRovoButtonActions = (0, $02cx8.useEditorRovoButtonActions)();
    const isAISmartButtonEnabled = (0, $cozmU.useMemo)(()=>optionsToUse.appearance !== 'page-comment' && optionsToUse.aiGlobalOptIn.status === 'enabled', [
        optionsToUse.appearance,
        optionsToUse.aiGlobalOptIn.status
    ]);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const aiSmartButtonOptions = (0, $cozmU.useMemo)(()=>isAISmartButtonEnabled ? {
            actions: {
                ...editorRovoButtonActions,
                setNudges: setNudges
            }
        } : undefined, [
        isAISmartButtonEnabled,
        editorRovoButtonActions,
        setNudges
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return createEditorPluginAIOptions({
            aiGlobalOptIn: optionsToUseRef.current.aiGlobalOptIn,
            /**
			 * Hide AI button in primary toolbar when AI proactive is enabled or
			 * 	when appearance is full-page and AI smart button is enabled
			 */ hidePrimaryToolbarButton: optionsToUse.appearance === 'full-page' && optionsToUse.aiGlobalOptIn.status === 'enabled',
            generativeAIApiUrl: `${window.location.origin}/gateway/api/editor-ai/v1/generative/ai`,
            handleFeedbackSubmission: async (feedbackMetadata)=>{
                try {
                    // TODO: EDF-831: Fix and ensure types match with handleFeedbackSubmission
                    optionsToUseRef.current.onFeedbackClicked?.(feedbackMetadata);
                    return {
                        status: 'submitted'
                    };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (error) {
                    return {
                        status: 'failed'
                    };
                }
            },
            onAnnotationsRemoved: optionsToUseRef.current.onAnnotationsRemoved,
            onExperienceEvent: {
                // Thumbs up and down are being deprecated and are no longer used.
                THUMBS_UP: ()=>{},
                THUMBS_DOWN: ()=>{},
                REVIEW_STATE_ENTERED: ()=>{
                    optionsToUseRef.current.onReviewStateEntered?.();
                },
                EXPERIENCE_COMPLETE: ()=>{
                    optionsToUseRef.current.onExperienceComplete?.();
                }
            },
            onDocChangeByAgent: (_agent)=>{
            // TODO Integrate with confluence
            },
            onAIProviderChanged: (source, aiProvider)=>{
                if (optionsToUseRef.current.onAIProviderChanged) optionsToUseRef.current.onAIProviderChanged(source, aiProvider);
            },
            getUserPreferences: ()=>{
                if (!(0, $9wGTI.fg)('enable_auto_apply_toggling')) return {};
                return {
                    isInDocumentStreamingAllowed: isInDocumentStreamingAllowedRef.current
                };
            },
            getChannelVariables: optionsToUseRef.current.getChannelVariables,
            product: 'CONFLUENCE',
            objectId: optionsToUseRef.current.contentId,
            PromptEditor: PromptEditor,
            AIButtonWrapper: options?.AIButtonWrapper,
            providers: options?.providers,
            /**
			 * Need to audit logs only for confluence page as of now.
			 */ auditLogSettings: optionsToUse.appearance !== 'page-comment' && optionsToUse.contentId ? {
                enabled: true,
                eventData: {
                    type: 'page',
                    pageId: optionsToUse.contentId
                }
            } : {
                enabled: false
            },
            ...isAISmartButtonEnabled && {
                aiSmartButtonOptions: aiSmartButtonOptions
            },
            ...optionsToUse.usePlatformPrompt && {
                onSubmit: ()=>{}
            },
            isInDocumentStreamingEnabled: true,
            isRovoEnabled: isRovoEnabled,
            // Provide creation context for experience-based agent routing.
            // Only set for full-page editor appearances (pages/blogs), not page comments.
            ...optionsToUse.appearance !== 'page-comment' && {
                creationContextParams: {
                    experience: 'inline_edit',
                    contentTypes: [
                        optionsToUse.contentType ?? 'page'
                    ]
                }
            }
        });
    }, [
        createEditorPluginAIOptions,
        optionsToUse.appearance,
        optionsToUse.contentId,
        optionsToUse.contentType,
        PromptEditor,
        options?.AIButtonWrapper,
        options?.providers,
        isAISmartButtonEnabled,
        aiSmartButtonOptions,
        optionsToUse.aiGlobalOptIn.status,
        optionsToUse.usePlatformPrompt,
        isRovoEnabled
    ]);
};
module.exports["useEditorPluginAIOptions"] = $820a39291628bd44$export$ac968d961305af39;

});

parcelRegister("j2p1x", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $93WrI = parcelRequire("93WrI");

var $2urSQ = parcelRequire("2urSQ");

var $7ZL6d = parcelRequire("7ZL6d");


var $ggncV = parcelRequire("ggncV");

var $p6OqS = parcelRequire("p6OqS");

var $6Jphz = parcelRequire("6Jphz");

var $dQeg1 = parcelRequire("dQeg1");

var $4WfQc = parcelRequire("4WfQc");

var $2xJ2w = parcelRequire("2xJ2w");

var $3CdTA = parcelRequire("3CdTA");

var $74BSk = parcelRequire("74BSk");


var $7Jde4 = parcelRequire("7Jde4");


var $ixfCV = parcelRequire("ixfCV");


var $4TgUg = parcelRequire("4TgUg");


var $cozmU = parcelRequire("cozmU");








var $dVbiN = parcelRequire("dVbiN");

const $308391080aec9cff$export$ced89349fedce38 = ({ size: size = 'medium' } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
        label: "",
        spacing: "spacious",
        size: size
    });



var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $88f2ac45e0b8ca2a$export$683185be8e4be56f = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).BRAINSTORM,
        title: (0, $93WrI.aiConfigItemMessages).brainstormTitle,
        description: (0, $93WrI.aiConfigItemMessages).brainstormDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $308391080aec9cff$export$ced89349fedce38), null),
        promptLabel: (0, $93WrI.aiConfigItemMessages).brainstormPromptLabel,
        promptHint: (0, $93WrI.aiConfigItemMessages).brainstormPromptHint,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        agentId: 'editor_agent',
        intentSchemaId: 'brainstorm_intent_schema.json',
        featureId: 'brainstorm',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $88f2ac45e0b8ca2a$export$dddd8d441293ae3 = (options)=>({
        config: $88f2ac45e0b8ca2a$export$683185be8e4be56f(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });



var $dFWys = parcelRequire("dFWys");








var $3fO5l = parcelRequire("3fO5l");







const $6c2fd50787c1318b$var$intentSchemaId = 'convert_to_bullet_points.json';
const $6c2fd50787c1318b$export$c791aa34bcfdf607 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CONVERT_TO_BULLETED_LIST,
        title: (0, $93WrI.aiConfigItemMessages).convertToBulletListTitle,
        description: (0, $93WrI.aiConfigItemMessages).convertToBulletListDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $6c2fd50787c1318b$var$intentSchemaId,
        actions: {
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $6c2fd50787c1318b$export$37c986c539d0ca07 = (options)=>({
        config: $6c2fd50787c1318b$export$c791aa34bcfdf607(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });









var $1bzO2 = parcelRequire("1bzO2");







const $e180adc23351de79$var$intentSchemaId = 'convert_to_table.json';
const $e180adc23351de79$export$a7ada90d2d2877a7 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CONVERT_TO_TABLE,
        title: (0, $93WrI.aiConfigItemMessages).convertToTableTitle,
        description: (0, $93WrI.aiConfigItemMessages).convertToTableDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $e180adc23351de79$var$intentSchemaId,
        actions: {
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $e180adc23351de79$export$d67616d0b45ccf63 = (options)=>({
        config: $e180adc23351de79$export$a7ada90d2d2877a7(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });



var $iO5TS = parcelRequire("iO5TS");












var $cXtTj = parcelRequire("cXtTj");

const $5b3f9a38f8fe8658$export$cd87ff8f4335648e = ()=>{
    const getExperimentValue = (0, $cXtTj.default).getExperimentValue;
    const variation = getExperimentValue('platform_editor_ai-prompts-placeholder', 'cohort', 'not-enrolled');
    if (variation !== 'control' && variation !== 'not-enrolled') {
        const label = getExperimentValue('platform_editor_ai-prompts-placeholder', 'label', '');
        const description = getExperimentValue('platform_editor_ai-prompts-placeholder', 'description', '');
        const intent = getExperimentValue('platform_editor_ai-prompts-placeholder', 'intent', '');
        const listOrder = getExperimentValue('platform_editor_ai-prompts-placeholder', 'list_order', 0);
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        // The follow are optional backwards compatible properties which can be configured in the experiment
        const showOnEmpty = getExperimentValue('platform_editor_ai-prompts-placeholder', 'show_on_empty_page', true);
        const statusType = getExperimentValue('platform_editor_ai-prompts-placeholder', 'prompt_status_type', '');
        if (label && description && intent && analyticsExperienceName) return {
            label: {
                id: label,
                description: label,
                defaultMessage: label
            },
            description: {
                id: description,
                description: description,
                defaultMessage: description
            },
            intent: intent,
            listOrder: listOrder,
            analyticsExperienceName: analyticsExperienceName,
            showOnEmpty: showOnEmpty,
            statusType: statusType
        };
    }
};


const $475ac549a376725c$export$6cd03141a939166d = ()=>{
    const configurations = (0, $5b3f9a38f8fe8658$export$cd87ff8f4335648e)();
    if (configurations) {
        const statusLozengeType = configurations.statusType.toLowerCase() === 'new' || configurations.statusType.toLowerCase() === 'beta' ? configurations.statusType.toLowerCase() : undefined;
        return {
            ...configurations,
            configItem: {
                key: (0, $2MofN.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER,
                title: configurations.label,
                description: configurations.description,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $308391080aec9cff$export$ced89349fedce38), null),
                statusLozengeType: statusLozengeType,
                intentSchemaId: configurations.intent,
                actions: {
                    empty: [
                        (0, $33Ze6.createInsertAtCurrentPosition)({
                            appearance: 'secondary'
                        }),
                        (0, $33Ze6.createInsertAtTop)({
                            appearance: 'primary'
                        })
                    ],
                    selection: [
                        (0, $33Ze6.createInsertBelow)({
                            appearance: 'secondary'
                        }),
                        (0, $33Ze6.createReplace)({
                            appearance: 'primary'
                        })
                    ]
                },
                getBackendModel: ()=>{
                    return 'assistance-service';
                }
            }
        };
    }
};
const $475ac549a376725c$export$d991dc90761ce2a0 = ()=>{
    const res = $475ac549a376725c$export$6cd03141a939166d();
    if (res) {
        const { configItem: configItem, ...others } = res;
        return {
            configItemWithOptions: {
                config: configItem,
                triggers: {
                    empty: {
                        enabled: true,
                        docMinSize: 1
                    },
                    selection: {
                        enabled: true
                    }
                }
            },
            ...others
        };
    }
};












var $2hwiA = parcelRequire("2hwiA");

const $3509da16250bd576$export$6eebfc33bd4f687b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hwiA))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });








const $ec29599520f1fdd8$export$acf0f0fea45f23f0 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FIND_ACTION_ITEMS,
        title: (0, $93WrI.aiConfigItemMessages).findActionItemsTitle,
        description: (0, $93WrI.aiConfigItemMessages).findActionItemsDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3509da16250bd576$export$6eebfc33bd4f687b), null),
        intentSchemaId: 'action_items_intent_schema.json',
        featureId: 'find_action_items',
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary',
                    factoryOptions: options
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $ec29599520f1fdd8$export$8edb35f92492e5cd = (options)=>({
        config: $ec29599520f1fdd8$export$acf0f0fea45f23f0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });






var $flbIU = parcelRequire("flbIU");




const $3b09d49da4bcd338$export$28052871323f977f = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
        // This is to avoid StateMachine `guard` check
        title: {
            id: 'free-generate-aifc-title',
            defaultMessage: 'Free Generate AIFC'
        },
        description: (0, $flbIU.default).aiUniversalLongCallToAction,
        promptHint: (0, $93WrI.aiConfigItemMessages).freeGeneratePromptHint,
        adfPrompt: true,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        actions: {},
        getBackendModel: ()=>'aifc-bridge'
    });



var $7vVCw = parcelRequire("7vVCw");


var $lQkyl = parcelRequire("lQkyl");


var $ddlQ3 = parcelRequire("ddlQ3");


var $iTW08 = parcelRequire("iTW08");


var $hXIpv = parcelRequire("hXIpv");


var $llvMC = parcelRequire("llvMC");


var $9pamm = parcelRequire("9pamm");


var $2aMCF = parcelRequire("2aMCF");


var $gcCwL = parcelRequire("gcCwL");

const $16f3b32138480c8a$export$fa98ce94fc01fa17 = {
    brainstormConfigItem: (0, $88f2ac45e0b8ca2a$export$683185be8e4be56f)(),
    freeGenerateAifcConfigItem: (0, $3b09d49da4bcd338$export$28052871323f977f)(),
    addPolishConfigItem: ()=>(0, $iTW08.addPolish)()
};
function $16f3b32138480c8a$var$getDynamicSurfaceConfigItems(opts) {
    const dynamicSurfaceConfigItems = [
        // Only brainstorm, suggest title and find action items are enabled for empty
        {
            config: (0, $iO5TS.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $iO5TS.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToEducational)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $ddlQ3.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $lQkyl.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $iTW08.addPolishWithOptions)(opts),
        // Convert to table and bullet list are already on enabled for selection
        (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
        (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
        (0, $ec29599520f1fdd8$export$8edb35f92492e5cd)(opts),
        (0, $hXIpv.suggestTitleForConfluenceTitleToolbarWithOptions)(opts),
        {
            config: (0, $llvMC.summarizeWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $9pamm.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    // Fix this const name after team 25 with platform_editor_ai_aifc_streaming being cleaned up
    const dynamicSurfaceConfigItemsTeam25 = [
        {
            config: (0, $iO5TS.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $iTW08.addPolishWithOptions)(opts),
        {
            config: (0, $iO5TS.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $dFWys.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $ddlQ3.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $lQkyl.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $9pamm.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    return opts.isInDocumentStreamingEnabled ? dynamicSurfaceConfigItemsTeam25 : dynamicSurfaceConfigItems;
}
const $16f3b32138480c8a$export$25814a113f71ded2 = (props)=>{
    const { editorView: editorView, configItem: configItem } = props;
    const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: 'triggerConfigItem',
        aiGlobalOptIn: {
            status: 'enabled',
            triggerOptInFlow: ()=>{}
        }
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
function $16f3b32138480c8a$export$15d114523124a386(options) {
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $dFWys.changeToneToProfessionalWithOptions)(opts),
            (0, $llvMC.summarizeWritingWithOptions)(opts),
            (0, $iO5TS.improveWritingWithOptions)(opts),
            (0, $iO5TS.fixSpellingAndGrammarWithOptions)(opts),
            (0, $ddlQ3.makeShorterWithOptions)(opts),
            (0, $lQkyl.makeLongerWithOptions)(opts),
            (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
            (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
            (0, $hXIpv.suggestTitleWithOptions)(opts),
            (0, $dFWys.changeToneToEmpatheticWithOptions)(opts),
            (0, $dFWys.changeToneToCasualWithOptions)(opts),
            (0, $dFWys.changeToneToEducationalWithOptions)(opts),
            ...(0, $9pamm.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $475ac549a376725c$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $ixfCV.fg)('platform_editor_ai_aifc_streaming');
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $7vVCw.freeGenerate)(),
        configItemWithOptions: getConfigItems({
            product: product,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
        }),
        disableAISelectionToolbar: true,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $gcCwL._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        /**
     * Below options are added to use rovo agent behind the scenes for free generate.
     *
     * Need to load rovo agents, so getChannelVariables and isRovoEnabled is set.
     * showRovoAgentsInCommandPalette will disable showing Rovo agents section.
     * useFreeGenerateEditorAgent will swap standard free generate prompt with
     * 	rovo agent enabled free generate after agents are loaded.
     * If loading agents fails, then fallback to standard free generate.
     */ getChannelVariables: options.getChannelVariables,
        isRovoEnabled: options.isRovoEnabled ?? true,
        showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? false,
        useFreeGenerateEditorAgent: options.useFreeGenerateEditorAgent ?? true,
        onSubmit: options.onSubmit,
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        enableQuickPrompt: options.enableQuickPrompt ?? false
    };
}
const $16f3b32138480c8a$export$b2747cd26144b27d = (options)=>{
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $dFWys.changeToneToProfessionalWithOptions)(opts),
            (0, $llvMC.summarizeWritingWithOptions)(opts),
            (0, $iO5TS.improveWritingWithOptions)(opts),
            (0, $iO5TS.fixSpellingAndGrammarWithOptions)(opts),
            (0, $ddlQ3.makeShorterWithOptions)(opts),
            (0, $lQkyl.makeLongerWithOptions)(opts),
            (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
            (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
            (0, $ec29599520f1fdd8$export$8edb35f92492e5cd)(opts),
            (0, $hXIpv.suggestTitleWithOptions)(opts),
            (0, $dFWys.changeToneToEmpatheticWithOptions)(opts),
            (0, $dFWys.changeToneToCasualWithOptions)(opts),
            (0, $dFWys.changeToneToEducationalWithOptions)(opts),
            (0, $iTW08.addPolishWithOptions)(opts),
            ...(0, $9pamm.translationConfigItemWithOptions)(opts)
        ];
        const newListOrder = [
            (0, $iO5TS.fixSpellingAndGrammarWithOptions)(opts),
            (0, $dFWys.changeToneToProfessionalWithOptions)(opts),
            (0, $ddlQ3.makeShorterWithOptions)(opts),
            (0, $llvMC.summarizeWritingWithOptions)(opts),
            (0, $iO5TS.improveWritingWithOptions)(opts),
            (0, $lQkyl.makeLongerWithOptions)(opts),
            (0, $6c2fd50787c1318b$export$37c986c539d0ca07)(opts),
            (0, $e180adc23351de79$export$d67616d0b45ccf63)(opts),
            (0, $ec29599520f1fdd8$export$8edb35f92492e5cd)(opts),
            (0, $hXIpv.suggestTitleWithOptions)(opts),
            (0, $dFWys.changeToneToEmpatheticWithOptions)(opts),
            (0, $dFWys.changeToneToCasualWithOptions)(opts),
            (0, $dFWys.changeToneToEducationalWithOptions)(opts),
            (0, $iTW08.addPolishWithOptions)(opts),
            ...(0, $9pamm.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $475ac549a376725c$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData && !opts.isInDocumentStreamingEnabled) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return opts.isInDocumentStreamingEnabled ? newListOrder : list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $ixfCV.fg)('platform_editor_ai_aifc_streaming');
    const configItemOptions = {
        product: product,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $7vVCw.freeGenerate)(configItemOptions),
        configItemWithOptions: getConfigItems(configItemOptions),
        getSelectionToolbarDropdowns () {
            const selectionToolbarOptions = [
                {
                    id: 'change-tone',
                    label: (0, $7ZL6d.aiMessages).confluenceChangeToneSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneProfessionalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToProfessional)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneEmpatheticToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToEmpathetic)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneCasualToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToCasual)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneNeutralToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToNeutral)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).changeToneEducationalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $dFWys.changeToneToEducational)(configItemOptions)
                        }
                    ]
                },
                {
                    id: 'rewrite',
                    label: (0, $7ZL6d.aiMessages).confluenceRewriteSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $93WrI.aiConfigItemMessages).improveWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iO5TS.improveWriting)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).fixSpellingGrammarSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iO5TS.fixSpellingAndGrammar)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).summarizeWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $llvMC.summarizeWriting)(configItemOptions)
                        },
                        {
                            label: (0, $93WrI.aiConfigItemMessages).makeShorterSelectionToolbarDropdownItemTitle,
                            configItem: (0, $ddlQ3.makeShorter)(configItemOptions)
                        }
                    ]
                }
            ];
            const translationConfigItemsMap = (0, $9pamm.createTranslationConfigItems)(configItemOptions);
            const translateOptions = (0, $2aMCF.getSortedSupportedTranslationLanguages)().map((language)=>{
                const label = (0, $2urSQ.aiLanguageMessages)[language];
                return {
                    label: label,
                    configItem: translationConfigItemsMap[language]
                };
            });
            selectionToolbarOptions.push({
                id: 'translate',
                label: (0, $7ZL6d.aiMessages).confluenceTranslateSelectionToolbarDropdownMenuTitle,
                options: translateOptions
            });
            return selectionToolbarOptions;
        },
        disableAISelectionToolbar: false,
        hidePrimaryToolbarButton: isInDocumentStreamingEnabled ? false : options.hidePrimaryToolbarButton,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $gcCwL._getFetchCustomHeaders),
        getChannelVariables: options.getChannelVariables,
        onDocChangeByAgent: options.onDocChangeByAgent,
        onAIProviderChanged: options.onAIProviderChanged,
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        aiUsageDisclaimer: options.aiUsageDisclaimer,
        isRovoEnabled: options.isRovoEnabled ?? true,
        /**
     * Below options are added because;
     * - Show rovo agents in command palette.
     */ showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? true,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        aiSmartButtonOptions: options.aiSmartButtonOptions,
        heroConfigItem: isInDocumentStreamingEnabled ? (0, $iO5TS.improveWritingWithOptions)(configItemOptions) : undefined,
        ...options.aiGlobalOptIn.status === 'enabled' && (0, $ixfCV.fg)('ai-smart-button-team-25') && {
            dynamicSurfaceConfigItems: $16f3b32138480c8a$var$getDynamicSurfaceConfigItems(configItemOptions)
        },
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        onSubmit: options.onSubmit,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        enableQuickPrompt: options.enableQuickPrompt ?? true,
        creationContextParams: options.creationContextParams
    };
};
const $16f3b32138480c8a$export$679d027153aa30cf = (editorApi)=>{
    const onActionClick = (configItem)=>{
        return ()=>{
            editorApi.aiExperience?.actions.openAIModal({
                invokedFrom: 'objectSidebar',
                configItem: configItem
            });
        };
    };
    const configItemOptions = {
        product: 'CONFLUENCE',
        isInDocumentStreamingEnabled: (0, $ixfCV.fg)('platform_editor_ai_aifc_streaming')
    };
    const changeToneActionItems = [
        {
            title: (0, $7ZL6d.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($p6OqS))),
            onClick: onActionClick((0, $dFWys.changeToneToProfessional)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).moreCasualToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Jphz))),
            onClick: onActionClick((0, $dFWys.changeToneToCasual)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4WfQc))),
            onClick: onActionClick((0, $dFWys.changeToneToEmpathetic)(configItemOptions))
        }
    ];
    const adjustLengthActionItems = [
        {
            title: (0, $7ZL6d.aiMessages).makeShorterToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3CdTA))),
            onClick: onActionClick((0, $ddlQ3.makeShorter)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).makeLongerToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2xJ2w))),
            onClick: onActionClick((0, $lQkyl.makeLonger)(configItemOptions))
        }
    ];
    const objectSideBarButtons = [
        {
            title: (0, $7ZL6d.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($74BSk))),
            onClick: onActionClick((0, $iO5TS.fixSpellingAndGrammar)(configItemOptions))
        },
        {
            title: (0, $7ZL6d.aiMessages).changeToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))),
            subItems: changeToneActionItems
        },
        {
            title: (0, $7ZL6d.aiMessages).adjustLengthToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ggncV))),
            subItems: adjustLengthActionItems
        },
        {
            title: (0, $93WrI.aiConfigItemMessages).improveFormattingTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
            onClick: onActionClick((0, $iTW08.addPolish)(configItemOptions))
        }
    ];
    return objectSideBarButtons;
};
module.exports["UNSTABLE_configItems"] = $16f3b32138480c8a$export$fa98ce94fc01fa17;
module.exports["UNSTABLE_DO_NOT_USE_ONLY_FOR_CONFLUENCE_triggerConfigItem"] = $16f3b32138480c8a$export$25814a113f71ded2;
module.exports["createPageCommentEditorPluginAIOptions"] = $16f3b32138480c8a$export$15d114523124a386;
module.exports["createPageEditorPluginAIOptions"] = $16f3b32138480c8a$export$b2747cd26144b27d;
module.exports["getEditorActionsForObjectSidebar"] = $16f3b32138480c8a$export$679d027153aa30cf;

});

parcelRegister("5JZoZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $ixfCV = parcelRequire("ixfCV");




const $e85d9b72d1bb97d7$export$e9c2274564cfd3df = (diffType)=>(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) || diffType === 'smart' && (0, $ixfCV.fg)('platform_editor_ai_smart_diff');


const $c8506ce9a0d29c95$export$ce4c822284447bb4 = {
    diff: 'diff',
    anchor: 'anchor'
};
const $c8506ce9a0d29c95$export$fa63aa0289bee17d = {
    from: 'from',
    to: 'to',
    left: 'left',
    docMargin: 'doc-margin'
};
const $c8506ce9a0d29c95$export$821fbb25e40fbb48 = {
    inline: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.diff}-inline`,
    block: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.diff}-block`,
    widget: `${$c8506ce9a0d29c95$export$ce4c822284447bb4.diff}-widget`
};
const $c8506ce9a0d29c95$export$bc2e1517d52e2060 = `${$c8506ce9a0d29c95$export$ce4c822284447bb4.anchor}-${$c8506ce9a0d29c95$export$fa63aa0289bee17d.docMargin}`;
const $c8506ce9a0d29c95$export$c580b39c28f817bd = ({ diffId: diffId, anchorType: anchorType })=>{
    return `${$c8506ce9a0d29c95$export$ce4c822284447bb4.anchor}-${diffId}${anchorType ? `-${anchorType}` : ''}`;
};
const $c8506ce9a0d29c95$export$e95973fb6fa1595f = ({ decorationKeyPrefix: decorationKeyPrefix, isActive: isActive, diffId: diffId, diffType: diffType })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return `${decorationKeyPrefix}-${diffId}-${isActive ? 'active' : 'inactive'}`;
    return isActive !== undefined ? `${decorationKeyPrefix}-${isActive ? 'active' : 'inactive'}` : decorationKeyPrefix;
};
const $c8506ce9a0d29c95$export$b63856cff30de075 = ({ decorationType: decorationType, diffId: diffId, isActive: isActive, nodeName: nodeName, side: side, diffType: diffType })=>({
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.diff,
        decorationType: decorationType,
        diffId: diffId,
        key: $c8506ce9a0d29c95$export$e95973fb6fa1595f({
            decorationKeyPrefix: $c8506ce9a0d29c95$export$821fbb25e40fbb48[decorationType],
            diffId: diffId,
            isActive: isActive,
            diffType: diffType
        }),
        ...nodeName ? {
            nodeName: nodeName
        } : {},
        ...side !== undefined ? {
            side: side
        } : {}
    });
function $c8506ce9a0d29c95$export$bfa07d0d50bcdd89({ anchorType: anchorType, diffId: diffId, side: side }) {
    if (anchorType === $c8506ce9a0d29c95$export$fa63aa0289bee17d.docMargin) return {
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.anchor,
        anchorType: anchorType,
        key: $c8506ce9a0d29c95$export$bc2e1517d52e2060,
        ...side !== undefined ? {
            side: side
        } : {}
    };
    if (!diffId) throw new Error(`diffId is required for anchor type "${anchorType}"`);
    return {
        decorationFamily: $c8506ce9a0d29c95$export$ce4c822284447bb4.anchor,
        anchorType: anchorType,
        diffId: diffId,
        key: $c8506ce9a0d29c95$export$c580b39c28f817bd({
            diffId: diffId,
            anchorType: anchorType
        }),
        ...side !== undefined ? {
            side: side
        } : {}
    };
}
const $c8506ce9a0d29c95$export$f24673b80d65051c = (spec)=>Boolean(spec && typeof spec === 'object' && 'decorationFamily' in spec && spec.decorationFamily === $c8506ce9a0d29c95$export$ce4c822284447bb4.diff);
const $c8506ce9a0d29c95$export$daed4283846b64e6 = (spec)=>Boolean(spec && typeof spec === 'object' && 'decorationFamily' in spec && spec.decorationFamily === $c8506ce9a0d29c95$export$ce4c822284447bb4.anchor);
const $c8506ce9a0d29c95$export$c9bc510aa0f85e34 = (decoration)=>$c8506ce9a0d29c95$export$f24673b80d65051c(decoration.spec);
const $c8506ce9a0d29c95$export$f6b1e5edab6db0b1 = (decorations)=>decorations.find(undefined, undefined, $c8506ce9a0d29c95$export$f24673b80d65051c).filter($c8506ce9a0d29c95$export$c9bc510aa0f85e34).map(({ spec: spec })=>{
        return {
            id: spec.diffId,
            type: spec.decorationType
        };
    });



/**
 * True if `fragment` contains at least one inline node (text, hardBreak, emoji, mention, etc.).
 * Block-only subtrees (e.g. empty paragraphs, block cards with no inline children) return false.
 */ function $8dbcf03441d7dc2f$var$fragmentContainsInlineContent(fragment) {
    for(let i = 0; i < fragment.childCount; i++){
        const node = fragment.child(i);
        if (node.isInline) return true;
        if (node.content.size > 0 && $8dbcf03441d7dc2f$var$fragmentContainsInlineContent(node.content)) return true;
    }
    return false;
}
function $8dbcf03441d7dc2f$export$1176e62203433107(doc, from, to) {
    try {
        const slice = doc.slice(from, to);
        return $8dbcf03441d7dc2f$var$fragmentContainsInlineContent(slice.content);
    } catch  {
        return false;
    }
}
/**
 * Checks if range1 is fully contained within range2
 */ function $8dbcf03441d7dc2f$var$isRangeFullyInside(range1Start, range1End, range2Start, range2End) {
    return range2Start <= range1Start && range1End <= range2End;
}
function $8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, keyPrefix) {
    return Boolean(spec && typeof spec === 'object' && 'key' in spec && typeof spec.key === 'string' && spec.key.startsWith(keyPrefix));
}
const $8dbcf03441d7dc2f$export$c459ab16dd3c3d79 = (set, doc, diffType)=>{
    if (!set) return [];
    const isBlockDecoration = (decoration)=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'block' : decoration.spec?.key?.startsWith((0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).block) ?? false;
    const isInlineDecoration = (decoration)=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'inline' : decoration.spec?.key?.startsWith((0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).inline) ?? false;
    const isWidgetDecoration = (decoration)=>(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? (0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'widget' : decoration.spec?.key?.startsWith((0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).widget) ?? false;
    const seenBlockKeys = new Set();
    const allDecorations = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? set.find(undefined, undefined, (0, $c8506ce9a0d29c95$export$f24673b80d65051c)) : set.find(undefined, undefined, (spec)=>$8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, (0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).inline) || $8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, (0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).widget) || $8dbcf03441d7dc2f$var$specHasDiffKeyPrefix(spec, (0, $c8506ce9a0d29c95$export$821fbb25e40fbb48).block));
    // First pass: filter out listItem blocks and deduplicates blocks
    const filtered = allDecorations.filter((dec)=>{
        if (!isBlockDecoration(dec) && !isInlineDecoration(dec) && !isWidgetDecoration(dec)) return false;
        if (isBlockDecoration(dec)) {
            // Skip listItem blocks as they are not scrollable
            if (dec.spec?.nodeName === 'listItem') return false;
            const key = `${dec.from}-${dec.to}-${dec.spec.nodeName ?? ''}`;
            // Skip blocks that have already been seen
            if (seenBlockKeys.has(key)) return false;
            seenBlockKeys.add(key);
        }
        return true;
    });
    // Separate decorations by type for easier processing
    const blocks = filtered.filter(isBlockDecoration);
    const rawInlines = filtered.filter(isInlineDecoration);
    const inlines = doc !== undefined ? rawInlines.filter((d)=>$8dbcf03441d7dc2f$export$1176e62203433107(doc, d.from, d.to)) : rawInlines;
    const widgets = filtered.filter(isWidgetDecoration);
    // Second pass: exclude overlapping decorations
    // Rules:
    // - If an inline is fully inside a block, exclude the block (inline takes priority)
    // - If a block is fully inside an inline, exclude the block (inline takes priority)
    const nonOverlappingBlocks = blocks.filter((block)=>{
        // Exclude block if:
        // 1. It's fully contained within any inline, OR
        // 2. It fully contains any inline
        return !inlines.some((inline)=>$8dbcf03441d7dc2f$var$isRangeFullyInside(block.from, block.to, inline.from, inline.to) || // block inside inline
            $8dbcf03441d7dc2f$var$isRangeFullyInside(inline.from, inline.to, block.from, block.to));
    });
    // Combine all non-overlapping decorations
    const result = [
        ...nonOverlappingBlocks,
        ...inlines,
        ...widgets
    ];
    // Sort by from position, then by to position
    result.sort((a, b)=>a.from === b.from ? a.to - b.to : a.from - b.from);
    return result;
};



var $5Qi6J = parcelRequire("5Qi6J");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $5aU9U = parcelRequire("5aU9U");


var $8nvEM = parcelRequire("8nvEM");

// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $3u5lg = parcelRequire("3u5lg");


var $dOBRD = parcelRequire("dOBRD");


var $dFI5z = parcelRequire("dFI5z");


var $6SJ6d = parcelRequire("6SJ6d");











var $eOaGc = parcelRequire("eOaGc");

/**
 * Returns a copy of the document with all marks removed from all text.
 * This normalises mark fragmentation — e.g. annotation marks reordering can split
 * a single text run into many text nodes, making structural comparison unreliable.
 * After stripping, ProseMirror will merge adjacent text nodes so childCounts are stable.
 */ function $6abaa709e6c99f63$var$stripMarks(doc) {
    const tr = new (0, $eOaGc.Transform)(doc);
    tr.removeMark(0, doc.content.size);
    return tr.doc;
}
/**
 * Returns true if both (mark-stripped) nodes have the same block tree structure (node type and child count at every level)
 */ function $6abaa709e6c99f63$var$isBlockStructureEqual(node1, node2) {
    if (node1.type !== node2.type || node1.childCount !== node2.childCount) return false;
    for(let i = 0; i < node1.childCount; i++){
        if (!$6abaa709e6c99f63$var$isBlockStructureEqual(node1.child(i), node2.child(i))) return false;
    }
    return true;
}
function $6abaa709e6c99f63$export$2b9c81e9e2c68dae(doc1, doc2) {
    if (doc1.textContent !== doc2.textContent) return false;
    // Strip marks before comparing so that mark-driven text fragmentation
    // (e.g. annotation mark reordering producing different childCounts) does not
    // cause false inequalities.
    const stripped1 = $6abaa709e6c99f63$var$stripMarks(doc1);
    const stripped2 = $6abaa709e6c99f63$var$stripMarks(doc2);
    return doc1.nodeSize === doc2.nodeSize && $6abaa709e6c99f63$var$isBlockStructureEqual(stripped1, stripped2);
}



var $bjg0G = parcelRequire("bjg0G");





/**
 * Resolves the doc-level block node (table/expand/layout) for `from`, along with
 * the position right before it (`beforePos`). Falls back to `$from.nodeAfter`
 * when there is no depth-1 ancestor (e.g. `from` sits just before the block).
 */ const $b6432cc061a6f6cb$var$resolveDocLevelNode = (doc, from)=>{
    const $from = doc.resolve(from);
    const node = $from.node(1) ?? $from.nodeAfter;
    if (!node) return undefined;
    // Content start of the block. For the depth-1 case this is `$from.start(1)`;
    // for the `nodeAfter` fallback, `from` is the position just before the block
    // node, so its content starts at `from + 1`.
    const nodeStart = $from.node(1) ? $from.start(1) : from + 1;
    return {
        node: node,
        nodeStart: nodeStart,
        // Position of the block node itself (one before its content start).
        beforePos: nodeStart - 1
    };
};
/**
 * Handles edge cases for block nodes whose inline content can exceed the doc
 * margin (tables, layouts, expands). Returns the position whose DOM should be
 * measured to size the left anchor, or `undefined` when the diff is not inside
 * such a node.
 */ const $b6432cc061a6f6cb$var$edgeCases = (doc, from)=>{
    const resolved = $b6432cc061a6f6cb$var$resolveDocLevelNode(doc, from);
    if (!resolved) return undefined;
    const { node: node, nodeStart: nodeStart, beforePos: beforePos } = resolved;
    /**
	 * All resizable nodes will need dynamic calculations of the block indicator left anchor
	 */ if (node.marks.some((mark)=>mark.type.name === 'breakout')) /**
		 * Layouts and Expands have extra padding around the container
		 */ return {
        measurePos: beforePos
    };
    switch(node.type.name){
        /**
		 * For resizable blocks, inline content can exceed the doc margin.
		 * The widget is placed before the block; the anchor is sized against the
		 * block's DOM so it doesn't get clipped when the block is resized :')
		 */ case 'table':
            // A table with no rows has nothing to measure.
            if (!node.firstChild) return undefined;
            // Measure the first row (`nodeStart` is just inside the table, i.e. the
            // position of the first row): its width matches the table's.
            return {
                measurePos: nodeStart
            };
        case 'layoutSection':
        case 'expand':
            // Measure the block itself (the widget is rendered outside the block).
            return {
                leftOffset: 12
            };
        default:
            return undefined;
    }
};
const $b6432cc061a6f6cb$export$e9accf2864a96b18 = ()=>{
    return (0, $8nvEM.Decoration).widget(0, ()=>{
        const span = document.createElement('span');
        span.style.setProperty('anchor-name', `--${(0, $c8506ce9a0d29c95$export$bc2e1517d52e2060)}`);
        return span;
    }, // set the side to -999 so that it is always rendered before any other anchors
    (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).docMargin,
        side: -999
    }));
};
const $b6432cc061a6f6cb$export$bb60b01773a85c0d = ({ doc: doc, from: from, diffId: diffId })=>{
    const edgeCase = $b6432cc061a6f6cb$var$edgeCases(doc, from);
    if (edgeCase === undefined) return undefined;
    // Render the widget right before the doc-level node so it lives outside the
    // resizable block container.
    const resolved = $b6432cc061a6f6cb$var$resolveDocLevelNode(doc, from);
    if (!resolved) return undefined;
    const { beforePos: beforePos } = resolved;
    const leftAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
    });
    return (0, $8nvEM.Decoration).widget(beforePos, (view, getPos)=>{
        // Outer span stays in the flow but takes up no space.
        const wrapper = document.createElement('div');
        wrapper.style.setProperty('position', 'relative');
        wrapper.style.setProperty('width', '100%');
        // Inner span is absolutely positioned in the doc margin; it carries the
        // `anchor-name` the IndicatorBar aligns its left edge against.
        const anchor = document.createElement('div');
        anchor.style.setProperty('anchor-name', `--${leftAnchorKey}`);
        anchor.style.setProperty('position', 'absolute');
        anchor.style.setProperty('left', `calc(50% - ${edgeCase?.leftOffset || 0}px)`);
        anchor.style.setProperty('transform', 'translateX(-50%)');
        wrapper.appendChild(anchor);
        // The block DOM may not be settled synchronously (e.g. after a
        // transaction), so defer the measurement like the gap cursor does.
        requestAnimationFrame(()=>{
            // The widget may have been unmounted; bail if its position is gone.
            // We still measure the stable block node position, not the widget's
            // own position.
            if (getPos() === undefined || edgeCase.measurePos === undefined) return;
            const dom = view.nodeDOM(edgeCase.measurePos);
            if (dom instanceof HTMLElement) // The left anchor only needs the container width so the
            // IndicatorBar can align against the block's horizontal extent.
            anchor.style.setProperty('width', `${dom.offsetWidth}px`);
        });
        return wrapper;
    }, (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left,
        side: -999
    }));
};
const $b6432cc061a6f6cb$var$isFullNodeRange = (doc, from, to)=>{
    let matchesFullNodeRange = false;
    doc.nodesBetween(from, to, (node, pos)=>{
        if (pos === from && pos + node.nodeSize === to) {
            matchesFullNodeRange = true;
            return false;
        }
        return true;
    });
    return matchesFullNodeRange;
};
const $b6432cc061a6f6cb$export$34d0779dfc2e9aea = ({ doc: doc, from: from, to: to, diffId: diffId })=>{
    const leftAnchor = $b6432cc061a6f6cb$export$bb60b01773a85c0d({
        doc: doc,
        from: from,
        diffId: diffId
    });
    const maybeLeftAnchor = leftAnchor ? [
        leftAnchor
    ] : [];
    /**
	 * A single anchor widget spans the full height of the block node, mimicking
	 * the gap cursor placement logic (see `place-gap-cursor.ts`): an element
	 * whose height is measured from the block's DOM so its box covers the block.
	 *
	 * Because the anchor rect covers the whole block, the `IndicatorBar` can
	 * resolve `top`, `bottom` and `left` against this one anchor (keyed by
	 * `diffId` with no `anchorType`) instead of separate `from`/`to` anchors.
	 */ const blockAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId
    });
    /**
	 * If `from` lands inside a table cell/header or a table row, the widget must
	 * still be rendered *outside* the table (widgets placed inside a table are
	 * clipped/mis-laid-out), but we want the anchor to be sized against the
	 * actual cell/row DOM. So we split into two positions:
	 * - `widgetPos`: where the widget DOM is rendered (outside the table).
	 * - `measurePos`: the closest cell/row whose DOM we measure for the height.
	 */ const $from = doc.resolve(from);
    const parentTable = (0, $bjg0G.findParentNodeClosestToPos)($from, (ancestor)=>ancestor.type.name === 'table');
    const parentCellOrRow = (0, $bjg0G.findParentNodeClosestToPos)($from, (ancestor)=>[
            'tableCell',
            'tableHeader',
            'tableRow'
        ].includes(ancestor.type.name));
    // Render outside the table when inside one; otherwise keep the original pos.
    const widgetPos = parentTable ? parentTable.pos : from;
    // Measure the actual cell/row DOM when inside one; otherwise measure the
    // widget's own position.
    const measurePos = parentCellOrRow ? parentCellOrRow.pos : from;
    const blockWidget = (0, $8nvEM.Decoration).widget(widgetPos, (view, getPos)=>{
        // Outer span stays in the flow but takes up no space.
        const wrapper = document.createElement('span');
        wrapper.style.setProperty('position', 'relative');
        // Inner span is absolutely positioned and sized to the block height;
        // it carries the `anchor-name` the IndicatorBar aligns against.
        const anchor = document.createElement('span');
        anchor.style.setProperty('position', 'absolute');
        anchor.style.setProperty('anchor-name', `--${blockAnchorKey}`);
        wrapper.appendChild(anchor);
        // The block DOM may not be settled synchronously (e.g. after a
        // transaction), so defer the measurement like the gap cursor does.
        requestAnimationFrame(()=>{
            // The widget may have been unmounted; bail if its position is gone.
            // We still measure the stable cell/row node position, not the
            // widget's own position.
            if (getPos() === undefined) return;
            const dom = view.nodeDOM(measurePos);
            if (dom instanceof HTMLElement) {
                anchor.style.setProperty('height', `${dom.offsetHeight}px`);
                // The wrapper renders outside the table, so there is a vertical
                // gap between it and the cell/row we're anchoring to. Measure
                // that delta and offset the (absolutely positioned) anchor by it
                // so its box lines up with the cell/row.
                const wrapperTop = wrapper.getBoundingClientRect().top;
                const domTop = dom.getBoundingClientRect().top;
                const verticalOffset = domTop - wrapperTop;
                anchor.style.setProperty('top', `${verticalOffset}px`);
                // The offset already accounts for the cell/row's position, so the
                // margin-top must not be double-applied.
                anchor.style.setProperty('margin-top', '0px');
            }
        });
        return wrapper;
    }, (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        // Reuse the `from` anchor type slot; the generated key intentionally
        // omits the anchor type so the single element backs top/bottom/left.
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from,
        side: -1
    }));
    return [
        blockWidget,
        ...maybeLeftAnchor
    ];
};
const $b6432cc061a6f6cb$export$dc213f6c0d801266 = ({ doc: doc, from: from, to: to, diffId: diffId })=>{
    if ($b6432cc061a6f6cb$var$isFullNodeRange(doc, from, to)) return [];
    const leftAnchor = $b6432cc061a6f6cb$export$bb60b01773a85c0d({
        doc: doc,
        from: from,
        diffId: diffId
    });
    const maybeLeftAnchor = leftAnchor ? [
        leftAnchor
    ] : [];
    /**
	 * Two widgets mark the start and end of the inline range so the
	 * IndicatorBar can determine top/bottom even if
	 * the inline decoration is broken up by marks / between blocks.
	 */ const fromAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from
    });
    const fromWidget = (0, $8nvEM.Decoration).widget(from, ()=>{
        const span = document.createElement('span');
        span.style.setProperty('anchor-name', `--${fromAnchorKey}`);
        return span;
    }, (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from,
        side: 1
    }));
    const toAnchorKey = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to
    });
    const toWidget = (0, $8nvEM.Decoration).widget(to, ()=>{
        const span = document.createElement('span');
        span.style.setProperty('anchor-name', `--${toAnchorKey}`);
        return span;
    }, (0, $c8506ce9a0d29c95$export$bfa07d0d50bcdd89)({
        diffId: diffId,
        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to,
        side: -1
    }));
    return [
        fromWidget,
        toWidget,
        ...maybeLeftAnchor
    ];
};



var $8Dx7s = parcelRequire("8Dx7s");








const $b4335631fdf63f73$export$8382eabaf43593de = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $b4335631fdf63f73$export$bab085854a7b47c = (0, $8Dx7s.convertToInlineCss)({
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $b4335631fdf63f73$export$97e4289fb0e21ca7 = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-purple, #803FA5)"
});
const $b4335631fdf63f73$export$6cbccbf53a6b2a8 = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$21401c524509064e = (0, $8Dx7s.convertToInlineCss)({
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$6edd58aab948260b = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$f65e7b80cdbdaf11 = (0, $8Dx7s.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.6
});
const $b4335631fdf63f73$export$1c9944aa8f37265b = (0, $8Dx7s.convertToInlineCss)({
    color: "var(--ds-text, #292A2E)",
    textDecoration: 'line-through',
    textDecorationColor: "var(--ds-text-accent-gray, #505258)",
    position: 'relative',
    opacity: 1
});
const $b4335631fdf63f73$export$da356444d868ff8e = (0, $8Dx7s.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.83
});
const $b4335631fdf63f73$export$19cf8e2cf40a1110 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    borderBottom: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    padding: `1px 0 2px`
});
const $b4335631fdf63f73$export$f9aac5ed53f3d424 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-text-accent-gray, #505258)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $b4335631fdf63f73$export$4be2f4158e5479e9 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`
});
const $b4335631fdf63f73$export$a26de8170ba89016 = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$b1c2428901df334f = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$2b892754935ecdf0 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$f2cea9f09f40fb64 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$95d973a7458c1194 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $b4335631fdf63f73$export$1e0b247f41c702d9 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $b4335631fdf63f73$export$ba3acd64357126ab = (0, $8Dx7s.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $b4335631fdf63f73$export$61432713bede9dea = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`
});
const $b4335631fdf63f73$export$69c3a1c4f451af4e = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $b4335631fdf63f73$export$6ba987e1eae93022 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b4335631fdf63f73$export$7643378707ce1e7 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $b4335631fdf63f73$export$5675345213f1a131 = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-purple, #AF59E1)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $b4335631fdf63f73$export$56ba023604266b1a = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-gray, #7D818A)",
    '--diff-decoration-marker-ring-width': '1px',
    opacity: 0.8
});
const $b4335631fdf63f73$export$d311b2309a26b4fb = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    pointerEvents: 'none'
});
const $b4335631fdf63f73$export$7000268b4d4c5e1 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    pointerEvents: 'none'
});





const $e7971598d3f97abe$export$5f26b1217ef25d6b = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-green, #22A06B)"
});
const $e7971598d3f97abe$export$a9b71bdebdda9dc4 = (0, $8Dx7s.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-green, #216E4E)"
});
const $e7971598d3f97abe$var$deletedTraditionalInlineStyleBase = {
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 1
};
const $e7971598d3f97abe$var$deletedTraditionalInlineStyleActiveBase = {
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleBase,
    textDecorationThickness: '2px',
    backgroundColor: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)"
};
function $e7971598d3f97abe$export$f37b168a762b249f(isActive) {
    return isActive ? (0, $8Dx7s.convertToInlineCss)($e7971598d3f97abe$var$deletedTraditionalInlineStyleActiveBase) : (0, $8Dx7s.convertToInlineCss)($e7971598d3f97abe$var$deletedTraditionalInlineStyleBase);
}
const $e7971598d3f97abe$export$d7c13cc5c70ee199 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $e7971598d3f97abe$export$e384205f8cc82cfe = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `2px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $e7971598d3f97abe$export$781ad9e3e3929b91 = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$cd5411bbe62ac5f5 = (0, $8Dx7s.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$2881f0731c48e52 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$bb158c719faea3c7 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$4d45bc5137e495cf = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $e7971598d3f97abe$export$9c9f71734a3c1e70 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $e7971598d3f97abe$export$94cf9011b730dea = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$bd7e21e639c80e8d = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $e7971598d3f97abe$export$62207903895cae1 = (0, $8Dx7s.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $e7971598d3f97abe$export$2baa37676a9f2541 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-green, #22A06B)"}`
});
const $e7971598d3f97abe$export$94c7715dcf202eb7 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `4px solid ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`
});
const $e7971598d3f97abe$export$f0d2b829bf102560 = (0, $8Dx7s.convertToInlineCss)({
    borderLeft: `4px solid ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`
});
const $e7971598d3f97abe$export$83df991322f77466 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-green, #22A06B)"
});
const $e7971598d3f97abe$export$987d21925631f1e0 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    border: 'none',
    height: '4px',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$27f4e50fea498762 = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    border: 'none',
    height: '4px',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$d4e3bc1287ea5f02 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$2e643fe7923d8094 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$a60bf2c814acef8e = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $e7971598d3f97abe$export$4352b2b7d464e82a = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e7971598d3f97abe$export$b5d15ab6b9f40699 = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e7971598d3f97abe$export$cf5a738872f070ca = (0, $8Dx7s.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $e7971598d3f97abe$export$90be779ecd934b0a = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-green, #22A06B)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $e7971598d3f97abe$export$25ad6f21613cdcf1 = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$4752b9cd0a02e8d3 = (0, $8Dx7s.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$e3ce52bf0fe385a = (0, $8Dx7s.convertToInlineCss)({
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleBase,
    '--diff-decoration-marker-color': "var(--ds-border-accent-red, #E2483D)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $e7971598d3f97abe$export$1c68397531783614 = (0, $8Dx7s.convertToInlineCss)({
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleBase,
    '--diff-decoration-marker-color': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$2e6c07fb91e6b5f7 = (0, $8Dx7s.convertToInlineCss)({
    ...$e7971598d3f97abe$var$deletedTraditionalInlineStyleActiveBase,
    '--diff-decoration-marker-color': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $e7971598d3f97abe$export$d2957495f69575c = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-green, #22A06B)"}`,
    pointerEvents: 'none'
});
const $e7971598d3f97abe$export$4447a7c482f80938 = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    pointerEvents: 'none'
});
const $e7971598d3f97abe$export$ea323b9930a7947d = (0, $8Dx7s.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-disabled, #0515240F)"}`,
    pointerEvents: 'none'
});




const $272524b39064824e$var$displayNoneStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'none'
});
const $272524b39064824e$var$getNodeClass = (name)=>{
    switch(name){
        case 'extension':
            return 'show-diff-changed-decoration-node';
        default:
            return undefined;
    }
};
const $272524b39064824e$var$getBlockNodeStyle = ({ nodeName: nodeName, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false, diffType: diffType })=>{
    const isTraditional = colorScheme === 'traditional';
    if ([
        'mediaSingle',
        'mediaGroup',
        'table',
        // Handle table separately to avoid border issues
        'tableRow',
        'paragraph',
        // Paragraph and heading nodes do not need special styling
        'heading',
        'hardBreak',
        'decisionList',
        'taskList',
        'bulletList',
        'orderedList',
        'layoutSection'
    ].includes(nodeName)) // Layout nodes do not need special styling
    return undefined;
    // Media nodes inside mediaSingle should not get position:relative
    // as it shifts the image outside its parent container (e.g. panel)
    if (nodeName === 'media') {
        if (!isInserted && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$56ba023604266b1a);
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
    }
    if ([
        'tableCell',
        'tableHeader'
    ].includes(nodeName)) {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) // This is used for positioning the cell overlay widget decorations
        return (0, $8Dx7s.convertToInlineCss)({
            position: 'relative'
        });
        // When gate is off, it should return undefined as above
        return undefined;
    }
    if (nodeName === 'panel') {
        if (!isInserted && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$56ba023604266b1a);
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
    }
    if ([
        'extension',
        'embedCard',
        'listItem'
    ].includes(nodeName)) {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional && isActive ? (0, $e7971598d3f97abe$export$4752b9cd0a02e8d3) : isTraditional ? (0, $e7971598d3f97abe$export$25ad6f21613cdcf1) : (0, $b4335631fdf63f73$export$5675345213f1a131);
            else {
                if (nodeName === 'listItem') return isTraditional && isActive ? (0, $e7971598d3f97abe$export$2e6c07fb91e6b5f7) : isTraditional ? (0, $e7971598d3f97abe$export$1c68397531783614) : (0, $b4335631fdf63f73$export$56ba023604266b1a);
                return isTraditional && isActive ? (0, $e7971598d3f97abe$export$2e6c07fb91e6b5f7) : isTraditional ? (0, $e7971598d3f97abe$export$1c68397531783614) : (0, $b4335631fdf63f73$export$da356444d868ff8e);
            }
        }
        return isTraditional && isActive ? (0, $e7971598d3f97abe$export$4752b9cd0a02e8d3) : isTraditional ? (0, $e7971598d3f97abe$export$25ad6f21613cdcf1) : (0, $b4335631fdf63f73$export$5675345213f1a131);
    }
    if (nodeName === 'blockquote') {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$f0d2b829bf102560) : (0, $e7971598d3f97abe$export$94c7715dcf202eb7) : (0, $b4335631fdf63f73$export$61432713bede9dea);
            else return isTraditional ? (0, $e7971598d3f97abe$export$781ad9e3e3929b91) : (0, $b4335631fdf63f73$export$4be2f4158e5479e9);
        }
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$f0d2b829bf102560) : (0, $e7971598d3f97abe$export$94c7715dcf202eb7) : (0, $b4335631fdf63f73$export$61432713bede9dea);
    }
    if (nodeName === 'rule') {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$27f4e50fea498762) : (0, $e7971598d3f97abe$export$987d21925631f1e0) : (0, $b4335631fdf63f73$export$69c3a1c4f451af4e);
            else return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$da356444d868ff8e);
        }
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$27f4e50fea498762) : (0, $e7971598d3f97abe$export$987d21925631f1e0) : (0, $b4335631fdf63f73$export$69c3a1c4f451af4e);
    }
    if (nodeName === 'blockCard') {
        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
            if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$cf5a738872f070ca) : (0, $e7971598d3f97abe$export$b5d15ab6b9f40699) : (0, $b4335631fdf63f73$export$7643378707ce1e7);
            else return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$da356444d868ff8e);
        }
        return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$cf5a738872f070ca) : (0, $e7971598d3f97abe$export$b5d15ab6b9f40699) : (0, $b4335631fdf63f73$export$7643378707ce1e7);
    }
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (isInserted) return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
        else return isTraditional ? (0, $e7971598d3f97abe$export$f37b168a762b249f)(false) : (0, $b4335631fdf63f73$export$da356444d868ff8e);
    }
    return isTraditional ? isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094) : (0, $b4335631fdf63f73$export$6ba987e1eae93022);
};
const $272524b39064824e$export$8df64513a6dc1f2a = ({ change: change, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false, shouldHideDeleted: shouldHideDeleted = false, showIndicators: showIndicators = false, doc: doc, diffType: diffType })=>{
    const decorations = [];
    const diffId = crypto.randomUUID();
    if (shouldHideDeleted) return [
        (0, $8nvEM.Decoration).node(change.from, change.to, {
            style: $272524b39064824e$var$displayNoneStyle
        }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            decorationType: 'block',
            diffId: diffId,
            isActive: isActive,
            nodeName: change.name,
            diffType: diffType
        }))
    ];
    let style;
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && [
        'tableCell',
        'tableHeader'
    ].includes(change.name)) {
        const cellOverlay = document.createElement('div');
        const cellOverlayStyle = isInserted ? colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$d2957495f69575c) : (0, $b4335631fdf63f73$export$d311b2309a26b4fb) : colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$ea323b9930a7947d) : (0, $b4335631fdf63f73$export$7000268b4d4c5e1);
        cellOverlay.setAttribute('style', cellOverlayStyle);
        decorations.push(// change.to - 1 to position the overlay inside the end of the cell
        // this key doesn't use the spec / key builder since this is just for
        // decorating the cells, this is part of a bigger table diff
        (0, $8nvEM.Decoration).widget(change.to - 1, cellOverlay, {
            key: 'cell-overlay-decoration'
        }));
    }
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) style = $272524b39064824e$var$getBlockNodeStyle({
        nodeName: change.name,
        colorScheme: colorScheme,
        isInserted: isInserted,
        isActive: isActive,
        diffType: diffType
    });
    else style = $272524b39064824e$var$getBlockNodeStyle({
        nodeName: change.name,
        colorScheme: colorScheme,
        isActive: isActive,
        diffType: diffType
    });
    const className = $272524b39064824e$var$getNodeClass(change.name);
    if (style || className) decorations.push((0, $8nvEM.Decoration).node(change.from, change.to, {
        style: style,
        'data-testid': 'show-diff-changed-decoration-node',
        class: className
    }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
        decorationType: 'block',
        diffId: diffId,
        isActive: isActive,
        nodeName: change.name,
        diffType: diffType
    })));
    if (decorations.length > 0 && showIndicators && doc && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) decorations.push(...(0, $b6432cc061a6f6cb$export$34d0779dfc2e9aea)({
        doc: doc,
        from: change.from,
        to: change.to,
        diffId: diffId
    }));
    return decorations;
};











var $iInrd = parcelRequire("iInrd");


var $57Rmq = parcelRequire("57Rmq");







const $be39abb9710747ce$var$lozengeStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $be39abb9710747ce$var$lozengeStyleActiveStandard = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $be39abb9710747ce$var$lozengeStyleActiveTraditional = (0, $8Dx7s.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $be39abb9710747ce$var$getChangedContentStyle = (colorScheme, isActive = false, isInserted = false, diffType)=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted) {
        if (colorScheme === 'traditional') return isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
        return isActive ? (0, $b4335631fdf63f73$export$6edd58aab948260b) : (0, $b4335631fdf63f73$export$6cbccbf53a6b2a8);
    }
    if (colorScheme === 'traditional') return (0, $e7971598d3f97abe$export$f37b168a762b249f)(isActive);
    if (isActive) return 0, $b4335631fdf63f73$export$1c9944aa8f37265b;
    return (0, $ieeJu.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? (0, $b4335631fdf63f73$export$da356444d868ff8e) : (0, $b4335631fdf63f73$export$f65e7b80cdbdaf11);
};
const $be39abb9710747ce$var$getChangedNodeStyle = (nodeName, colorScheme, isInserted = false, isActive = false, diffType)=>{
    const isTraditional = colorScheme === 'traditional';
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted) {
        if ($be39abb9710747ce$var$isMultiContainerBlockNode(nodeName)) return 0, $b4335631fdf63f73$export$21401c524509064e;
        if ($be39abb9710747ce$var$isTextLikeBlockNode(nodeName)) return undefined;
        if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$a60bf2c814acef8e) : (0, $e7971598d3f97abe$export$2e643fe7923d8094);
        return 0, $b4335631fdf63f73$export$6ba987e1eae93022;
    }
    switch(nodeName){
        case 'blockquote':
            if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$cd5411bbe62ac5f5) : (0, $e7971598d3f97abe$export$781ad9e3e3929b91);
            return isActive ? (0, $b4335631fdf63f73$export$b1c2428901df334f) : (0, $b4335631fdf63f73$export$a26de8170ba89016);
        case 'expand':
        case 'decisionList':
            if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$bb158c719faea3c7) : (0, $e7971598d3f97abe$export$94cf9011b730dea);
            return isActive ? (0, $b4335631fdf63f73$export$f2cea9f09f40fb64) : (0, $b4335631fdf63f73$export$2b892754935ecdf0);
        case 'panel':
        case 'codeBlock':
            if (isTraditional) return isActive ? (0, $e7971598d3f97abe$export$9c9f71734a3c1e70) : (0, $e7971598d3f97abe$export$bd7e21e639c80e8d);
            return isActive ? (0, $b4335631fdf63f73$export$1e0b247f41c702d9) : (0, $b4335631fdf63f73$export$95d973a7458c1194);
        default:
            return undefined;
    }
};
const $be39abb9710747ce$var$shouldShowRemovedLozenge = (nodeName)=>{
    switch(nodeName){
        case 'expand':
        case 'codeBlock':
        case 'mediaSingle':
        case 'panel':
        case 'decisionList':
        case 'embedCard':
        case 'blockquote':
            return true;
        default:
            return false;
    }
};
const $be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass = (nodeName)=>{
    switch(nodeName){
        case 'mediaSingle':
        case 'embedCard':
        case 'blockquote':
            return true;
        default:
            return false;
    }
};
/** Scroll-nav “new” ring (4px red subtlest) for media/embed; styled in editor-core smartCardStyles. */ const $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive = false })=>{
    const name = targetNode.type.name;
    if (name !== 'mediaSingle' && name !== 'embedCard') return;
    if (colorScheme === 'traditional' && !isActive) nodeView.classList.add('show-diff-deleted-outline-new');
};
/**
 * Checks if a node should apply deleted styles directly without wrapper
 * to preserve natural block-level margins
 */ const $be39abb9710747ce$var$shouldApplyStylesDirectly = (nodeName)=>{
    return nodeName === 'heading';
};
const $be39abb9710747ce$var$isMultiContainerBlockNode = (nodeName)=>{
    return [
        'decisionList',
        'layoutSection'
    ].includes(nodeName);
};
const $be39abb9710747ce$var$isTextLikeBlockNode = (nodeName)=>{
    return [
        'heading',
        'bulletList',
        'orderedList',
        'listItem',
        'taskList',
        'blockquote'
    ].includes(nodeName);
};
const $be39abb9710747ce$var$applyCellOverlayStyles = ({ element: element, colorScheme: colorScheme, isInserted: isInserted })=>{
    element.querySelectorAll('td, th').forEach((cell)=>{
        const overlay = document.createElement('span');
        const overlayStyle = colorScheme === 'traditional' ? isInserted ? (0, $e7971598d3f97abe$export$4447a7c482f80938) : (0, $e7971598d3f97abe$export$ea323b9930a7947d) : isInserted ? (0, $b4335631fdf63f73$export$d311b2309a26b4fb) : (0, $b4335631fdf63f73$export$7000268b4d4c5e1);
        overlay.setAttribute('style', overlayStyle);
        cell.appendChild(overlay);
    });
};
/**
 * Creates a "Removed" lozenge to be displayed at the top right corner of deleted block nodes
 */ const $be39abb9710747ce$var$createRemovedLozenge = (intl, isActive = false, colorScheme)=>{
    const container = document.createElement('span');
    const containerStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        top: "var(--ds-space-075, 6px)",
        right: "var(--ds-space-075, 6px)",
        zIndex: 2,
        pointerEvents: 'none',
        display: 'flex'
    });
    container.setAttribute('style', containerStyle);
    container.setAttribute('data-testid', 'show-diff-removed-lozenge');
    // Create vanilla HTML lozenge element with Atlaskit Lozenge styling (visual refresh)
    const lozengeElement = document.createElement('span');
    const lozengeInnerStyle = isActive && colorScheme === 'traditional' ? $be39abb9710747ce$var$lozengeStyleActiveTraditional : isActive ? $be39abb9710747ce$var$lozengeStyleActiveStandard : $be39abb9710747ce$var$lozengeStyle;
    lozengeElement.setAttribute('style', lozengeInnerStyle);
    lozengeElement.textContent = intl.formatMessage((0, $iInrd.trackChangesMessages).removed).toUpperCase();
    container.appendChild(lozengeElement);
    return container;
};
/**
 * Wraps a block node in a container with relative positioning to support absolute positioned lozenge
 */ const $be39abb9710747ce$var$createBlockNodeWrapper = ()=>{
    const wrapper = document.createElement('div');
    const baseStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'relative',
        display: 'block',
        opacity: 1
    });
    wrapper.setAttribute('style', baseStyle);
    return wrapper;
};
/**
 * Applies styles directly to an HTML element by merging with existing styles
 */ const $be39abb9710747ce$var$applyStylesToElement = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType })=>{
    const currentStyle = element.getAttribute('style') || '';
    const contentStyle = $be39abb9710747ce$var$getChangedContentStyle(colorScheme, isActive, isInserted, diffType);
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeSpecificStyle = $be39abb9710747ce$var$getChangedNodeStyle(targetNodeName, colorScheme, isInserted, isActive, diffType) || '';
    element.setAttribute('style', `${currentStyle}${contentStyle}${nodeSpecificStyle}`);
};
const $be39abb9710747ce$var$applyMultiContainerLikeStyles = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType })=>{
    const currentStyle = element.getAttribute('style') || '';
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeSpecificStyle = $be39abb9710747ce$var$getChangedNodeStyle(targetNodeName, colorScheme, isInserted, isActive, diffType) || '';
    if (targetNode.type.name === 'decisionList') element.querySelectorAll('li').forEach((listItem)=>{
        const currentListItemStyle = listItem.getAttribute('style') || '';
        listItem.setAttribute('style', `${currentListItemStyle}${(0, $b4335631fdf63f73$export$6ba987e1eae93022)}`);
    });
    else if (targetNode.type.name === 'layoutSection') element.querySelectorAll('[data-layout-column="true"]').forEach((section)=>{
        const currentSectionStyle = section.getAttribute('style') || '';
        section.setAttribute('style', `${currentSectionStyle}${(0, $b4335631fdf63f73$export$6ba987e1eae93022)}`);
    });
    else if (targetNode.type.name === 'taskList') element.querySelectorAll('li').forEach((listItem)=>{
        const currentListItemStyle = listItem.getAttribute('style') || '';
        listItem.setAttribute('style', `${currentListItemStyle}${(0, $b4335631fdf63f73$export$6ba987e1eae93022)}`);
    });
    element.setAttribute('style', `${currentStyle};${nodeSpecificStyle}`);
};
const $be39abb9710747ce$var$applyTextLikeBlockNodeStyles = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType })=>{
    const currentStyle = element.getAttribute('style') || '';
    const nodeSpecificStyle = $be39abb9710747ce$var$getChangedNodeStyle(targetNode.type.name, colorScheme, isInserted, isActive, diffType) || '';
    if (nodeSpecificStyle) element.setAttribute('style', `${currentStyle}${nodeSpecificStyle}`);
    const contentStyle = $be39abb9710747ce$var$getChangedContentStyle(colorScheme, isActive, isInserted, diffType);
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodesToWrap = [];
    let currentNode = walker.nextNode();
    while(currentNode){
        if (currentNode instanceof Text && currentNode.textContent !== '' && currentNode.parentElement) textNodesToWrap.push(currentNode);
        currentNode = walker.nextNode();
    }
    textNodesToWrap.forEach((textNode)=>{
        const contentWrapper = document.createElement('span');
        contentWrapper.setAttribute('style', contentStyle);
        textNode.replaceWith(contentWrapper);
        contentWrapper.append(textNode);
    });
};
/**
 * Creates a content wrapper with deleted styles for a block node
 */ const $be39abb9710747ce$var$createBlockNodeContentWrapper = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType })=>{
    const contentWrapper = document.createElement('div');
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeStyle = $be39abb9710747ce$var$getChangedNodeStyle(targetNodeName, colorScheme, isInserted, isActive, diffType);
    // When the extended experiment is enabled and the content is inserted,
    // block widget nodes that already have dedicated node-level styling (e.g. boxShadow outline)
    // should not also get the inline content style (borderBottom underline) on their container.
    const shouldSkipContentStyle = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && isInserted && nodeStyle !== undefined;
    const contentStyle = shouldSkipContentStyle ? '' : $be39abb9710747ce$var$getChangedContentStyle(colorScheme, isActive, isInserted, diffType);
    contentWrapper.setAttribute('style', `${contentStyle}${nodeStyle || ''}`);
    contentWrapper.append(nodeView);
    return contentWrapper;
};
/**
 * Handles embedCard node rendering with lozenge attached to the rich-media-item container.
 * Since embedCard content loads asynchronously, we use a MutationObserver
 * to wait for the rich-media-item to appear before attaching the lozenge.
 * @returns true if embedCard was handled
 */ const $be39abb9710747ce$var$handleEmbedCardWithLozenge = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, lozenge: lozenge, colorScheme: colorScheme, isActive: isActive = false })=>{
    if (targetNode.type.name !== 'embedCard' || !(nodeView instanceof HTMLElement)) return false;
    const richMediaItem = nodeView.querySelector('.rich-media-item');
    if (richMediaItem instanceof HTMLElement) richMediaItem.appendChild(lozenge);
    else {
        const observer = new MutationObserver((_, obs)=>{
            const loadedRichMedia = nodeView.querySelector('.rich-media-item');
            if (loadedRichMedia instanceof HTMLElement) {
                loadedRichMedia.appendChild(lozenge);
                obs.disconnect();
            }
        });
        observer.observe(nodeView, {
            childList: true,
            subtree: true
        });
    }
    if ($be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
        if (isActive) nodeView.classList.add('show-diff-deleted-active');
        $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass({
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive
        });
    }
    dom.append(nodeView);
    return true;
};
/**
 * Handles special mediaSingle node rendering with lozenge on child media element
 * @returns true if mediaSingle was handled, false otherwise
 */ const $be39abb9710747ce$var$handleMediaSingleWithLozenge = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, lozenge: lozenge, colorScheme: colorScheme, isActive: isActive = false })=>{
    if (targetNode.type.name !== 'mediaSingle' || !(nodeView instanceof HTMLElement)) return false;
    const mediaNode = nodeView.querySelector('[data-prosemirror-node-name="media"]');
    if (!mediaNode || !(mediaNode instanceof HTMLElement)) return false;
    // Add relative positioning to media node to anchor lozenge
    const currentStyle = mediaNode.getAttribute('style') || '';
    const relativePositionStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'relative'
    });
    mediaNode.setAttribute('style', `${currentStyle}${relativePositionStyle}`);
    mediaNode.append(lozenge);
    // Add deleted node class if needed
    if ($be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
        if (isActive) nodeView.classList.add('show-diff-deleted-active');
        $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass({
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive
        });
    }
    dom.append(nodeView);
    return true;
};
/**
 * Appends a block node with wrapper, lozenge, and appropriate styling
 */ const $be39abb9710747ce$var$wrapBlockNode = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, intl: intl, isActive: isActive = false, isInserted: isInserted = false, diffType: diffType })=>{
    const blockWrapper = $be39abb9710747ce$var$createBlockNodeWrapper();
    const targetNodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    if ($be39abb9710747ce$var$shouldShowRemovedLozenge(targetNodeName) && (!(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || !isInserted)) {
        const lozenge = $be39abb9710747ce$var$createRemovedLozenge(intl, isActive, colorScheme);
        if ($be39abb9710747ce$var$handleEmbedCardWithLozenge({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            lozenge: lozenge,
            colorScheme: colorScheme,
            isActive: isActive
        })) return;
        if ($be39abb9710747ce$var$handleMediaSingleWithLozenge({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            lozenge: lozenge,
            colorScheme: colorScheme,
            isActive: isActive
        })) return;
        blockWrapper.append(lozenge);
    }
    const contentWrapper = $be39abb9710747ce$var$createBlockNodeContentWrapper({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive,
        isInserted: isInserted,
        diffType: diffType
    });
    blockWrapper.append(contentWrapper);
    if (nodeView instanceof HTMLElement && $be39abb9710747ce$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
        if (isActive) nodeView.classList.add('show-diff-deleted-active');
        $be39abb9710747ce$var$maybeAddDeletedOutlineNewClass({
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive
        });
    }
    dom.append(blockWrapper);
};
const $be39abb9710747ce$export$decea4d8614a74b3 = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, intl: intl, isActive: isActive = false, isInserted: isInserted = false, diffType: diffType })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (nodeView instanceof HTMLElement) {
            if (isInserted && $be39abb9710747ce$var$isMultiContainerBlockNode(targetNode.type.name)) {
                $be39abb9710747ce$var$applyMultiContainerLikeStyles({
                    element: nodeView,
                    targetNode: targetNode,
                    colorScheme: colorScheme,
                    isActive: isActive,
                    isInserted: isInserted,
                    diffType: diffType
                });
                dom.append(nodeView);
                return;
            }
            if ($be39abb9710747ce$var$isTextLikeBlockNode(targetNode.type.name)) {
                $be39abb9710747ce$var$applyTextLikeBlockNodeStyles({
                    element: nodeView,
                    targetNode: targetNode,
                    colorScheme: colorScheme,
                    isActive: isActive,
                    isInserted: isInserted,
                    diffType: diffType
                });
                dom.append(nodeView);
                return;
            }
            if (targetNode.type.name === 'table') {
                $be39abb9710747ce$var$applyCellOverlayStyles({
                    element: nodeView,
                    colorScheme: colorScheme,
                    isInserted: isInserted
                });
                dom.append(nodeView);
                return;
            }
        }
        $be39abb9710747ce$var$wrapBlockNode({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            intl: intl,
            isActive: isActive,
            isInserted: isInserted,
            diffType: diffType
        });
        return;
    } else if ($be39abb9710747ce$var$shouldApplyStylesDirectly(targetNode.type.name) && nodeView instanceof HTMLElement) {
        // Apply deleted styles directly to preserve natural block-level margins
        $be39abb9710747ce$var$applyStylesToElement({
            element: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive,
            isInserted: isInserted,
            diffType: diffType
        });
        dom.append(nodeView);
    } else $be39abb9710747ce$var$wrapBlockNode({
        dom: dom,
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        intl: intl,
        isActive: isActive,
        isInserted: isInserted,
        diffType: diffType
    });
};
const $be39abb9710747ce$var$getDeletedContentStyleUnbounded = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional' && isActive) return 0, $e7971598d3f97abe$export$e384205f8cc82cfe;
    return colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$d7c13cc5c70ee199) : (0, $b4335631fdf63f73$export$f9aac5ed53f3d424);
};
const $be39abb9710747ce$var$getInsertedContentStyle = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional') return isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
    if (isActive) return 0, $b4335631fdf63f73$export$6edd58aab948260b;
    return 0, $b4335631fdf63f73$export$6cbccbf53a6b2a8;
};
const $be39abb9710747ce$var$getDeletedContentStyle = (colorScheme, isActive = false, diffType)=>{
    if (colorScheme === 'traditional') return (0, $e7971598d3f97abe$export$f37b168a762b249f)(isActive);
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return (isActive ? (0, $b4335631fdf63f73$export$1c9944aa8f37265b) : (0, $b4335631fdf63f73$export$da356444d868ff8e)) + (0, $b4335631fdf63f73$export$19cf8e2cf40a1110);
    return isActive ? (0, $b4335631fdf63f73$export$1c9944aa8f37265b) : (0, $b4335631fdf63f73$export$da356444d868ff8e);
};
const $be39abb9710747ce$export$d67ad4e75a7e5029 = ({ node: node, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted, diffType: diffType })=>{
    const wrapper = document.createElement('span');
    wrapper.setAttribute('style', isInserted ? $be39abb9710747ce$var$getInsertedContentStyle(colorScheme, isActive) : $be39abb9710747ce$var$getDeletedContentStyle(colorScheme, isActive, diffType));
    [
        ...node.childNodes
    ].forEach((child)=>{
        const removedChild = node.removeChild(child);
        wrapper.append(removedChild);
    });
    node.appendChild(wrapper);
    return node;
};
const $be39abb9710747ce$export$9fa8827364ac0e9d = (colorScheme, isActive = false, isInserted = false, diffType)=>{
    const wrapper = document.createElement('span');
    const baseStyle = (0, $8Dx7s.convertToInlineCss)({
        position: 'relative',
        width: 'fit-content'
    });
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (isInserted) wrapper.setAttribute('style', `${baseStyle}${$be39abb9710747ce$var$getInsertedContentStyle(colorScheme, isActive)}`);
        else {
            wrapper.setAttribute('style', `${baseStyle}${$be39abb9710747ce$var$getDeletedContentStyle(colorScheme, isActive, diffType)}`);
            const strikethrough = document.createElement('span');
            strikethrough.setAttribute('style', $be39abb9710747ce$var$getDeletedContentStyleUnbounded(colorScheme, isActive));
            wrapper.append(strikethrough);
        }
    } else {
        wrapper.setAttribute('style', `${baseStyle}${$be39abb9710747ce$var$getDeletedContentStyle(colorScheme, isActive, diffType)}`);
        const strikethrough = document.createElement('span');
        strikethrough.setAttribute('style', $be39abb9710747ce$var$getDeletedContentStyleUnbounded(colorScheme, isActive));
        wrapper.append(strikethrough);
    }
    return wrapper;
};


const $31f9015ad6b08a27$export$a5d21dc34e291ee6 = ({ change: change, originalDoc: originalDoc, newDoc: newDoc, isInverted: isInverted, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, diffId: diffId, showIndicators: showIndicators = false })=>{
    // Determine which doc and positions to use for rendering the reference block.
    const renderDoc = isInverted ? newDoc : originalDoc;
    const renderTo = isInverted ? change.toB : change.toA;
    // The insertion point is always in newDoc — ProseMirror decorates against the live document.
    // Walk up from toB to find the enclosing text block boundary for widget placement.
    const insertResolvedPos = newDoc.resolve(change.toB);
    let blockEnd = change.toB;
    for(let depth = insertResolvedPos.depth; depth >= 0; depth--){
        const node = insertResolvedPos.node(depth);
        if (node.isTextblock) {
            blockEnd = insertResolvedPos.start(depth) + node.nodeSize - 1;
            break;
        }
    }
    // Find the block node to render from the render doc at the render positions.
    const renderResolvedPos = renderDoc.resolve(renderTo);
    let renderBlockNode = null;
    for(let depth = renderResolvedPos.depth; depth >= 0; depth--){
        const node = renderResolvedPos.node(depth);
        if (node.isTextblock) {
            renderBlockNode = node;
            break;
        }
    }
    if (!renderBlockNode) return [];
    const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
    /**
   * This will always be a block node as it's a textBlock-like node.
   * We use div instead of span so we can add margins.
   */ const dom = document.createElement('div');
    dom.setAttribute('data-testid', 'show-diff-granular-block-reference');
    dom.style.setProperty('margin-top', "var(--ds-space-200, 16px)");
    const nodeView = nodeViewSerializer.tryCreateNodeView(renderBlockNode);
    if (nodeView) (0, $be39abb9710747ce$export$decea4d8614a74b3)({
        dom: dom,
        nodeView: nodeView,
        targetNode: renderBlockNode,
        colorScheme: colorScheme,
        intl: intl,
        isActive: !!isActive,
        isInserted: false
    });
    else {
        const serialized = nodeViewSerializer.serializeNode(renderBlockNode);
        if (serialized && serialized instanceof HTMLElement) {
            (0, $be39abb9710747ce$export$d67ad4e75a7e5029)({
                node: serialized,
                colorScheme: colorScheme,
                isActive: !!isActive,
                isInserted: false
            });
            dom.append(serialized);
        } else if (serialized) dom.append(serialized);
    }
    if (dom.childNodes.length === 0) return [];
    const decorations = [];
    if (showIndicators) {
        const leftAnchor = (0, $b6432cc061a6f6cb$export$bb60b01773a85c0d)({
            doc: newDoc,
            from: blockEnd,
            diffId: diffId
        });
        dom.style.setProperty('anchor-name', `--${(0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
            diffId: diffId
        })}`);
        if (leftAnchor) decorations.push(leftAnchor);
    }
    decorations.push((0, $8nvEM.Decoration).widget(blockEnd, dom, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
        decorationType: 'widget',
        diffId: diffId,
        // We want it to be as close to the granular diff as possible
        side: -999
    })));
    return decorations;
};













const $446fe50ec2aaceae$var$displayNoneStyle = (0, $8Dx7s.convertToInlineCss)({
    display: 'none'
});
const $446fe50ec2aaceae$export$69543ba6b110e31c = ({ change: change, colorScheme: colorScheme, isActive: isActive = false, isInserted: isInserted = true, shouldHideDeleted: shouldHideDeleted = false, showIndicators: showIndicators = false, doc: doc, diffType: diffType })=>{
    const diffId = crypto.randomUUID();
    if (shouldHideDeleted) return [
        (0, $8nvEM.Decoration).inline(change.fromB, change.toB, {
            style: $446fe50ec2aaceae$var$displayNoneStyle
        }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            decorationType: 'inline',
            diffId: diffId,
            isActive: isActive
        }))
    ];
    let style;
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (isInserted) {
            if (colorScheme === 'traditional') style = isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
            else style = isActive ? (0, $b4335631fdf63f73$export$6edd58aab948260b) : (0, $b4335631fdf63f73$export$6cbccbf53a6b2a8);
        } else if (colorScheme === 'traditional') style = (0, $e7971598d3f97abe$export$f37b168a762b249f)(false);
        else {
            style = isActive ? (0, $b4335631fdf63f73$export$1c9944aa8f37265b) : (0, $b4335631fdf63f73$export$f65e7b80cdbdaf11);
            /**
				 * Merge into existing styles when cleaning up
				 */ if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) style += (0, $b4335631fdf63f73$export$19cf8e2cf40a1110);
        }
    } else if (colorScheme === 'traditional') style = isActive ? (0, $e7971598d3f97abe$export$a9b71bdebdda9dc4) : (0, $e7971598d3f97abe$export$5f26b1217ef25d6b);
    else style = isActive ? (0, $b4335631fdf63f73$export$97e4289fb0e21ca7) : (0, $b4335631fdf63f73$export$8382eabaf43593de);
    const decorations = [
        (0, $8nvEM.Decoration).inline(change.fromB, change.toB, {
            style: style,
            'data-testid': 'show-diff-changed-decoration'
        }, (0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            decorationType: 'inline',
            diffId: diffId,
            isActive: isActive
        }))
    ];
    if (showIndicators && doc && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) decorations.push(...(0, $b6432cc061a6f6cb$export$dc213f6c0d801266)({
        doc: doc,
        from: change.fromB,
        to: change.toB,
        diffId: diffId
    }));
    return decorations;
};

















var $8Z43Z = parcelRequire("8Z43Z");








function $0635766b84aa3009$export$c531c54bff461ffa(doc, pos, slice) {
    if (pos > doc.content.size) return doc.content.size;
    let $pos = doc.resolve(pos);
    while(!(0, $bjg0G.canInsert)($pos, slice.content) && slice.content.firstChild?.type.name !== 'paragraph'){
        if ($pos.pos + 1 > doc.content.size) break;
        $pos = doc.resolve($pos.pos + 1);
    }
    return $pos.pos;
}


/**
 * Extracts information about deleted table rows from a change
 */ const $a3529214184876b7$var$extractChangedRows = ({ change: change, originalDoc: originalDoc, newDoc: newDoc, diffType: diffType })=>{
    const changedRows = [];
    // Find the table in the original document
    const $fromPos = originalDoc.resolve(change.fromA);
    const tableOld = (0, $bjg0G.findParentNodeClosestToPos)($fromPos, (node)=>node.type.name === 'table');
    if (!tableOld) return changedRows;
    const oldTableMap = (0, $8Z43Z.TableMap).get(tableOld.node);
    // Find the table in the new document at the insertion point
    const $newPos = newDoc.resolve(change.fromB);
    const tableNew = (0, $bjg0G.findParentNodeClosestToPos)($newPos, (node)=>node.type.name === 'table');
    if (!tableNew) return changedRows;
    const newTableMap = (0, $8Z43Z.TableMap).get(tableNew.node);
    // If no rows were changed, return empty
    if (oldTableMap.height <= newTableMap.height || // For now ignore if there are column deletions as well
    oldTableMap.width !== newTableMap.width) return changedRows;
    // Find which rows were changed by analyzing the change range
    const changeStartInTable = change.fromA - tableOld.pos - 1;
    const changeEndInTable = change.toA - tableOld.pos - 1;
    let currentOffset = 0;
    let rowIndex = 0;
    tableOld.node.content.forEach((rowNode)=>{
        const rowStart = currentOffset;
        const rowEnd = currentOffset + rowNode.nodeSize;
        // Check if this row overlaps with the deletion range
        const rowOverlapsChange = rowStart >= changeStartInTable && rowStart < changeEndInTable || rowEnd > changeStartInTable && rowEnd <= changeEndInTable || rowStart < changeStartInTable && rowEnd > changeEndInTable;
        if (rowOverlapsChange && rowNode.type.name === 'tableRow' && ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || !$a3529214184876b7$var$isEmptyRow(rowNode))) {
            const startOfRow = newTableMap.mapByRow.slice().reverse().find((row)=>row[0] + tableNew.pos < change.fromB && change.fromB < row[row.length - 1] + tableNew.pos);
            changedRows.push({
                rowIndex: rowIndex,
                rowNode: rowNode,
                fromA: tableOld.pos + 1 + rowStart,
                toA: tableOld.pos + 1 + rowEnd,
                fromB: startOfRow ? startOfRow[0] + tableNew.start : change.fromB
            });
        }
        currentOffset += rowNode.nodeSize;
        if (rowNode.type.name === 'tableRow') rowIndex++;
    });
    // Filter changes that never truly got deleted
    return changedRows.filter((changedRow)=>{
        return !tableNew.node.children.some((newRow)=>(0, $6SJ6d.areNodesEqualIgnoreAttrs)(newRow, changedRow.rowNode));
    });
};
/**
 * Checks if a table row is empty (contains no meaningful content)
 */ const $a3529214184876b7$var$isEmptyRow = (rowNode)=>{
    let isEmpty = true;
    rowNode.descendants((node)=>{
        if (!isEmpty) return false;
        // If we find any inline content with size > 0, the row is not empty
        if (node.isInline && node.nodeSize > 0) {
            isEmpty = false;
            return false;
        }
        // If we find text content, the row is not empty
        if (node.isText && node.text && node.text.trim() !== '') {
            isEmpty = false;
            return false;
        }
        return true;
    });
    return isEmpty;
};
/**
 * Creates a DOM representation of a deleted table row
 */ const $a3529214184876b7$var$createChangedRowDOM = (rowNode, nodeViewSerializer, colorScheme, isInserted, diffType)=>{
    const tr = document.createElement('tr');
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        if (!isInserted) tr.setAttribute('style', colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$62207903895cae1) : (0, $b4335631fdf63f73$export$ba3acd64357126ab));
    } else tr.setAttribute('style', colorScheme === 'traditional' ? (0, $e7971598d3f97abe$export$62207903895cae1) : (0, $b4335631fdf63f73$export$ba3acd64357126ab));
    tr.setAttribute('data-testid', 'show-diff-deleted-row');
    // Serialize each cell in the row
    rowNode.content.forEach((cellNode)=>{
        if (cellNode.type.name === 'tableCell' || cellNode.type.name === 'tableHeader') {
            const nodeView = nodeViewSerializer.tryCreateNodeView(cellNode);
            if (nodeView) {
                if (nodeView instanceof HTMLElement && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
                    const overlay = document.createElement('span');
                    const overlayStyle = colorScheme === 'traditional' ? isInserted ? (0, $e7971598d3f97abe$export$d2957495f69575c) : (0, $e7971598d3f97abe$export$ea323b9930a7947d) : isInserted ? (0, $b4335631fdf63f73$export$d311b2309a26b4fb) : (0, $b4335631fdf63f73$export$7000268b4d4c5e1);
                    overlay.setAttribute('style', overlayStyle);
                    nodeView.appendChild(overlay);
                }
                tr.appendChild(nodeView);
            } else {
                // Fallback to fragment serialization
                const serializedContent = nodeViewSerializer.serializeFragment(cellNode.content);
                if (serializedContent) tr.appendChild(serializedContent);
            }
        }
    });
    return tr;
};
/**
 * Expands a diff to include whole changed rows when table rows are affected
 */ const $a3529214184876b7$var$expandDiffForChangedRows = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc, diffType: diffType })=>{
    const rowInfo = [];
    for (const change of changes){
        // Check if this change affects table content
        const changedRows = $a3529214184876b7$var$extractChangedRows({
            change: change,
            originalDoc: originalDoc,
            newDoc: newDoc,
            diffType: diffType
        });
        if (changedRows.length > 0) rowInfo.push(...changedRows);
    }
    return rowInfo;
};
const $a3529214184876b7$export$f3a7e2ee274f388a = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, isInserted: isInserted = false, diffType: diffType })=>{
    // First, expand the changes to include complete deleted rows
    const changedRows = $a3529214184876b7$var$expandDiffForChangedRows({
        changes: changes.filter((change)=>change.deleted.length > 0),
        originalDoc: originalDoc,
        newDoc: newDoc,
        diffType: diffType
    });
    return changedRows.map((changedRow)=>{
        const rowDOM = $a3529214184876b7$var$createChangedRowDOM(changedRow.rowNode, nodeViewSerializer, colorScheme, isInserted, diffType);
        // Find safe insertion position for the deleted row
        const safeInsertPos = (0, $0635766b84aa3009$export$c531c54bff461ffa)(newDoc, changedRow.fromB - 1, originalDoc.slice(changedRow.fromA, changedRow.toA));
        const diffId = crypto.randomUUID();
        return (0, $8nvEM.Decoration).widget(safeInsertPos, rowDOM, {
            ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
                decorationType: 'widget',
                diffId: diffId,
                isActive: false,
                diffType: diffType
            })
        });
    });
};





const $6760b5578652a45a$export$33298e826c81587e = ({ change: change, doc: doc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, newDoc: newDoc, intl: intl, activeIndexPos: activeIndexPos, isInserted: // This is false by default as this is generally used to show deleted content
isInserted = false, showIndicators: showIndicators = false, placeBelow: // When true, render the deleted content *after* (below) the new content instead of
// before it. Used for `smart` node-level changes so the deleted node appears beneath
// its replacement (gray + strikethrough).
placeBelow = false, diffType: diffType })=>{
    const slice = doc.slice(change.fromA, change.toA);
    const shouldSkipDeletedEmptyParagraphDecoration = !isInserted && slice?.content?.childCount === 1 && slice?.content?.firstChild?.type.name === 'paragraph' && slice?.content?.firstChild?.content.size === 0;
    // Widget decoration used for deletions as the content is not in the document
    // and we want to display the deleted content with a style.
    // For `placeBelow`, anchor at the END of the new content (change.toB) so the deleted
    // node renders beneath its replacement; otherwise anchor at the start (change.fromB).
    const anchorPos = placeBelow ? change.toB : change.fromB;
    const safeInsertPos = (0, $0635766b84aa3009$export$c531c54bff461ffa)(newDoc, anchorPos, slice);
    const isActive = activeIndexPos && safeInsertPos === activeIndexPos.from && safeInsertPos === activeIndexPos.to;
    if (slice.content.content.length === 0 || shouldSkipDeletedEmptyParagraphDecoration) return [];
    const isTableCellContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableHeader',
                'tableCell'
            ].includes(siblingNode.type.name)));
    const isTableRowContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableRow'
            ].includes(siblingNode.type.name)));
    if (isTableCellContent) return [];
    if (isTableRowContent) return (0, $a3529214184876b7$export$f3a7e2ee274f388a)({
        changes: [
            change
        ],
        originalDoc: doc,
        newDoc: newDoc,
        nodeViewSerializer: nodeViewSerializer,
        colorScheme: colorScheme,
        isInserted: isInserted,
        diffType: diffType
    });
    const serializer = nodeViewSerializer;
    // For non-table content, use the existing span wrapper approach
    const dom = document.createElement('span');
    // When mediaSingle nodes are rendered inside a widget decoration (e.g. as part of
    // a replaced panel), the centering CSS (margin-left: 50%; transform: translateX(-50%))
    // incorrectly applies because isNestedNode resolves to false (getPos returns 0).
    // Observe DOM mutations and override the transform on .rich-media-item elements
    // after React mounts to prevent the image from shifting outside its parent container.
    let constrainMediaObserver;
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        constrainMediaObserver = new MutationObserver(()=>{
            const richMediaItems = dom.querySelectorAll('.rich-media-item');
            richMediaItems.forEach((el)=>{
                if (el instanceof HTMLElement) {
                    el.style.transform = 'none';
                    el.style.marginLeft = '0';
                    el.style.maxWidth = '100%';
                }
            });
            if (richMediaItems.length > 0) constrainMediaObserver?.disconnect();
        });
        constrainMediaObserver.observe(dom, {
            childList: true,
            subtree: true
        });
    }
    const diffId = crypto.randomUUID();
    const decorations = [];
    /*
   * The thinking is we separate out the fragment we got from doc.slice
   * and if it's the first or last content, we go in however many the sliced Open
   * or sliced End depth is and match only the entire node.
   */ slice.content.forEach((node)=>{
        // Helper function to handle multiple child nodes
        const handleMultipleChildNodes = (node)=>{
            if (node.content.childCount > 1 && node.type.inlineContent) {
                node.content.forEach((childNode)=>{
                    const childNodeView = serializer.tryCreateNodeView(childNode);
                    if (childNodeView) {
                        const lineBreak = document.createElement('br');
                        dom.append(lineBreak);
                        const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType);
                        wrapper.append(childNodeView);
                        dom.append(wrapper);
                    } else {
                        // Fallback to serializing the individual child node
                        const serializedChild = serializer.serializeNode(childNode);
                        if (serializedChild) {
                            const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType);
                            wrapper.append(serializedChild);
                            dom.append(wrapper);
                        }
                    }
                });
                return true; // Indicates we handled multiple children
            }
            return false; // Indicates single child, continue with normal logic
        };
        // Determine which node to use and how to serialize
        const isFirst = slice.content.firstChild === node;
        const isLast = slice.content.lastChild === node;
        const hasInlineContent = node.content.childCount > 0 && node.type.inlineContent === true;
        let fallbackSerialization;
        if (handleMultipleChildNodes(node)) return;
        if ((isFirst || isLast && slice.content.childCount > 2) && hasInlineContent) fallbackSerialization = ()=>serializer.serializeFragment(node.content);
        else if (isLast && slice.content.childCount === 2) fallbackSerialization = ()=>{
            if (node.type.name === 'text') return document.createTextNode(node.text || '');
            if (node.type.name === 'paragraph') {
                const lineBreak = document.createElement('br');
                dom.append(lineBreak);
                return serializer.serializeFragment(node.content);
            }
            return serializer.serializeFragment(node.content);
        };
        else fallbackSerialization = ()=>serializer.serializeNode(node);
        // Try to create node view, fallback to serialization
        const nodeView = serializer.tryCreateNodeView(node);
        if (nodeView) {
            if (node.isInline) {
                const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType);
                wrapper.append(nodeView);
                dom.append(wrapper);
            } else // Handle all block nodes with unified function
            (0, $be39abb9710747ce$export$decea4d8614a74b3)({
                dom: dom,
                nodeView: nodeView,
                targetNode: node,
                colorScheme: colorScheme,
                intl: intl,
                isActive: isActive,
                isInserted: isInserted,
                diffType: diffType
            });
        } else if (nodeViewSerializer.getFilteredNodeViewBlocklist([
            'paragraph',
            'tableRow'
        ]).has(node.type.name)) // Skip the case where the node is a paragraph or table row that way it can still be rendered and delete the entire table
        return;
        else {
            const fallbackNode = fallbackSerialization();
            if (fallbackNode) {
                if (fallbackNode instanceof HTMLElement) {
                    const injectedNode = (0, $be39abb9710747ce$export$d67ad4e75a7e5029)({
                        node: fallbackNode,
                        colorScheme: colorScheme,
                        isActive: isActive,
                        isInserted: isInserted,
                        diffType: diffType
                    });
                    dom.append(injectedNode);
                } else {
                    const wrapper = (0, $be39abb9710747ce$export$9fa8827364ac0e9d)(colorScheme, isActive, isInserted, diffType);
                    wrapper.append(fallbackNode);
                    dom.append(wrapper);
                }
            }
        }
    });
    dom.setAttribute('data-testid', 'show-diff-deleted-decoration');
    if (showIndicators && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        const leftAnchor = (0, $b6432cc061a6f6cb$export$bb60b01773a85c0d)({
            doc: newDoc,
            from: safeInsertPos,
            diffId: diffId
        });
        dom.style.setProperty('anchor-name', `--${(0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
            diffId: diffId
        })}`);
        if (leftAnchor) decorations.push(leftAnchor);
    }
    decorations.push((0, $8nvEM.Decoration).widget(safeInsertPos, dom, {
        ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
            decorationType: 'widget',
            diffId: diffId,
            isActive: isActive,
            diffType: diffType,
            ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                // placeBelow anchors at the end of the new content, so render on the
                // trailing side (1); otherwise render before the new content (-1).
                side: placeBelow ? 1 : -1
            }
        }),
        destroy: ()=>constrainMediaObserver?.disconnect()
    }));
    // When a single block node is purely deleted at the very start of the doc (first child),
    // the deleted widget decoration overlaps with the existing first child's decoration.
    // To fix this, we insert an additional empty widget span before the deleted content
    // to push it down and create visual separation.
    //
    // Conditions for the placeholder:
    // 1. isPureDeletion: change.fromB === change.toB — nothing was inserted at the same position.
    //    Node type changes (e.g. paragraph → heading) have both a deletion and an insertion,
    //    so fromB !== toB — we skip the placeholder in that case.
    // 2. isSingleBlock: exactly one block node was deleted (not inline, not multi-block).
    // 3. safeInsertPos: that it is the first node
    const isPureDeletion = change.fromB === change.toB;
    const isSingleBlock = slice.content.childCount === 1 && slice.content.firstChild?.isBlock;
    const resolvedPos = newDoc.resolve(change.fromB);
    const isFirstDocChild = resolvedPos.depth === 0 && resolvedPos.index(0) === 0;
    if (isFirstDocChild && isSingleBlock && isPureDeletion && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        const emptyWidgetSpan = document.createElement('span');
        emptyWidgetSpan.style.display = 'block';
        // Use a design token for the margin to keep spacing consistent with the design system
        emptyWidgetSpan.style.marginTop = "var(--ds-space-100, 8px)";
        const widget = (0, $8nvEM.Decoration).widget(safeInsertPos, emptyWidgetSpan, {
            ...(0, $c8506ce9a0d29c95$export$b63856cff30de075)({
                decorationType: 'widget',
                diffId: crypto.randomUUID(),
                diffType: diffType
            })
        });
        decorations.push(widget);
    }
    return decorations;
};




var $1A89X = parcelRequire("1A89X");




const $5a5219f6ff8efa86$var$filterUndefined = (x)=>!!x;
// Attributes that indicate a change in media image
const $5a5219f6ff8efa86$var$mediaAttrs = [
    'id',
    'collection',
    'url'
];
// Attribute that indicates a date change
const $5a5219f6ff8efa86$var$dateAttrs = [
    'timestamp'
];
// Attribute that indicates a task item state change
const $5a5219f6ff8efa86$var$taskItemAttrs = [
    'state'
];
// Attributes excluded from extension change detection (not meaningful content changes)
const $5a5219f6ff8efa86$var$extensionExcludedAttrs = [
    'localId'
];
// Extension node type names
const $5a5219f6ff8efa86$var$extensionNodeNames = [
    'extension',
    'inlineExtension',
    'bodiedExtension'
];
const $5a5219f6ff8efa86$var$getStepAttrs = (step)=>{
    if (step instanceof (0, $eOaGc.AttrStep)) return [
        step.attr
    ];
    if (step instanceof (0, $1A89X.SetAttrsStep) && step.attrs) return Object.keys(step.attrs);
    return [];
};
const $5a5219f6ff8efa86$export$34445edbbb29aecb = (doc, steps)=>{
    return steps.map((step)=>{
        if (!(step instanceof (0, $eOaGc.AttrStep)) && !(step instanceof (0, $1A89X.SetAttrsStep))) return undefined;
        const stepAttrs = $5a5219f6ff8efa86$var$getStepAttrs(step);
        const $pos = doc.resolve(step.pos);
        const nodeAtPos = doc.nodeAt(step.pos);
        // date node: timestamp attribute change — highlight the date node itself (inline)
        if (stepAttrs.some((v)=>$5a5219f6ff8efa86$var$dateAttrs.includes(v)) && nodeAtPos?.type.name === 'date') return {
            fromB: step.pos,
            toB: step.pos + nodeAtPos.nodeSize,
            isInline: true
        };
        // taskItem node: state attribute change — highlight the taskItem node
        if (stepAttrs.some((v)=>$5a5219f6ff8efa86$var$taskItemAttrs.includes(v)) && nodeAtPos?.type.name === 'taskItem') return {
            fromB: step.pos,
            toB: step.pos + nodeAtPos.nodeSize
        };
        // extension nodes: any attribute change except localId — highlight the node
        if (nodeAtPos && $5a5219f6ff8efa86$var$extensionNodeNames.includes(nodeAtPos.type.name) && stepAttrs.some((v)=>!$5a5219f6ff8efa86$var$extensionExcludedAttrs.includes(v))) {
            const isInline = nodeAtPos.type.name === 'inlineExtension';
            return {
                fromB: step.pos,
                toB: step.pos + nodeAtPos.nodeSize,
                isInline: isInline
            };
        }
        // media node: id/collection/url attribute change — highlight the mediaSingle parent
        if (stepAttrs.some((v)=>$5a5219f6ff8efa86$var$mediaAttrs.includes(v)) && $pos.parent.type === doc.type.schema.nodes.mediaSingle) {
            const startPos = $pos.pos + $pos.parentOffset;
            return {
                fromB: startPos,
                toB: startPos + $pos.parent.nodeSize - 1
            };
        }
        return undefined;
    }).filter($5a5219f6ff8efa86$var$filterUndefined);
};
const $5a5219f6ff8efa86$export$78b37f7430a7646c = (step, beforeDoc, afterDoc)=>{
    try {
        if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $1A89X.SetAttrsStep)) {
            const attrStepAfter = afterDoc.nodeAt(step.pos);
            const attrStepBefore = beforeDoc.nodeAt(step.pos);
            // The change affected the document
            if (attrStepAfter && attrStepBefore && !attrStepAfter.eq(attrStepBefore)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};





const $112c13fed0acd0fd$var$extractMarkStep = (step)=>{
    if (step instanceof (0, $eOaGc.AddMarkStep)) return {
        type: 'add',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    if (step instanceof (0, $eOaGc.RemoveMarkStep)) return {
        type: 'remove',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    return undefined;
};
const $112c13fed0acd0fd$export$cb37e032b0f65b99 = (steps)=>{
    const resultRanges = [];
    let lastOp;
    for (const step of steps){
        const op = $112c13fed0acd0fd$var$extractMarkStep(step);
        if (!op) continue;
        // Check if previous operation cancels this one
        if (lastOp && lastOp.from === op.from && lastOp.to === op.to && lastOp.markName === op.markName && lastOp.type !== op.type) resultRanges.pop();
        else resultRanges.push({
            fromB: op.from,
            toB: op.to
        });
        lastOp = op;
    }
    return resultRanges;
};







var $aPdNQ = parcelRequire("aPdNQ");




function $1958099bac1d5a54$export$e2f3b3d89f27d105(changes) {
    if (changes.length <= 1) return changes;
    const optimized = [];
    let current = {
        ...changes[0]
    };
    for(let i = 1; i < changes.length; i++){
        const next = changes[i];
        // Check if changes are adjacent or very close (within 2 positions)
        const isAdjacent = next.fromB <= current.toB + 2;
        if (isAdjacent) current = {
            fromA: current.fromA,
            toA: Math.max(current.toA, next.toA),
            fromB: current.fromB,
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            optimized.push(current);
            current = {
                ...next
            };
        }
    }
    optimized.push(current);
    return optimized;
}


// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $77c6f9f7c3b6c582$var$WORD_CHAR_REGEX = RegExp("[\\p{L}\\p{N}_]", "u");
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $77c6f9f7c3b6c582$var$PUNCTUATION_REGEX = RegExp("\\p{P}", "u");
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $77c6f9f7c3b6c582$var$WHITESPACE_REGEX = /\s/u;
const $77c6f9f7c3b6c582$var$mapPosition = (mapping, pos)=>mapping.map(pos);
/**
 * Build a per-content-offset view of the textblock's characters.
 *
 * Returns an array `chars` whose length is `parent.content.size`. For every
 * offset that lies inside a text node, `chars[offset]` is the character at
 * that offset; for every offset that lies inside (or on the edge of) a
 * non-text inline node — hardBreak, mention, emoji, date, etc. — the entry
 * is `null`.
 *
 * Using doc positions to index `parent.textContent` is wrong because
 * `textContent` strips non-text inline nodes, so every such node shifts the
 * lookup off by its size. This per-offset view restores a 1:1 mapping between
 * doc positions inside the textblock and the character (or "no character",
 * i.e. a hard word boundary) at that position.
 */ const $77c6f9f7c3b6c582$var$buildCharsByOffset = (parent)=>{
    const chars = new Array(parent.content.size).fill(null);
    parent.content.forEach((child, offset)=>{
        if (!child.isText) return;
        const text = child.text ?? '';
        for(let i = 0; i < text.length; i++)chars[offset + i] = text[i];
    });
    return chars;
};
/**
 * Given a ProseMirror doc and a position range [from, to], expand
 * both endpoints outward to the nearest word boundaries.
 *
 * A "word character" is any Unicode letter/number or underscore. Punctuation is
 * treated as part of the same token only when it is sandwiched between two
 * non-whitespace characters, so contractions like "You'll", accented words like
 * "l'été", and punctuation-joined tokens like "deep-sea" or "foo/bar" stay
 * intact without treating standalone punctuation as a general word character.
 * Expansion stops at whitespace, standalone punctuation, the boundary of any
 * non-text inline node (hardBreak, mention, emoji, date, etc.), or the
 * textblock edges.
 *
 * If `from` and `to` resolve into different parent nodes, or if the
 * parent is not a textblock, the range is returned unchanged.
 */ const $77c6f9f7c3b6c582$var$expandToWordBoundaries = (doc, from, to)=>{
    const $from = doc.resolve(from);
    // Only expand inside a textblock.
    if (!$from.parent.isTextblock) return {
        from: from,
        to: to
    };
    // When `from !== to`, verify both ends are in the same textblock.
    if (from !== to) {
        const $to = doc.resolve(to);
        if ($from.parent !== $to.parent) return {
            from: from,
            to: to
        };
    }
    const parent = $from.parent;
    const parentStart = $from.start(); // absolute position of the first character in the textblock
    // Per-offset view of the textblock so we don't conflate the inline
    // positions of non-text nodes (hardBreak, mention, emoji, date, etc.)
    // with the characters returned by `parent.textContent`.
    const chars = $77c6f9f7c3b6c582$var$buildCharsByOffset(parent);
    // Convert absolute doc positions to zero-based content offsets.
    let fromIdx = from - parentStart;
    let toIdx = to - parentStart;
    // Base word chars are Unicode letters/numbers/underscore. Punctuation only
    // counts when it is surrounded by non-whitespace characters, e.g. in
    // "You'll", "deep-sea", or "foo/bar". `null` still behaves like a hard
    // boundary because only string neighbors qualify.
    const isWordCharAt = (idx)=>{
        if (idx < 0 || idx >= chars.length) return false;
        const ch = chars[idx];
        if (typeof ch !== 'string') return false;
        const prev = chars[idx - 1];
        const next = chars[idx + 1];
        return $77c6f9f7c3b6c582$var$WORD_CHAR_REGEX.test(ch) || $77c6f9f7c3b6c582$var$PUNCTUATION_REGEX.test(ch) && typeof prev === 'string' && typeof next === 'string' && !$77c6f9f7c3b6c582$var$WHITESPACE_REGEX.test(prev) && !$77c6f9f7c3b6c582$var$WHITESPACE_REGEX.test(next);
    };
    // Detect whether the position sits mid-word: there is a word character
    // on both sides of the position (or, for a non-empty range, on the
    // outer side of each endpoint).
    const isMidWord = (idx)=>idx > 0 && idx < chars.length && isWordCharAt(idx - 1) && isWordCharAt(idx);
    // For a zero-width range (pure insertion / deletion point), only expand
    // if the point is mid-word — i.e. both the char before and after are
    // word characters. Otherwise the point is already at a word boundary.
    if (from === to) {
        if (!isMidWord(fromIdx)) return {
            from: from,
            to: to
        };
        // Expand both directions from the mid-word point.
        while(fromIdx > 0 && isWordCharAt(fromIdx - 1))fromIdx--;
        while(toIdx < chars.length && isWordCharAt(toIdx))toIdx++;
        return {
            from: parentStart + fromIdx,
            to: parentStart + toIdx
        };
    }
    // Non-empty range: expand each endpoint outward if it is mid-word.
    // Expand left only if `from` is truly mid-word: the character at `from`
    // (inside the range) and the character before `from` are both word chars.
    if (fromIdx > 0 && fromIdx < chars.length && isWordCharAt(fromIdx) && isWordCharAt(fromIdx - 1)) while(fromIdx > 0 && isWordCharAt(fromIdx - 1))fromIdx--;
    // Expand right only if `to` is truly mid-word: the character just before
    // `to` (last char of the range) and the character at `to` are both word chars.
    if (toIdx > 0 && toIdx < chars.length && isWordCharAt(toIdx - 1) && isWordCharAt(toIdx)) while(toIdx < chars.length && isWordCharAt(toIdx))toIdx++;
    return {
        from: parentStart + fromIdx,
        to: parentStart + toIdx
    };
};
/**
 * Compare marks between two nodes
 * We have to check each child because adding a mark splits text into multiple nodes
 */ const $77c6f9f7c3b6c582$var$hasSameChildMarks = (left, right)=>{
    if (left.childCount !== right.childCount) return false;
    for(let index = 0; index < left.childCount; index++){
        if (!(0, $aPdNQ.Mark).sameSet(left.child(index).marks, right.child(index).marks)) return false;
    }
    return true;
};
const $77c6f9f7c3b6c582$var$createMapping = (maps)=>{
    const mapping = new (0, $eOaGc.Mapping)();
    for (const map of maps)mapping.appendMap(map);
    return mapping;
};
const $77c6f9f7c3b6c582$var$createSpans = (length)=>length > 0 ? [
        {
            length: length,
            data: null
        }
    ] : [];
const $77c6f9f7c3b6c582$var$mergeOverlappingByNewDocRange = (changes)=>{
    if (changes.length <= 1) return changes;
    const sortedChanges = [
        ...changes
    ].sort((left, right)=>left.fromB - right.fromB);
    const merged = [];
    let current = {
        ...sortedChanges[0]
    };
    for(let i = 1; i < sortedChanges.length; i++){
        const next = sortedChanges[i];
        const isOverlapping = next.fromB <= current.toB;
        if (isOverlapping) current = {
            fromA: Math.min(current.fromA, next.fromA),
            toA: Math.max(current.toA, next.toA),
            fromB: Math.min(current.fromB, next.fromB),
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            merged.push(current);
            current = {
                ...next
            };
        }
    }
    merged.push(current);
    return merged;
};
/**
 * This function checks whether to do granular diffing.
 * We should do granular diffing if:
 * - The step is a replace step
 * - The step is not open
 * - The replaced slice is not open
 * - The replaced slice has only one child
 * - The replacing slice has only one child
 * - The replaced slice and replacing slice have the same text content
 * - The replaced slice and replacing slice have the same child marks (if text content is equal)
 */ const $77c6f9f7c3b6c582$var$shouldCheckGranularDiff = (step, before, from, to)=>{
    if (!(step instanceof (0, $eOaGc.ReplaceStep))) return false;
    if (step.slice.openStart !== 0 || step.slice.openEnd !== 0) return false;
    const replacedSlice = before.slice(from, to);
    const replacingSlice = step.slice;
    if (replacedSlice.openStart !== 0 || replacedSlice.openEnd !== 0 || replacedSlice.content.childCount !== 1 || replacingSlice.content.childCount !== 1) return false;
    const replacedNode = replacedSlice.content.firstChild;
    const replacingNode = replacingSlice.content.firstChild;
    if (replacedNode?.type.name !== replacingNode?.type.name || !replacedNode?.type.isTextblock) return false;
    if (!(0, $aPdNQ.Mark).sameSet(replacedNode?.marks ?? [], replacingNode?.marks ?? [])) return false;
    const isTextContentEqual = replacedNode?.textContent === replacingNode?.textContent;
    return !isTextContentEqual || isTextContentEqual && $77c6f9f7c3b6c582$var$hasSameChildMarks(replacedNode, replacingNode);
};
const $77c6f9f7c3b6c582$export$3dfa1fc8b4a78d32 = (originalDoc, steps)=>{
    const changes = [];
    let currentDoc = originalDoc;
    const successfulStepMaps = [];
    const rangedSteps = [];
    for (const step of steps){
        const before = currentDoc;
        const result = step.apply(currentDoc);
        if (result.failed !== null || !result.doc) continue;
        const stepMap = step.getMap();
        const rangeStep = step;
        if (typeof rangeStep.from === 'number' && typeof rangeStep.to === 'number') rangedSteps.push({
            before: before,
            doc: result.doc,
            from: rangeStep.from,
            to: rangeStep.to,
            mapIndex: successfulStepMaps.length,
            step: step,
            stepMap: stepMap
        });
        successfulStepMaps.push(stepMap);
        currentDoc = result.doc;
    }
    for (const rangedStep of rangedSteps){
        // Mapping from original -> doc before this step.
        const originalToBeforeStep = $77c6f9f7c3b6c582$var$createMapping(successfulStepMaps.slice(0, rangedStep.mapIndex));
        const beforeStepToOriginal = originalToBeforeStep.invert();
        const fromA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, rangedStep.from);
        const toA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, rangedStep.to);
        // Map the step range into final steppedDoc coordinates.
        const fromAfterStep = rangedStep.stepMap.map(rangedStep.from, -1);
        const toAfterStep = rangedStep.stepMap.map(rangedStep.to, 1);
        const afterStepToFinal = $77c6f9f7c3b6c582$var$createMapping(successfulStepMaps.slice(rangedStep.mapIndex + 1));
        const fromB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, fromAfterStep);
        const toB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, toAfterStep);
        if ($77c6f9f7c3b6c582$var$shouldCheckGranularDiff(rangedStep.step, rangedStep.before, rangedStep.from, rangedStep.to)) {
            const granularStepChanges = (0, $dFI5z.ChangeSet).create(rangedStep.before).addSteps(rangedStep.doc, [
                rangedStep.stepMap
            ], null);
            // `simplifyChanges` reads text using `Change.fromB`/`toB`, which are
            // positions in the post-step doc (the "B" doc). Passing the pre-step
            // doc (`startDoc`) misreads characters and produces mid-word cuts
            // (e.g. "deep-s|ea") because word-boundary detection runs against the
            // wrong text/positions. Use the post-step doc here.
            const optimizedGranularStepChanges = (0, $1958099bac1d5a54$export$e2f3b3d89f27d105)((0, $dFI5z.simplifyChanges)(granularStepChanges.changes, rangedStep.doc));
            for (const granularChange of optimizedGranularStepChanges){
                // Expand each granular change to the nearest word boundaries in
                // both the pre-step doc (A-side) and the post-step doc (B-side).
                // This ensures that a mid-word edit like "sanitised" → "sanitized"
                // shows as deleting the whole original word and inserting the whole
                // new word, rather than a single-character swap.
                const expandedA = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.before, granularChange.fromA, granularChange.toA);
                const expandedB = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.doc, granularChange.fromB, granularChange.toB);
                // When one side expanded further than the other (e.g. a space
                // was inserted mid-word: "altogether" → "all together"), the
                // less-expanded side must grow to match — otherwise the renderer
                // shows a partial word as plain text next to a deletion/insertion.
                // We compare left and right deltas independently so partial
                // expansion on one side doesn't prevent the other side from
                // being pulled out further.
                const aLeftDelta = granularChange.fromA - expandedA.from;
                const aRightDelta = expandedA.to - granularChange.toA;
                const bLeftDelta = granularChange.fromB - expandedB.from;
                const bRightDelta = expandedB.to - granularChange.toB;
                let finalA = expandedA;
                let finalB = expandedB;
                // If A expanded further on either side, nudge B outward
                // by the excess and re-expand to snap to word boundaries.
                if (aLeftDelta > bLeftDelta || aRightDelta > bRightDelta) {
                    const extraLeft = Math.max(0, aLeftDelta - bLeftDelta);
                    const extraRight = Math.max(0, aRightDelta - bRightDelta);
                    finalB = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.doc, Math.max(expandedB.from - extraLeft, 0), expandedB.to + extraRight);
                }
                // If B expanded further on either side, nudge A outward.
                if (bLeftDelta > aLeftDelta || bRightDelta > aRightDelta) {
                    const extraLeft = Math.max(0, bLeftDelta - aLeftDelta);
                    const extraRight = Math.max(0, bRightDelta - aRightDelta);
                    finalA = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.before, Math.max(expandedA.from - extraLeft, 0), expandedA.to + extraRight);
                }
                const granularFromA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, finalA.from);
                const granularToA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, finalA.to);
                const granularFromB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, finalB.from);
                const granularToB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, finalB.to);
                changes.push({
                    fromA: granularFromA,
                    toA: granularToA,
                    fromB: granularFromB,
                    toB: granularToB,
                    deleted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, granularToA - granularFromA)),
                    inserted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, granularToB - granularFromB))
                });
            }
            continue;
        }
        changes.push({
            fromA: fromA,
            toA: toA,
            fromB: fromB,
            toB: toB,
            deleted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, toA - fromA)),
            inserted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, toB - fromB))
        });
    }
    return $77c6f9f7c3b6c582$var$mergeOverlappingByNewDocRange(changes);
};
const $77c6f9f7c3b6c582$export$cafca9d74d24384b = (originalDoc, steps)=>{
    const result = [];
    let currentDoc = originalDoc;
    const successfulStepMaps = [];
    const rangedSteps = [];
    for (const step of steps){
        const before = currentDoc;
        const stepResult = step.apply(currentDoc);
        if (stepResult.failed !== null || !stepResult.doc) continue;
        const stepMap = step.getMap();
        const rangeStep = step;
        if (typeof rangeStep.from === 'number' && typeof rangeStep.to === 'number') rangedSteps.push({
            before: before,
            doc: stepResult.doc,
            from: rangeStep.from,
            to: rangeStep.to,
            mapIndex: successfulStepMaps.length,
            step: step,
            stepMap: stepMap
        });
        successfulStepMaps.push(stepMap);
        currentDoc = stepResult.doc;
    }
    for (const rangedStep of rangedSteps){
        const originalToBeforeStep = $77c6f9f7c3b6c582$var$createMapping(successfulStepMaps.slice(0, rangedStep.mapIndex));
        const beforeStepToOriginal = originalToBeforeStep.invert();
        const fromA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, rangedStep.from);
        const toA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, rangedStep.to);
        const fromAfterStep = rangedStep.stepMap.map(rangedStep.from, -1);
        const toAfterStep = rangedStep.stepMap.map(rangedStep.to, 1);
        const afterStepToFinal = $77c6f9f7c3b6c582$var$createMapping(successfulStepMaps.slice(rangedStep.mapIndex + 1));
        const fromB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, fromAfterStep);
        const toB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, toAfterStep);
        if ($77c6f9f7c3b6c582$var$shouldCheckGranularDiff(rangedStep.step, rangedStep.before, rangedStep.from, rangedStep.to)) {
            const granularStepChanges = (0, $dFI5z.ChangeSet).create(rangedStep.before).addSteps(rangedStep.doc, [
                rangedStep.stepMap
            ], null);
            const optimizedGranularStepChanges = (0, $1958099bac1d5a54$export$e2f3b3d89f27d105)((0, $dFI5z.simplifyChanges)(granularStepChanges.changes, rangedStep.doc));
            const stepChanges = [];
            for (const granularChange of optimizedGranularStepChanges){
                const expandedA = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.before, granularChange.fromA, granularChange.toA);
                const expandedB = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.doc, granularChange.fromB, granularChange.toB);
                const aLeftDelta = granularChange.fromA - expandedA.from;
                const aRightDelta = expandedA.to - granularChange.toA;
                const bLeftDelta = granularChange.fromB - expandedB.from;
                const bRightDelta = expandedB.to - granularChange.toB;
                let finalA = expandedA;
                let finalB = expandedB;
                if (aLeftDelta > bLeftDelta || aRightDelta > bRightDelta) {
                    const extraLeft = Math.max(0, aLeftDelta - bLeftDelta);
                    const extraRight = Math.max(0, aRightDelta - bRightDelta);
                    finalB = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.doc, Math.max(expandedB.from - extraLeft, 0), expandedB.to + extraRight);
                }
                if (bLeftDelta > aLeftDelta || bRightDelta > aRightDelta) {
                    const extraLeft = Math.max(0, bLeftDelta - aLeftDelta);
                    const extraRight = Math.max(0, bRightDelta - aRightDelta);
                    finalA = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.before, Math.max(expandedA.from - extraLeft, 0), expandedA.to + extraRight);
                }
                stepChanges.push({
                    fromA: $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, finalA.from),
                    toA: $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, finalA.to),
                    fromB: $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, finalB.from),
                    toB: $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, finalB.to),
                    deleted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, finalA.to - finalA.from)),
                    inserted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, finalB.to - finalB.from))
                });
            }
            result.push({
                isGranular: true,
                changes: $77c6f9f7c3b6c582$var$mergeOverlappingByNewDocRange(stepChanges)
            });
            continue;
        }
        result.push({
            isGranular: false,
            changes: [
                {
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB,
                    deleted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, toA - fromA)),
                    inserted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, toB - fromB))
                }
            ]
        });
    }
    return result;
};


function $b0bf35342ffa1121$export$db7650118b60a5b3(doc, from, to) {
    return {
        from: doc.resolve(from).before(1),
        to: doc.resolve(to).after(1)
    };
}
function $b0bf35342ffa1121$export$a0c7c7ce83d8783e(changes, docA, docB) {
    const groups = new Map();
    for (const change of changes){
        const blockA = $b0bf35342ffa1121$export$db7650118b60a5b3(docA, change.fromA, change.toA);
        const blockB = $b0bf35342ffa1121$export$db7650118b60a5b3(docB, change.fromB, change.toB);
        if (!groups.has(blockB.from)) groups.set(blockB.from, {
            fromB: blockB.from,
            toB: blockB.to,
            fromA: blockA ? blockA.from : change.fromA,
            toA: blockA ? blockA.to : change.toA,
            changed: []
        });
        const group = groups.get(blockB.from);
        if (group) group.changed = [
            ...group.changed,
            ...change.inserted,
            ...change.deleted
        ];
    }
    return Array.from(groups.values()).sort((a, b)=>a.fromB - b.fromB).map(({ fromA: fromA, toA: toA, fromB: fromB, toB: toB, changed: changed })=>({
            fromA: fromA,
            toA: toA,
            fromB: fromB,
            toB: toB,
            /**
			 * We add all changes (both deleted and inserted) as that will
			 * inform the calculateDiffDecorations function that changes should be rendered
			 * (even if the change is only one of the two).
			 */ deleted: changed,
            inserted: changed
        }));
}




var $l5rX3 = parcelRequire("l5rX3");







/**
 * Attempts to merge two consecutive ReplaceStep operations.
 * This merges steps where:
 * - Both steps replace content at the same starting position
 * - The second step's range encompasses the first step's range
 * - The second step has content to insert
 * Returns null if steps cannot be merged.
 */ function $c2a675ff129cc20a$var$mergeReplaceSteps(step1, step2) {
    if (!(step1 instanceof (0, $eOaGc.ReplaceStep)) || !(step2 instanceof (0, $eOaGc.ReplaceStep))) return null;
    // Confirm the step overlaps exactly with the previous
    const step2Length = step2.to - step2.from;
    if (step1.from === step2.from && step2.to >= step1.to && step2.slice.size >= step2Length && step2Length === step1.slice.size && step2.slice.size >= step1.slice.size && step1.slice.openEnd === step2.slice.openEnd && step1.slice.openStart === step2.slice.openStart) return new (0, $eOaGc.ReplaceStep)(step1.from, step1.to, step2.slice);
    return null;
}
function $c2a675ff129cc20a$export$320ba57788df881b(steps, originalDoc) {
    const stepsToFilter = $c2a675ff129cc20a$var$removeUnusedSteps(steps, originalDoc);
    return stepsToFilter// Remove steps that don't affect document structure or content
    .filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep)))// Merge consecutive steps where possible
    .reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        const merged = lastStep?.merge?.(step) ?? $c2a675ff129cc20a$var$mergeReplaceSteps(lastStep, step);
        if (merged) acc[acc.length - 1] = merged;
        else acc.push(step);
        return acc;
    }, []);
}
/**
 * Does a first pass to remove steps that don't impact the document
 */ function $c2a675ff129cc20a$var$removeUnusedSteps(steps, originalDoc) {
    const finalSteps = [];
    let firstPassDoc = originalDoc;
    for (const step of steps){
        const result = step.apply(firstPassDoc);
        if (result.failed === null && result.doc && !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(firstPassDoc, result.doc, [
            'localId'
        ])) {
            finalSteps.push(step);
            firstPassDoc = result.doc;
        }
    }
    return finalSteps;
}


const $5a823ae841a62560$export$c71ba38a098bdec3 = (length, data = null)=>length > 0 ? [
        {
            length: length,
            data: data
        }
    ] : [];
const $5a823ae841a62560$export$71d4e291db87dd0a = (fromA, toA, fromB, toB, level)=>{
    const data = level ? {
        smartLevel: level
    } : null;
    // `deleted` and `inserted` must be independent arrays: downstream code may mutate one
    // side (push/splice), which would silently corrupt the other if they shared a reference.
    return {
        fromA: fromA,
        toA: toA,
        fromB: fromB,
        toB: toB,
        deleted: $5a823ae841a62560$export$c71ba38a098bdec3(Math.max(0, toA - fromA), data),
        inserted: $5a823ae841a62560$export$c71ba38a098bdec3(Math.max(0, toB - fromB), data)
    };
};
const $5a823ae841a62560$export$bd99dc0a81d559c2 = (change)=>{
    const spans = [
        ...change.inserted,
        ...change.deleted
    ];
    for (const span of spans){
        const data = span.data;
        if (data && typeof data === 'object' && 'smartLevel' in data) return data.smartLevel;
    }
    return undefined;
};
/** True when a change has no original-side (deleted) content — a pure insertion. */ const $5a823ae841a62560$var$isPureInsertion = (change)=>change.toA <= change.fromA;
const $5a823ae841a62560$export$866b12e69287308f = (changes)=>{
    if (changes.length <= 1) return changes;
    const sorted = [
        ...changes
    ].sort((l, r)=>l.fromB - r.fromB);
    const merged = [];
    let current = {
        ...sorted[0]
    };
    for(let i = 1; i < sorted.length; i++){
        const next = sorted[i];
        const bOverlaps = next.fromB <= current.toB;
        // A ranges may be unioned only if they touch, or if either side contributes no A content.
        const aMergeable = $5a823ae841a62560$var$isPureInsertion(current) || $5a823ae841a62560$var$isPureInsertion(next) || $5a823ae841a62560$export$8f43b23b5d8de905(current.fromA, current.toA, next.fromA, next.toA) || next.fromA <= current.toA; // adjacency (sorted by B, A usually monotonic)
        if (bOverlaps && aMergeable) current = {
            fromA: Math.min(current.fromA, next.fromA),
            toA: Math.max(current.toA, next.toA),
            fromB: Math.min(current.fromB, next.fromB),
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            merged.push(current);
            current = {
                ...next
            };
        }
    }
    merged.push(current);
    return merged;
};
const $5a823ae841a62560$export$8f43b23b5d8de905 = (aFrom, aTo, bFrom, bTo)=>aFrom < bTo && bFrom < aTo;


// A character is treated as part of a word unless it is whitespace or common punctuation.
// We deliberately avoid Unicode property escapes (`\p{...}`) and the `u` flag here: the `u`
// flag is only valid when targeting es6+, and the declaration-generation build config for
// this package targets an older lib, which rejects it with TS1501. This negated approach
// keeps word segmentation reasonable across scripts (any non-punctuation, non-space glyph
// counts as a word char) without needing Unicode-aware regex.
const $225246a57078976f$var$NON_WORD_CHARS = " 	\n\r\f\v.,;:!?\u2026\u3002\uFF01\uFF1F\u3001\"'`\u201C\u201D\u2018\u2019()[]{}<>/\\|@#$%^&*-+=~";
const $225246a57078976f$var$NON_WORD_CHAR_SET = new Set($225246a57078976f$var$NON_WORD_CHARS.split(''));
const $225246a57078976f$var$isWordChar = (ch)=>!$225246a57078976f$var$NON_WORD_CHAR_SET.has(ch);
// Whitespace is checked via a Set rather than a regex to avoid both the `require-unicode-regexp`
// lint rule and the TS1501 error the `u` flag triggers under this package's build lib target.
const $225246a57078976f$var$WHITESPACE_CHAR_SET = new Set([
    ' ',
    '\t',
    '\n',
    '\r',
    '\f',
    '\v',
    '\u00a0'
]);
const $225246a57078976f$var$isWhitespaceChar = (ch)=>$225246a57078976f$var$WHITESPACE_CHAR_SET.has(ch);
// Sentence terminators used by the regex fallback. We intentionally keep this small and
// conservative — the Intl.Segmenter path is the source of truth when available.
const $225246a57078976f$var$SENTENCE_TERMINATORS = new Set([
    '.',
    '!',
    '?',
    "\u2026",
    "\u3002",
    "\uFF01",
    "\uFF1F"
]);
const $225246a57078976f$export$48178c209e718bdd = (parent)=>{
    const chars = Array.from({
        length: parent.content.size
    }, ()=>null);
    parent.content.forEach((child, offset)=>{
        if (!child.isText) return;
        const text = child.text ?? '';
        for(let i = 0; i < text.length; i++)chars[offset + i] = text[i];
    });
    return chars;
};
const $225246a57078976f$var$getSegmenterCtor = ()=>{
    if (typeof Intl === 'undefined') return undefined;
    const ctor = Intl.Segmenter;
    return typeof ctor === 'function' ? ctor : undefined;
};
let $225246a57078976f$var$cachedLocale;
let $225246a57078976f$var$cachedSentenceSegmenter;
let $225246a57078976f$var$cachedWordSegmenter;
const $225246a57078976f$var$getSegmenters = (locale)=>{
    const Ctor = $225246a57078976f$var$getSegmenterCtor();
    if (!Ctor) return undefined;
    if ($225246a57078976f$var$cachedLocale !== locale || !$225246a57078976f$var$cachedSentenceSegmenter || !$225246a57078976f$var$cachedWordSegmenter) {
        $225246a57078976f$var$cachedLocale = locale;
        $225246a57078976f$var$cachedSentenceSegmenter = new Ctor(locale, {
            granularity: 'sentence'
        });
        $225246a57078976f$var$cachedWordSegmenter = new Ctor(locale, {
            granularity: 'word'
        });
    }
    return {
        sentence: $225246a57078976f$var$cachedSentenceSegmenter,
        word: $225246a57078976f$var$cachedWordSegmenter
    };
};
/**
 * Convert a char-view into a plain string plus an index map back to content offsets.
 *
 * Opaque inline tokens (`null`) are represented in the string by a single sentinel
 * character (Unicode Object Replacement Character, U+FFFC) so that:
 * - the segmenter treats them as a word-like glyph rather than whitespace/punctuation;
 * - they never look like a sentence terminator.
 * `indexMap[j]` gives the content offset of string index `j`.
 */ const $225246a57078976f$var$OBJECT_REPLACEMENT = '\uFFFC';
const $225246a57078976f$var$flattenChars = (chars)=>{
    let text = '';
    const indexMap = [];
    for(let offset = 0; offset < chars.length; offset++){
        const ch = chars[offset];
        text += ch === null ? $225246a57078976f$var$OBJECT_REPLACEMENT : ch;
        indexMap.push(offset);
    }
    return {
        text: text,
        indexMap: indexMap
    };
};
const $225246a57078976f$var$stringIndexToOffset = (indexMap, strIdx, fallback)=>{
    if (strIdx < 0) return fallback;
    if (strIdx >= indexMap.length) // One-past-the-end maps to the offset after the last char.
    return indexMap.length > 0 ? indexMap[indexMap.length - 1] + 1 : fallback;
    return indexMap[strIdx];
};
const $225246a57078976f$export$37d9b8fca7e28693 = (chars, locale)=>{
    if (chars.length === 0) return [];
    const { text: text, indexMap: indexMap } = $225246a57078976f$var$flattenChars(chars);
    const segmenters = $225246a57078976f$var$getSegmenters(locale);
    if (segmenters) {
        const spans = [];
        for (const seg of segmenters.sentence.segment(text)){
            const startOffset = $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index, 0);
            const endOffset = $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index + seg.segment.length, chars.length);
            if (endOffset > startOffset) spans.push({
                from: startOffset,
                to: endOffset
            });
        }
        return spans.length > 0 ? spans : [
            {
                from: 0,
                to: chars.length
            }
        ];
    }
    // Regex fallback: split after a sentence terminator followed by whitespace/EOL.
    // A `null` (OBJECT_REPLACEMENT) is never a terminator.
    const spans = [];
    let start = 0;
    for(let i = 0; i < chars.length; i++){
        const ch = chars[i];
        if (ch !== null && $225246a57078976f$var$SENTENCE_TERMINATORS.has(ch)) {
            // Consume trailing spaces as part of this sentence.
            let end = i + 1;
            while(end < chars.length && chars[end] !== null && $225246a57078976f$var$isWhitespaceChar(chars[end]))end++;
            spans.push({
                from: start,
                to: end
            });
            start = end;
        }
    }
    if (start < chars.length) spans.push({
        from: start,
        to: chars.length
    });
    return spans.length > 0 ? spans : [
        {
            from: 0,
            to: chars.length
        }
    ];
};
const $225246a57078976f$export$5e9f9da5213092bc = (chars, span, locale)=>{
    const slice = chars.slice(span.from, span.to);
    if (slice.length === 0) return 0;
    const segmenters = $225246a57078976f$var$getSegmenters(locale);
    const { text: text } = $225246a57078976f$var$flattenChars(slice);
    if (segmenters) {
        let count = 0;
        for (const seg of segmenters.word.segment(text))// Object-replacement sentinel is word-like; count it.
        if (seg.isWordLike || seg.segment.includes($225246a57078976f$var$OBJECT_REPLACEMENT)) count++;
        return count;
    }
    // Regex fallback: a run of word chars OR a single opaque token is one word.
    let count = 0;
    let inWord = false;
    for (const ch of slice){
        if (ch === null) {
            count++;
            inWord = false;
            continue;
        }
        if ($225246a57078976f$var$isWordChar(ch)) {
            if (!inWord) {
                count++;
                inWord = true;
            }
        } else inWord = false;
    }
    return count;
};
const $225246a57078976f$export$df862e795a1833f8 = (chars, span, locale)=>{
    const segmenters = $225246a57078976f$var$getSegmenters(locale);
    const slice = chars.slice(span.from, span.to);
    const { text: text, indexMap: indexMap } = $225246a57078976f$var$flattenChars(slice);
    const spans = [];
    if (segmenters) {
        for (const seg of segmenters.word.segment(text))if (seg.isWordLike || seg.segment.includes($225246a57078976f$var$OBJECT_REPLACEMENT)) {
            const from = span.from + $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index, 0);
            const to = span.from + $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index + seg.segment.length, slice.length);
            spans.push({
                from: from,
                to: to
            });
        }
        return spans;
    }
    let wordStart = -1;
    for(let i = 0; i < slice.length; i++){
        const ch = slice[i];
        if (ch === null) {
            if (wordStart !== -1) {
                spans.push({
                    from: span.from + wordStart,
                    to: span.from + i
                });
                wordStart = -1;
            }
            spans.push({
                from: span.from + i,
                to: span.from + i + 1
            });
        } else if ($225246a57078976f$var$isWordChar(ch)) {
            if (wordStart === -1) wordStart = i;
        } else if (wordStart !== -1) {
            spans.push({
                from: span.from + wordStart,
                to: span.from + i
            });
            wordStart = -1;
        }
    }
    if (wordStart !== -1) spans.push({
        from: span.from + wordStart,
        to: span.from + slice.length
    });
    return spans;
};


/**
 * Configurable thresholds for the `smart` diffType.
 *
 * See docs/smart-diff-design.md §3 and §6 for the exact semantics of each level.
 */ const $087e793972840e8d$export$fd5c9e9a18faa986 = {
    sentence: {
        ratio: 0.4,
        minChanged: 2
    },
    paragraph: {
        ratio: 0.4,
        minChanged: 2
    },
    node: {
        ratio: 0.6,
        textBearingRatio: 0.6
    }
};
const $087e793972840e8d$export$fe359b9dc54dc4e0 = (overrides)=>{
    if (!overrides) return $087e793972840e8d$export$fd5c9e9a18faa986;
    return {
        sentence: {
            ...$087e793972840e8d$export$fd5c9e9a18faa986.sentence,
            ...overrides.sentence
        },
        paragraph: {
            ...$087e793972840e8d$export$fd5c9e9a18faa986.paragraph,
            ...overrides.paragraph
        },
        node: {
            ...$087e793972840e8d$export$fd5c9e9a18faa986.node,
            ...overrides.node
        }
    };
};


const $2be352b0f93592ab$export$c15105fe770d78d4 = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc, locale: locale, thresholds: overrides })=>{
    if (changes.length === 0) return changes;
    const thresholds = (0, $087e793972840e8d$export$fe359b9dc54dc4e0)(overrides);
    const groups = $2be352b0f93592ab$var$groupByTopLevelBlock(changes, originalDoc, newDoc);
    const result = [];
    for (const group of groups)result.push(...$2be352b0f93592ab$var$classifyBlockGroup(group, originalDoc, newDoc, locale, thresholds));
    // Clamp to valid bounds (defensive) and coalesce overlaps.
    const maxA = originalDoc.content.size;
    const maxB = newDoc.content.size;
    const clamped = result.map((change)=>$2be352b0f93592ab$var$clampChange(change, maxA, maxB)).filter((change)=>change !== null);
    return (0, $5a823ae841a62560$export$866b12e69287308f)(clamped);
};
/**
 * Group changes by the top-level block (direct child of doc) they touch, aligning the A-side
 * and B-side blocks a change covers. A single change can span MULTIPLE top-level blocks (e.g.
 * a ReplaceStep whose slice contains several nodes); we enumerate every block it overlaps on
 * both sides (`topLevelBlocksInRange`) and create one group per aligned block, so added/removed
 * blocks in a multi-node replacement are never dropped. Unlike `groupChangesByBlock`, we KEEP
 * each group's constituent raw changes so intra-block density can be measured.
 */ const $2be352b0f93592ab$var$groupByTopLevelBlock = (changes, docA, docB)=>{
    const groups = new Map();
    const ensureGroup = (blockA, blockB, anchors)=>{
        if (!blockA && !blockB) return null;
        // Key by both sides so an added block (blockA=null) on the B side and a deleted block
        // (blockB=null) on the A side each get their own group.
        const key = `${blockB ? blockB.from : 'x'}:${blockA ? blockA.from : 'x'}`;
        let group = groups.get(key);
        if (!group) {
            group = {
                blockA: blockA,
                blockB: blockB,
                changes: [],
                ...anchors
            };
            groups.set(key, group);
        }
        return group;
    };
    for (const change of changes){
        // A single change (e.g. a ReplaceStep whose slice spans several nodes) can cover MULTIPLE
        // top-level blocks on either side. Resolving only the block at `fromB` would silently drop
        // the extra blocks (e.g. an added table after a replaced paragraph). So we enumerate every
        // top-level block the change overlaps on BOTH sides and create a group per aligned block.
        const blocksB = $2be352b0f93592ab$var$topLevelBlocksInRange(docB, change.fromB, change.toB);
        const blocksA = $2be352b0f93592ab$var$topLevelBlocksInRange(docA, change.fromA, change.toA);
        // Simple, common case: exactly one block on each side (or one side empty).
        if (blocksB.length <= 1 && blocksA.length <= 1) {
            const group = ensureGroup(blocksA[0] ?? null, blocksB[0] ?? null);
            group?.changes.push(change);
            continue;
        }
        // Multi-block span: align blocks positionally by index. The first `min(len)` blocks are
        // REPLACEMENTS (paired A↔B). Extra B-blocks are PURE INSERTIONS and extra A-blocks are
        // PURE DELETIONS — and, crucially, these must NOT reuse the raw change's full A/B range
        // (that range covers the paired blocks too, so an added block would claim the original
        // content already owned by a paired replacement, rendering it deleted twice). Instead we
        // anchor a pure insertion's A side (and a pure deletion's B side) as ZERO-WIDTH at the
        // end of the last paired block on the opposite side.
        const paired = Math.min(blocksA.length, blocksB.length);
        for(let i = 0; i < paired; i++){
            const group = ensureGroup(blocksA[i], blocksB[i]);
            group?.changes.push(change);
        }
        // Anchor for extras = end of the last paired block on the opposite side (or the start of
        // the span if there were no paired blocks).
        const anchorA = paired > 0 ? blocksA[paired - 1].to : change.fromA;
        const anchorB = paired > 0 ? blocksB[paired - 1].to : change.fromB;
        for(let i = paired; i < blocksB.length; i++){
            const group = ensureGroup(null, blocksB[i], {
                anchorA: anchorA
            });
            group?.changes.push(change);
        }
        for(let i = paired; i < blocksA.length; i++){
            const group = ensureGroup(blocksA[i], null, {
                anchorB: anchorB
            });
            group?.changes.push(change);
        }
    }
    return Array.from(groups.values()).sort((a, b)=>(a.blockB?.from ?? a.blockA?.from ?? 0) - (b.blockB?.from ?? b.blockA?.from ?? 0));
};
/**
 * Enumerate the top-level blocks (direct children of doc) whose outer range overlaps
 * `[from, to)`. Returns each as a BlockRef. Used to split a change that spans several blocks.
 */ const $2be352b0f93592ab$var$topLevelBlocksInRange = (doc, from, to)=>{
    const lo = Math.min(Math.max(from, 0), doc.content.size);
    const hi = Math.min(Math.max(to, lo), doc.content.size);
    const refs = [];
    let offset = 0;
    for(let i = 0; i < doc.childCount; i++){
        const node = doc.child(i);
        const blockFrom = offset;
        const blockTo = offset + node.nodeSize;
        // Overlap test; include a zero-width touch at the block start (pure insertion point).
        if (blockFrom < hi && blockTo > lo) refs.push({
            node: node,
            from: blockFrom,
            to: blockTo
        });
        else if (blockFrom === lo && blockFrom === hi) refs.push({
            node: node,
            from: blockFrom,
            to: blockTo
        });
        offset = blockTo;
    }
    return refs;
};
const $2be352b0f93592ab$var$clampChange = (change, maxA, maxB)=>{
    const fromA = Math.max(0, Math.min(change.fromA, maxA));
    const toA = Math.max(fromA, Math.min(change.toA, maxA));
    const fromB = Math.max(0, Math.min(change.fromB, maxB));
    const toB = Math.max(fromB, Math.min(change.toB, maxB));
    if (toA === fromA && toB === fromB) return null;
    return {
        ...change,
        fromA: fromA,
        toA: toA,
        fromB: fromB,
        toB: toB
    };
};
const $2be352b0f93592ab$var$TEXT_BLOCK_TYPES = new Set([
    'paragraph',
    'heading'
]);
/**
 * Rigid children cannot be individually deleted+re-inserted without breaking their parent's
 * structure — promoting one escalates to its structural unit (see classifyContainer):
 *   layoutColumn → layoutSection, tableCell/tableHeader → tableRow → table.
 */ const $2be352b0f93592ab$var$RIGID_CHILD_TYPES = new Set([
    'layoutColumn',
    'tableCell',
    'tableHeader'
]);
const $2be352b0f93592ab$var$TABLE_TYPE = 'table';
/**
 * Emit a single whole-block (node-level) change covering both sides of a group. Used for
 * structural / node-type replacements and for containers dense enough to replace wholesale.
 */ const $2be352b0f93592ab$var$wholeBlockChange = (blockA, blockB, changes, anchors)=>{
    // Pure insertion (blockA === null): the A side must be a ZERO-WIDTH anchor, never the raw
    // change's A range (which spans sibling blocks that were separately replaced). Same for a
    // pure deletion's B side. Falling back to the change coords is the last-resort path when no
    // anchor was supplied (single-block insert/delete, where the coords are already zero-width).
    const fromA = blockA ? blockA.from : anchors?.anchorA ?? changes[0].fromA;
    const toA = blockA ? blockA.to : anchors?.anchorA ?? changes[changes.length - 1].toA;
    const fromB = blockB ? blockB.from : anchors?.anchorB ?? changes[0].fromB;
    const toB = blockB ? blockB.to : anchors?.anchorB ?? changes[changes.length - 1].toB;
    return (0, $5a823ae841a62560$export$71d4e291db87dd0a)(fromA, toA, fromB, toB, 'node');
};
/**
 * Classify one block group. This is the single recursive decision point:
 *  - one side missing (pure insert/delete)   → whole block
 *  - node type changed (para→panel, list→table, heading→para, …) → whole block
 *  - text-bearing block                       → sentence / paragraph / inline
 *  - container                                → recurse into children (with rigid escalation)
 */ const $2be352b0f93592ab$var$classifyBlockGroup = (group, originalDoc, newDoc, locale, thresholds)=>{
    const { blockA: blockA, blockB: blockB, changes: changes, anchorA: anchorA, anchorB: anchorB } = group;
    // Pure insertion or deletion of a whole block.
    if (!blockA || !blockB) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes, {
            anchorA: anchorA,
            anchorB: anchorB
        })
    ];
    // Node-type / structural change: the whole block was replaced. No further analysis — this
    // is what makes list→table, paragraph→panel, heading→paragraph "just work".
    if (blockA.node.type.name !== blockB.node.type.name) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    // Text-bearing block → sentence / paragraph / inline.
    if ($2be352b0f93592ab$var$TEXT_BLOCK_TYPES.has(blockB.node.type.name)) return $2be352b0f93592ab$var$classifyTextblock(blockA, blockB, changes, locale, thresholds);
    // Container block → measure changed-child density, promote whole container or recurse.
    return $2be352b0f93592ab$var$classifyContainer(blockA, blockB, changes, originalDoc, newDoc, locale, thresholds);
};
/**
 * Sentence- and paragraph-level classification for a single text-bearing block.
 */ const $2be352b0f93592ab$var$classifyTextblock = (blockA, blockB, changes, locale, thresholds)=>{
    const charsB = (0, $225246a57078976f$export$48178c209e718bdd)(blockB.node);
    const sentencesB = (0, $225246a57078976f$export$37d9b8fca7e28693)(charsB, locale);
    const charsA = (0, $225246a57078976f$export$48178c209e718bdd)(blockA.node);
    const sentencesA = (0, $225246a57078976f$export$37d9b8fca7e28693)(charsA, locale);
    // Block content starts one position after the block's outer start (open token).
    const contentStartB = blockB.from + 1;
    // Map each change to the sentence indices (new-doc offset space) it overlaps.
    const changedSentenceIdx = new Set();
    const perSentenceChanges = new Map();
    for (const change of changes){
        const fromOff = change.fromB - contentStartB;
        const toOff = change.toB - contentStartB;
        for(let s = 0; s < sentencesB.length; s++){
            const sentence = sentencesB[s];
            if ((0, $5a823ae841a62560$export$8f43b23b5d8de905)(fromOff, Math.max(toOff, fromOff + 1), sentence.from, sentence.to)) {
                changedSentenceIdx.add(s);
                let list = perSentenceChanges.get(s);
                if (!list) {
                    list = [];
                    perSentenceChanges.set(s, list);
                }
                list.push(change);
            }
        }
    }
    // Level 2: paragraph promotion.
    const sentenceDenom = Math.max(sentencesA.length, sentencesB.length, 1);
    const sentencesChanged = changedSentenceIdx.size;
    if (sentencesChanged >= thresholds.paragraph.minChanged && sentencesChanged / sentenceDenom >= thresholds.paragraph.ratio) return [
        (0, $5a823ae841a62560$export$71d4e291db87dd0a)(blockA.from, blockA.to, blockB.from, blockB.to, 'paragraph')
    ];
    // Level 1: per-sentence promotion (else keep inline changes).
    const contentStartA = blockA.from + 1;
    const out = [];
    for (const [sIdx, sentenceChanges] of perSentenceChanges.entries()){
        const sentence = sentencesB[sIdx];
        const wordsNew = (0, $225246a57078976f$export$5e9f9da5213092bc)(charsB, sentence, locale);
        const sentA = sentencesA[sIdx];
        const wordsOld = sentA ? (0, $225246a57078976f$export$5e9f9da5213092bc)(charsA, sentA, locale) : 0;
        const wordSpans = (0, $225246a57078976f$export$df862e795a1833f8)(charsB, sentence, locale);
        let wordsChanged = 0;
        for (const w of wordSpans){
            const overlaps = sentenceChanges.some((c)=>(0, $5a823ae841a62560$export$8f43b23b5d8de905)(c.fromB - contentStartB, Math.max(c.toB - contentStartB, c.fromB - contentStartB + 1), w.from, w.to));
            if (overlaps) wordsChanged++;
        }
        const wordDenom = Math.max(wordsOld, wordsNew, 1);
        if (wordsChanged >= thresholds.sentence.minChanged && wordsChanged / wordDenom >= thresholds.sentence.ratio) {
            const fromB = contentStartB + sentence.from;
            const toB = contentStartB + sentence.to;
            const fromA = sentA ? contentStartA + sentA.from : sentenceChanges[0].fromA;
            const toA = sentA ? contentStartA + sentA.to : sentenceChanges[0].toA;
            out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(fromA, toA, fromB, toB, 'sentence'));
        } else out.push(...sentenceChanges);
    }
    return out;
};
/** Resolve the direct children of a container node (whose OUTER start is `blockFrom`). */ const $2be352b0f93592ab$var$childRefs = (block)=>{
    const refs = [];
    let offset = block.from + 1; // content starts after the container's open token
    block.node.forEach((child, _, index)=>{
        refs.push({
            node: child,
            from: offset,
            to: offset + child.nodeSize,
            index: index
        });
        offset += child.nodeSize;
    });
    return refs;
};
/** Which direct-child indices of `block` are touched by any of `changes` (new-doc coords). */ const $2be352b0f93592ab$var$changedChildIndices = (block, children, changes)=>{
    const changed = new Set();
    for (const child of children){
        const touched = changes.some((c)=>(0, $5a823ae841a62560$export$8f43b23b5d8de905)(c.fromB, Math.max(c.toB, c.fromB + 1), child.from, child.to));
        if (touched) changed.add(child.index);
    }
    return changed;
};
/**
 * Align a container's A-side and B-side direct children via an LCS over their serialized
 * content. This is essential because index alignment (`childrenA[childB.index]`) breaks the
 * moment a child is inserted or removed: every child after the insertion/deletion point would
 * be mis-paired, causing added items to be classified against the wrong (or a B-side) original
 * child — which corrupts the A-side coordinates and makes one list's deletions surface under a
 * different block. The LCS pairs identical children as "matched" (unchanged, skipped later),
 * leaving genuinely added children as B-only and removed children as A-only.
 */ const $2be352b0f93592ab$var$alignChildren = (childrenA, childrenB)=>{
    const keyA = childrenA.map((c)=>JSON.stringify(c.node.toJSON()));
    const keyB = childrenB.map((c)=>JSON.stringify(c.node.toJSON()));
    const n = childrenA.length;
    const m = childrenB.length;
    // LCS length table.
    const lcs = Array.from({
        length: n + 1
    }, ()=>Array.from({
            length: m + 1
        }, ()=>0));
    for(let i = n - 1; i >= 0; i--)for(let j = m - 1; j >= 0; j--)lcs[i][j] = keyA[i] === keyB[j] ? lcs[i + 1][j + 1] + 1 : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
    // Backtrack. Identical children become matched anchors. Runs of non-identical children
    // between anchors are "zipped" positionally into modified pairs (a & b), with any leftover
    // B children as pure insertions and leftover A children as pure deletions. Zipping avoids
    // treating a MODIFIED child (whose content merely differs) as a delete+insert — that pairing
    // lets the recursion diff inside the child (inline/sentence) instead of replacing it whole.
    const out = [];
    let i = 0;
    let j = 0;
    // Pending runs of unmatched children on each side, flushed (zipped) at each anchor / at end.
    let runA = [];
    let runB = [];
    const flushRuns = ()=>{
        const shared = Math.min(runA.length, runB.length);
        for(let k = 0; k < shared; k++)out.push({
            a: runA[k],
            b: runB[k]
        });
        for(let k = shared; k < runA.length; k++)out.push({
            a: runA[k],
            b: null
        });
        for(let k = shared; k < runB.length; k++)out.push({
            a: null,
            b: runB[k]
        });
        runA = [];
        runB = [];
    };
    while(i < n && j < m){
        if (keyA[i] === keyB[j]) {
            flushRuns();
            out.push({
                a: childrenA[i],
                b: childrenB[j]
            });
            i++;
            j++;
        } else if (lcs[i + 1][j] >= lcs[i][j + 1]) {
            runA.push(childrenA[i]);
            i++;
        } else {
            runB.push(childrenB[j]);
            j++;
        }
    }
    while(i < n){
        runA.push(childrenA[i]);
        i++;
    }
    while(j < m){
        runB.push(childrenB[j]);
        j++;
    }
    flushRuns();
    return out;
};
/**
 * Container classification with the rigid-child escalation rules:
 *  - list:         replace whole list if changed items / items ≥ node.ratio, else recurse
 *                  into each changed listItem's content.
 *  - table:        replace whole table if changed cells / cells ≥ node.ratio; else, for each
 *                  changed ROW, replace the row if changed cells / row-cells ≥ node.ratio,
 *                  else recurse into each changed cell's content.
 *  - layout:       replace whole section if changed columns / columns ≥ node.ratio, else
 *                  recurse into each changed column's content.
 *  - generic (panel/expand/quote/...): replace whole block if changed children / children ≥
 *                  node.ratio, else recurse into each changed child.
 */ const $2be352b0f93592ab$var$classifyContainer = (blockA, blockB, changes, originalDoc, newDoc, locale, thresholds)=>{
    const typeName = blockB.node.type.name;
    // Tables need cell-level counting across rows; handle them specially.
    if (typeName === $2be352b0f93592ab$var$TABLE_TYPE) return $2be352b0f93592ab$var$classifyTable(blockA, blockB, changes, originalDoc, newDoc, locale, thresholds);
    const childrenB = $2be352b0f93592ab$var$childRefs(blockB);
    const childrenA = $2be352b0f93592ab$var$childRefs(blockA);
    const changed = $2be352b0f93592ab$var$changedChildIndices(blockB, childrenB, changes);
    const denom = Math.max(childrenA.length, childrenB.length, 1);
    if (changed.size / denom >= thresholds.node.ratio) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    // Below threshold → recurse per child, using an LCS alignment so inserted/removed children
    // do not mis-pair (which previously corrupted A-side coordinates and leaked one block's
    // deletions into another). Each alignment entry is one of:
    //   - matched (a & b): recurse to classify any intra-child changes (skipped if identical);
    //   - added (b only):  a pure insertion, with a zero-width A anchor near its position;
    //   - removed (a only): a pure deletion, with a zero-width B anchor near its position.
    const alignment = $2be352b0f93592ab$var$alignChildren(childrenA, childrenB);
    const out = [];
    // Running A/B anchors from the last matched pair, so pure insert/delete get sensible
    // zero-width coordinates on the opposite side.
    let lastMatchedAEnd = blockA.from + 1;
    let lastMatchedBEnd = blockB.from + 1;
    for (const { a: a, b: b } of alignment){
        if (a && b) {
            lastMatchedAEnd = a.to;
            lastMatchedBEnd = b.to;
            // Identical content is left as-is by the LCS; if a change still overlaps this pair
            // (e.g. marks), recurse to classify it.
            const childChanges = changes.filter((c)=>(0, $5a823ae841a62560$export$8f43b23b5d8de905)(c.fromB, Math.max(c.toB, c.fromB + 1), b.from, b.to));
            if (childChanges.length === 0) continue;
            out.push(...$2be352b0f93592ab$var$classifyChild(a, b, childChanges, originalDoc, newDoc, locale, thresholds));
            continue;
        }
        if (b && !a) {
            // Added child: pure insertion. Anchor the (empty) A side at the last matched A end.
            out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(lastMatchedAEnd, lastMatchedAEnd, b.from, b.to, 'node'));
            lastMatchedBEnd = b.to;
            continue;
        }
        if (a && !b) {
            // Removed child: pure deletion. Anchor the (empty) B side at the last matched B end.
            out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(a.from, a.to, lastMatchedBEnd, lastMatchedBEnd, 'node'));
            lastMatchedAEnd = a.to;
        }
    }
    return out;
};
/**
 * Classify a table: replace the whole table when changed-cells/total-cells ≥ node.ratio;
 * otherwise for each changed row, replace the row when its own changed-cells/row-cells ≥
 * node.ratio, else recurse into each changed cell.
 */ const $2be352b0f93592ab$var$classifyTable = (blockA, blockB, changes, originalDoc, newDoc, locale, thresholds)=>{
    const rowsB = $2be352b0f93592ab$var$childRefs(blockB);
    const rowsA = $2be352b0f93592ab$var$childRefs(blockA);
    // Total cell counts across the whole table.
    let totalCellsB = 0;
    let changedCellsB = 0;
    const perRowChangedCells = new Map();
    for (const row of rowsB){
        const cells = $2be352b0f93592ab$var$childRefs(row);
        totalCellsB += cells.length;
        const changedCells = $2be352b0f93592ab$var$changedChildIndices(row, cells, changes);
        if (changedCells.size > 0) {
            perRowChangedCells.set(row.index, changedCells);
            changedCellsB += changedCells.size;
        }
    }
    let totalCellsA = 0;
    for (const row of rowsA)totalCellsA += row.node.childCount;
    const cellDenom = Math.max(totalCellsA, totalCellsB, 1);
    // Whole-table replacement.
    if (changedCellsB / cellDenom >= thresholds.node.ratio) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    const out = [];
    // LCS-align rows (mirrors classifyContainer) so an inserted/deleted row does not mis-pair
    // every subsequent row by index (which would corrupt the row-level A coordinates).
    const rowAlignment = $2be352b0f93592ab$var$alignChildren(rowsA, rowsB);
    let lastMatchedRowAEnd = blockA.from + 1;
    let lastMatchedRowBEnd = blockB.from + 1;
    for (const { a: rowA, b: rowB } of rowAlignment){
        // Added row: pure insertion (only if it actually carries changes).
        if (rowB && !rowA) {
            if ((perRowChangedCells.get(rowB.index)?.size ?? 0) > 0) out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(lastMatchedRowAEnd, lastMatchedRowAEnd, rowB.from, rowB.to, 'node'));
            lastMatchedRowBEnd = rowB.to;
            continue;
        }
        // Removed row: pure deletion.
        if (rowA && !rowB) {
            out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(rowA.from, rowA.to, lastMatchedRowBEnd, lastMatchedRowBEnd, 'node'));
            lastMatchedRowAEnd = rowA.to;
            continue;
        }
        if (!rowA || !rowB) continue;
        lastMatchedRowAEnd = rowA.to;
        lastMatchedRowBEnd = rowB.to;
        const changedCells = perRowChangedCells.get(rowB.index);
        if (!changedCells || changedCells.size === 0) continue;
        const cellsB = $2be352b0f93592ab$var$childRefs(rowB);
        // Row-level replacement.
        if (changedCells.size / Math.max(rowA.node.childCount, cellsB.length, 1) >= thresholds.node.ratio) {
            out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(rowA.from, rowA.to, rowB.from, rowB.to, 'node'));
            continue;
        }
        // Else recurse into each changed cell's content (cell is never replaced alone). Cells are
        // positionally aligned within a matched row (table columns are fixed, so a cell at index i
        // on the B side corresponds to index i on the A side).
        const cellsA = $2be352b0f93592ab$var$childRefs(rowA);
        for (const cellB of cellsB){
            if (!changedCells.has(cellB.index)) continue;
            const cellA = cellsA[cellB.index] ?? null;
            const cellChanges = changes.filter((c)=>(0, $5a823ae841a62560$export$8f43b23b5d8de905)(c.fromB, Math.max(c.toB, c.fromB + 1), cellB.from, cellB.to));
            out.push(...$2be352b0f93592ab$var$classifyChild(cellA, cellB, cellChanges, originalDoc, newDoc, locale, thresholds));
        }
    }
    return out;
};
/**
 * Recurse into a rigid/structural child (listItem, layoutColumn, tableCell/tableHeader) or a
 * plain child block. Rigid children are containers of blocks: we recurse into THEIR children
 * (paragraphs, nested lists, …) so we never delete+replace the rigid child itself. A plain
 * text-bearing or container child is classified directly.
 */ const $2be352b0f93592ab$var$classifyChild = (childA, childB, changes, originalDoc, newDoc, locale, thresholds)=>{
    if (changes.length === 0) return [];
    const typeName = childB.node.type.name;
    const asBlock = (ref)=>ref ? {
            node: ref.node,
            from: ref.from,
            to: ref.to
        } : null;
    // Structurally-rigid wrapper (layoutColumn / tableCell / tableHeader): the wrapper itself is
    // NEVER a whole-block result — deleting+re-inserting a single column or cell would break the
    // parent layout/table structure. We only reach here because the parent already decided NOT
    // to promote wholesale, so we bypass `classifyContainer` (which could promote the whole
    // wrapper when it is internally dense) and classify EACH of the wrapper's direct children on
    // its own. This keeps the diff strictly inside the wrapper (inline / sentence / paragraph,
    // or a nested container such as a list inside a table cell).
    if ($2be352b0f93592ab$var$RIGID_CHILD_TYPES.has(typeName)) {
        const blockB = asBlock(childB);
        if (!blockB) return [];
        const wrapperA = asBlock(childA);
        const childrenB = $2be352b0f93592ab$var$childRefs(blockB);
        const childrenA = wrapperA ? $2be352b0f93592ab$var$childRefs(wrapperA) : [];
        const out = [];
        // LCS-align inner children (mirrors classifyContainer) so a paragraph inserted/deleted
        // inside the cell/column does not mis-pair every subsequent inner child by index. We never
        // promote the wrapper itself here — we only classify each inner child.
        const alignment = $2be352b0f93592ab$var$alignChildren(childrenA, childrenB);
        let lastMatchedAEnd = wrapperA ? wrapperA.from + 1 : blockB.from + 1;
        let lastMatchedBEnd = blockB.from + 1;
        for (const { a: a, b: b } of alignment){
            if (a && b) {
                lastMatchedAEnd = a.to;
                lastMatchedBEnd = b.to;
                const innerChanges = changes.filter((c)=>(0, $5a823ae841a62560$export$8f43b23b5d8de905)(c.fromB, Math.max(c.toB, c.fromB + 1), b.from, b.to));
                if (innerChanges.length === 0) continue;
                out.push(...$2be352b0f93592ab$var$classifyChild(a, b, innerChanges, originalDoc, newDoc, locale, thresholds));
                continue;
            }
            if (b && !a) {
                // Added inner child: pure insertion, zero-width A anchor at the last matched A end.
                out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(lastMatchedAEnd, lastMatchedAEnd, b.from, b.to, 'node'));
                lastMatchedBEnd = b.to;
                continue;
            }
            if (a && !b) {
                // Removed inner child: pure deletion, zero-width B anchor at the last matched B end.
                out.push((0, $5a823ae841a62560$export$71d4e291db87dd0a)(a.from, a.to, lastMatchedBEnd, lastMatchedBEnd, 'node'));
                lastMatchedAEnd = a.to;
            }
        }
        return out;
    }
    // A `listItem` CAN be replaced wholesale (delete + re-insert at the same position does not
    // break the list's structure), so per the spec it uses the normal container rule: promote
    // the whole item when its own content is dense enough, else recurse into its children.
    if (typeName === 'listItem') {
        const blockB = asBlock(childB);
        const blockAItem = asBlock(childA);
        // Pure deletion of the item: emit the whole A-side item as deleted (zero-width B anchor at
        // the item's own B-less position — anchored at the A start for lack of parent context).
        if (!blockB) return blockAItem ? [
            (0, $5a823ae841a62560$export$71d4e291db87dd0a)(blockAItem.from, blockAItem.to, blockAItem.from, blockAItem.from, 'node')
        ] : [];
        // Pure insertion of the item: emit the whole B-side item as inserted with a ZERO-WIDTH A
        // anchor. (Using `blockB` as the A side would make the LCS compare the item against itself
        // and drop the insertion.)
        if (!blockAItem) return [
            (0, $5a823ae841a62560$export$71d4e291db87dd0a)(blockB.from, blockB.from, blockB.from, blockB.to, 'node')
        ];
        return $2be352b0f93592ab$var$classifyContainer(blockAItem, blockB, changes, originalDoc, newDoc, locale, thresholds);
    }
    // Plain child block: classify as its own group (text or nested container).
    return $2be352b0f93592ab$var$classifyBlockGroup({
        blockA: asBlock(childA),
        blockB: asBlock(childB),
        changes: changes
    }, originalDoc, newDoc, locale, thresholds);
};



const $ccec9bbe1ed9722a$var$getChanges = ({ changeset: changeset, originalDoc: originalDoc, steppedDoc: steppedDoc, diffType: diffType, tr: tr, steps: steps, intl: intl, smartThresholds: smartThresholds })=>{
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) {
        // The `smart` diff type is gated behind `platform_editor_ai_smart_diff`. When the gate is
        // off, `smart` falls through to the default (`inline`) path below so behaviour degrades
        // gracefully (see docs/smart-diff-design.md §3).
        if (diffType === 'smart' && (0, $ixfCV.fg)('platform_editor_ai_smart_diff')) {
            const changes = (0, $dFI5z.simplifyChanges)(changeset.changes, tr.doc);
            return (0, $2be352b0f93592ab$export$c15105fe770d78d4)({
                changes: changes,
                originalDoc: originalDoc,
                newDoc: tr.doc,
                locale: intl.locale,
                thresholds: smartThresholds
            });
        }
        if (diffType === 'step') return (0, $77c6f9f7c3b6c582$export$3dfa1fc8b4a78d32)(originalDoc, steps);
        if (diffType === 'block') return (0, $b0bf35342ffa1121$export$a0c7c7ce83d8783e)(changeset.changes, originalDoc, steppedDoc);
        const changes = (0, $dFI5z.simplifyChanges)(changeset.changes, tr.doc);
        return (0, $1958099bac1d5a54$export$e2f3b3d89f27d105)(changes);
    }
    const changes = (0, $dFI5z.simplifyChanges)(changeset.changes, tr.doc);
    return (0, $1958099bac1d5a54$export$e2f3b3d89f27d105)(changes);
};
/**
 * Collect the inline-content ranges of every leaf text-bearing block (paragraph, heading, …)
 * whose content overlaps `[from, to)`. Used to clip a node-level `smart` insertion highlight to
 * the actual added text, so the inserted background/underline never spans structural gaps
 * (list markers, empty item slots, cell/column boundaries) which would render as phantom rows.
 */ const $ccec9bbe1ed9722a$var$leafTextblockRanges = (doc, from, to)=>{
    const ranges = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isTextblock && node.content.size > 0) {
            const contentFrom = Math.max(pos + 1, from);
            const contentTo = Math.min(pos + 1 + node.content.size, to);
            if (contentTo > contentFrom) ranges.push([
                contentFrom,
                contentTo
            ]);
            // Textblocks have no block children to descend into.
            return false;
        }
        return true;
    });
    return ranges;
};
const $ccec9bbe1ed9722a$var$calculateNodesForBlockDecoration = ({ doc: doc, from: from, to: to, colorScheme: colorScheme, isInserted: isInserted = true, activeIndexPos: activeIndexPos, shouldHideDeleted: shouldHideDeleted = false, showIndicators: showIndicators = false, diffType: diffType })=>{
    const decorations = [];
    // Iterate over the document nodes within the range
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isBlock && (!(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) || pos + node.nodeSize <= to)) {
            const nodeEnd = pos + node.nodeSize;
            const isActive = activeIndexPos && pos === activeIndexPos.from && nodeEnd === activeIndexPos.to;
            decorations.push(...(0, $272524b39064824e$export$8df64513a6dc1f2a)({
                change: {
                    from: pos,
                    to: nodeEnd,
                    name: node.type.name
                },
                colorScheme: colorScheme,
                isInserted: isInserted,
                isActive: isActive,
                shouldHideDeleted: shouldHideDeleted,
                showIndicators: showIndicators,
                doc: doc,
                diffType: diffType
            }));
        }
    });
    return decorations;
};
const $ccec9bbe1ed9722a$var$calculateDiffDecorationsInner = ({ state: state, pluginState: pluginState, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, api: api, isInverted: isInverted = false, diffType: diffType = 'inline', hideDeletedDiffs: hideDeletedDiffs = false, showIndicators: showIndicators = false, smartThresholds: smartThresholds, deletedDiffPlacement: deletedDiffPlacement = 'top' })=>{
    const { originalDoc: originalDoc, steps: steps, isDisplayingChanges: isDisplayingChanges } = pluginState;
    if (!originalDoc || !isDisplayingChanges) return {
        decorations: (0, $8nvEM.DecorationSet).empty,
        diffDescriptors: []
    };
    const { tr: tr } = state;
    let steppedDoc = originalDoc;
    const attrSteps = [];
    const simplifiedSteps = (0, $c2a675ff129cc20a$export$320ba57788df881b)(steps, originalDoc);
    const stepMaps = [];
    for (const step of simplifiedSteps){
        const result = step.apply(steppedDoc);
        if (result.failed === null && result.doc) {
            if ((0, $5a5219f6ff8efa86$export$78b37f7430a7646c)(step, steppedDoc, result.doc)) attrSteps.push(step);
            stepMaps.push(step.getMap());
            steppedDoc = result.doc;
        }
    }
    // Rather than using .eq() we use a custom function that only checks for structural
    // changes and ignores differences in attributes which don't affect decoration positions
    if (!(0, $6SJ6d.areNodesEqualIgnoreAttrs)(steppedDoc, tr.doc)) {
        const recoveredViaContentEquality = (0, $6abaa709e6c99f63$export$2b9c81e9e2c68dae)(steppedDoc, tr.doc);
        api?.analytics?.actions.fireAnalyticsEvent({
            eventType: 'track',
            action: 'nodesNotEqual',
            actionSubject: 'showDiff',
            attributes: {
                docSizeEqual: steppedDoc.nodeSize === tr.doc.nodeSize,
                colorScheme: colorScheme,
                recoveredViaContentEquality: recoveredViaContentEquality
            }
        });
        if (!recoveredViaContentEquality) return {
            decorations: (0, $8nvEM.DecorationSet).empty,
            diffDescriptors: []
        };
    }
    const changeset = (0, $dFI5z.ChangeSet).create(originalDoc).addSteps(steppedDoc, stepMaps, tr.doc);
    const changes = $ccec9bbe1ed9722a$var$getChanges({
        changeset: changeset,
        originalDoc: originalDoc,
        steppedDoc: steppedDoc,
        diffType: diffType,
        tr: tr,
        steps: steps,
        intl: intl,
        smartThresholds: smartThresholds
    });
    const decorations = [];
    /**
   * If showIndicators is on, we create an anchor widget here to mark the doc margin.
   */ if (showIndicators && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) decorations.push((0, $b6432cc061a6f6cb$export$e9accf2864a96b18)());
    // Our default operations are insertions, so it should match the opposite of isInverted.
    const isInserted = !isInverted;
    const createDecorationsForChange = (change, showGranularWithBlock)=>{
        const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
        if (change.inserted.length > 0) {
            // shouldHideDeleted for block/node decorations: suppressed when isInverted + hideDeletedDiffs,
            // or when showGranularWithBlock (block reference widget is shown instead).
            // isInverted gates both — on an inverted diff the inserted side is visually the deleted side.
            const shouldHideDeleted = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? isInverted && (hideDeletedDiffs || showGranularWithBlock) && change.deleted.length > 0 : false;
            // For `smart` NODE-level promotions the change range spans a whole container
            // (e.g. an entire list/table/layout, using outer node bounds). Applying a SINGLE
            // inline decoration across that whole range would paint the inserted style across
            // block boundaries and structural gaps (list markers, empty item slots), producing
            // phantom "empty" rows above the real content. But skipping the inline highlight
            // entirely leaves added text-bearing blocks (paragraphs/headings inside the added
            // container) without the inserted background+underline, because block decorations
            // return no style for paragraph/heading. So for node-level smart changes we instead
            // emit ONE inline decoration per leaf text-bearing block within the range — the text
            // gets highlighted, and structural gaps never do.
            const isSmartNodeLevel = diffType === 'smart' && (0, $ixfCV.fg)('platform_editor_ai_smart_diff') && (0, $5a823ae841a62560$export$bd99dc0a81d559c2)(change) === 'node';
            if (isSmartNodeLevel) for (const [from, to] of $ccec9bbe1ed9722a$var$leafTextblockRanges(tr.doc, change.fromB, change.toB))decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
                change: {
                    fromB: from,
                    toB: to
                },
                doc: tr.doc,
                colorScheme: colorScheme,
                isActive: isActive,
                diffType: diffType,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted,
                    showIndicators: showIndicators
                }
            }));
            else decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
                change: change,
                doc: tr.doc,
                colorScheme: colorScheme,
                isActive: isActive,
                diffType: diffType,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted,
                    showIndicators: showIndicators
                }
            }));
            decorations.push(...$ccec9bbe1ed9722a$var$calculateNodesForBlockDecoration({
                doc: tr.doc,
                from: change.fromB,
                to: change.toB,
                colorScheme: colorScheme,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted,
                    showIndicators: showIndicators
                },
                activeIndexPos: activeIndexPos,
                intl: intl,
                diffType: diffType
            }));
        }
        if (change.deleted.length > 0) {
            const shouldHideDeleted = (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) ? !isInverted && (hideDeletedDiffs || showGranularWithBlock) && change.inserted.length > 0 : false;
            if (!shouldHideDeleted) decorations.push(...(0, $6760b5578652a45a$export$33298e826c81587e)({
                change: change,
                doc: originalDoc,
                nodeViewSerializer: nodeViewSerializer,
                colorScheme: colorScheme,
                newDoc: tr.doc,
                intl: intl,
                activeIndexPos: activeIndexPos,
                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType) && {
                    isInserted: !isInserted,
                    diffType: diffType,
                    // For `smart` node- and paragraph-level changes, optionally render the
                    // deleted content below the new content (gray + strikethrough) instead
                    // of above it. Controlled by `deletedDiffPlacement` (default `'top'`).
                    placeBelow: deletedDiffPlacement === 'bottom' && diffType === 'smart' && (0, $ixfCV.fg)('platform_editor_ai_smart_diff') && ((0, $5a823ae841a62560$export$bd99dc0a81d559c2)(change) === 'node' || (0, $5a823ae841a62560$export$bd99dc0a81d559c2)(change) === 'paragraph')
                },
                showIndicators: showIndicators
            }));
        }
    };
    if (diffType === 'step' && (0, $ieeJu.expValEquals)('platform_editor_diff_granular_extended', 'isEnabled', true)) {
        // Uses getStepChanges instead of getChanges so that we have per-step granularity metadata.
        // Specifically, we need to know how many granular changes each step produced in order to
        // apply the shouldHideDeleted suppression threshold (> 3 granular changes per step).
        // getChanges returns a flat Change[] with no per-step grouping, making this count impossible
        // to derive after the fact without re-introducing per-change metadata.
        const stepChanges = (0, $77c6f9f7c3b6c582$export$cafca9d74d24384b)(originalDoc, steps);
        stepChanges.forEach(({ isGranular: isGranular, changes: stepChangeList })=>{
            const granularCount = isGranular ? stepChangeList.length : 0;
            // Calculate the average ratio of changed content on both A (original) and B (new)
            // sides of the diff. If 30% or more of the block has changed on average, we show
            // the block reference widget even if the granular change count is below the threshold.
            // Block length is derived from the enclosing text block boundaries rather than the
            // first/last change positions, so unchanged words at the start/end are accounted for.
            let avgChangedRatio = 0;
            if (isGranular && stepChangeList.length > 0) {
                const first = stepChangeList[0];
                const last = stepChangeList[stepChangeList.length - 1];
                const resolvedA = originalDoc.resolve(first.fromA);
                const resolvedB = tr.doc.resolve(first.fromB);
                let blockStartA = first.fromA;
                let blockEndA = last.toA;
                let blockStartB = first.fromB;
                let blockEndB = last.toB;
                for(let depth = resolvedA.depth; depth >= 0; depth--){
                    const node = resolvedA.node(depth);
                    if (node.isTextblock) {
                        blockStartA = resolvedA.start(depth);
                        blockEndA = blockStartA + node.nodeSize - 2; // exclude open/close tokens
                        break;
                    }
                }
                for(let depth = resolvedB.depth; depth >= 0; depth--){
                    const node = resolvedB.node(depth);
                    if (node.isTextblock) {
                        blockStartB = resolvedB.start(depth);
                        blockEndB = blockStartB + node.nodeSize - 2; // exclude open/close tokens
                        break;
                    }
                }
                const blockLengthA = blockEndA - blockStartA;
                const blockLengthB = blockEndB - blockStartB;
                const totalChangedA = stepChangeList.reduce((sum, c)=>sum + (c.toA - c.fromA), 0);
                const totalChangedB = stepChangeList.reduce((sum, c)=>sum + (c.toB - c.fromB), 0);
                const ratioA = blockLengthA > 0 ? totalChangedA / blockLengthA : 0;
                const ratioB = blockLengthB > 0 ? totalChangedB / blockLengthB : 0;
                avgChangedRatio = (ratioA + ratioB) / 2;
            }
            const showGranularWithBlock = isGranular && granularCount !== 1 && (granularCount > 3 || avgChangedRatio >= 0.3);
            stepChangeList.forEach((change)=>{
                createDecorationsForChange(change, showGranularWithBlock);
            });
            if (showGranularWithBlock && stepChangeList.length > 0) {
                const lastChange = stepChangeList[stepChangeList.length - 1];
                const granularBlockDiffId = crypto.randomUUID();
                const blockWidgets = (0, $31f9015ad6b08a27$export$a5d21dc34e291ee6)({
                    change: lastChange,
                    originalDoc: originalDoc,
                    newDoc: tr.doc,
                    isInverted: isInverted,
                    nodeViewSerializer: nodeViewSerializer,
                    colorScheme: colorScheme,
                    intl: intl,
                    activeIndexPos: activeIndexPos,
                    diffId: granularBlockDiffId,
                    showIndicators: showIndicators
                });
                decorations.push(...blockWidgets);
            }
        });
    } else changes.forEach((change)=>{
        createDecorationsForChange(change, /* showGranularWithBlock */ false);
    });
    (0, $112c13fed0acd0fd$export$cb37e032b0f65b99)(steps).forEach((change)=>{
        const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
        decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
            change: change,
            colorScheme: colorScheme,
            isActive: isActive,
            isInserted: true
        }));
    });
    (0, $5a5219f6ff8efa86$export$34445edbbb29aecb)(tr.doc, attrSteps).forEach((change)=>{
        if (change.isInline) {
            // Inline nodes (e.g. date) need an inline decoration rather than a block decoration
            const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
            decorations.push(...(0, $446fe50ec2aaceae$export$69543ba6b110e31c)({
                change: change,
                colorScheme: colorScheme,
                isActive: isActive,
                isInserted: true
            }));
        } else decorations.push(...$ccec9bbe1ed9722a$var$calculateNodesForBlockDecoration({
            doc: tr.doc,
            from: change.fromB,
            to: change.toB,
            colorScheme: colorScheme,
            isInserted: true,
            activeIndexPos: activeIndexPos,
            intl: intl,
            showIndicators: showIndicators
        }));
    });
    const decorationSet = (0, $8nvEM.DecorationSet).empty.add(tr.doc, decorations);
    return {
        decorations: decorationSet,
        diffDescriptors: (0, $c8506ce9a0d29c95$export$f6b1e5edab6db0b1)(decorationSet)
    };
};
const $ccec9bbe1ed9722a$export$aa7cf3ccfb5d875f = (0, $dOBRD.default)($ccec9bbe1ed9722a$var$calculateDiffDecorationsInner, // Cache results unless relevant inputs change
([{ pluginState: pluginState, state: state, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, isInverted: isInverted, diffType: diffType, hideDeletedDiffs: hideDeletedDiffs, showIndicators: showIndicators, smartThresholds: smartThresholds, deletedDiffPlacement: deletedDiffPlacement }], [{ pluginState: lastPluginState, state: lastState, colorScheme: lastColorScheme, intl: lastIntl, activeIndexPos: lastActiveIndexPos, isInverted: lastIsInverted, diffType: lastDiffType, hideDeletedDiffs: lastHideDeletedDiffs, showIndicators: lastShowIndicators, smartThresholds: lastSmartThresholds, deletedDiffPlacement: lastDeletedDiffPlacement }])=>{
    const originalDocIsSame = lastPluginState.originalDoc && pluginState.originalDoc && pluginState.originalDoc.eq(lastPluginState.originalDoc);
    if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(diffType)) return (colorScheme === lastColorScheme && intl.locale === lastIntl.locale && isInverted === lastIsInverted && diffType === lastDiffType && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(activeIndexPos, lastActiveIndexPos) && originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.steps, lastPluginState.steps) && state.doc.eq(lastState.doc) && hideDeletedDiffs === lastHideDeletedDiffs && showIndicators === lastShowIndicators && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(smartThresholds, lastSmartThresholds) && deletedDiffPlacement === lastDeletedDiffPlacement) ?? false;
    return (originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pluginState.steps, lastPluginState.steps) && state.doc.eq(lastState.doc) && colorScheme === lastColorScheme && intl.locale === lastIntl.locale && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(activeIndexPos, lastActiveIndexPos) && hideDeletedDiffs === lastHideDeletedDiffs) ?? false;
});


// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");




const $c3b673b22464e106$export$b180cb547184e48c = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // @ts-expect-error ProseMirror step classes expose jsonID on prototype.
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // Re-register if needed; ignore if already registered.
                // @ts-expect-error Step.jsonID expects a step constructor.
                (0, $5aU9U.Step).jsonID(id, customStep);
            } catch  {
            // Step already registered.
            }
        }
    };
    // @ts-expect-error Step modules export non-step symbols too.
    tryToRegisterStep($aOSDg);
    // @ts-expect-error Step modules export non-step symbols too.
    tryToRegisterStep($aqgkf);
};







function $2dfa9b84b3c8f00b$export$42cf4389dbe8b0ff(view) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return view.nodeViews !== undefined;
}
class $2dfa9b84b3c8f00b$export$314a8d5cfa8a18e6 {
    /**
   * Initializes or reinitializes the NodeViewSerializer with a new EditorView.
   * This allows the same serializer instance to be reused across different editor states.
   */ init(params) {
        this.serializer = (0, $aPdNQ.DOMSerializer).fromSchema(params.editorView.state.schema);
        if ($2dfa9b84b3c8f00b$export$42cf4389dbe8b0ff(params.editorView)) this.editorView = params.editorView;
        const nodeViews = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params.editorView?.nodeViews || {};
        this.nodeViews = nodeViews ?? this.editorView?.nodeViews ?? {};
    }
    /**
   * Appends serialized child nodes to the given contentDOM element.
   */ appendChildNodes(children, contentDOM) {
        children.forEach((child)=>{
            const childNode = this.tryCreateNodeView(child) || this.serializeNode(child);
            if (childNode) contentDOM?.append(childNode);
        });
    }
    /**
   * Attempts to create a node view for the given node.
   *
   * Returns `null` when there is no `EditorView`, no constructor for the node type,
   * or the node type is blocklisted. Otherwise returns the constructed node view instance.
   */ tryCreateNodeView(targetNode) {
        if (!this.editorView) return null;
        const constructor = this.nodeViews?.[targetNode.type.name];
        if (this.nodeViewBlocklist.has(targetNode.type.name)) return null;
        try {
            if (!constructor) {
                if (targetNode.isInline) return null;
                const toDOMResult = targetNode.type.spec.toDOM?.(targetNode);
                if (!toDOMResult) return null;
                const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, toDOMResult);
                if (dom instanceof HTMLElement) {
                    if (targetNode.type.name === 'paragraph' && targetNode.children.length === 1) return this.serializeFragment(targetNode.content);
                    // Iteratively populate children
                    this.appendChildNodes(targetNode.children, contentDOM);
                }
                return dom;
            }
            const { dom: dom, contentDOM: contentDOM } = constructor(targetNode, this.editorView, ()=>0, [], {});
            // Iteratively populate children
            this.appendChildNodes(targetNode.children, contentDOM);
            return dom;
        } catch  {
            return null;
        }
    }
    /**
   * Serializes a node to a DOM `Node` using the schema's `DOMSerializer`.
   */ serializeNode(node) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeNode(node);
        } catch  {
            return null;
        }
    }
    /**
   * Serializes a fragment to a `DocumentFragment` using the schema's `DOMSerializer`.
   */ serializeFragment(fragment) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeFragment(fragment);
        } catch  {
            return null;
        }
    }
    /**
   * Returns a copy of the current node view blocklist.
   */ getNodeViewBlocklist() {
        return new Set(this.nodeViewBlocklist);
    }
    /**
   * Returns a filtered copy of the node view blocklist, excluding specified node types.
   * @param excludeTypes - Array of node type names to exclude from the blocklist
   */ getFilteredNodeViewBlocklist(excludeTypes) {
        const filtered = new Set(this.nodeViewBlocklist);
        excludeTypes.forEach((type)=>filtered.delete(type));
        return filtered;
    }
    constructor(params){
        this.editorView = void 0;
        this.serializer = void 0;
        this.nodeViews = void 0;
        this.nodeViewBlocklist = void 0;
        if (params?.editorView) this.init({
            editorView: params.editorView
        });
        this.nodeViewBlocklist = new Set(params.blocklist ?? [
            'paragraph'
        ]);
    }
}



/**
 * Extra space above the scrolled-to element so it does not sit flush under the
 * viewport edge (helps with sticky table headers, toolbars, etc.).
 *
 * Implemented with `scroll-margin-top` so we still use the browser’s native
 * `scrollIntoView`, which scrolls every relevant scrollport (nested containers
 * and the window). A single manual `scrollTop` on one ancestor often misses
 * outer scroll or mis-identifies the active scroll container.
 */ const $0a56d7ce3dd9c790$var$SCROLL_TOP_MARGIN_PX = 100;
/**
 * Returns the resolved HTMLElement for a given DOM node, walking up to the
 * parent element if the node itself is not an Element (e.g. a text node).
 */ function $0a56d7ce3dd9c790$var$scrollToSelection(node) {
    const element = node instanceof Element ? node : node?.parentElement instanceof Element ? node.parentElement : null;
    if (!(element instanceof HTMLElement)) return;
    // scroll-margin is included in scroll-into-view math; it does not change layout.
    const previousScrollMarginTop = element.style.scrollMarginTop;
    element.style.scrollMarginTop = `${$0a56d7ce3dd9c790$var$SCROLL_TOP_MARGIN_PX}px`;
    try {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } finally{
        element.style.scrollMarginTop = previousScrollMarginTop;
    }
}
const $0a56d7ce3dd9c790$export$8c2c2fbc53afef61 = (view, set)=>{
    const decoration = set.find(undefined, undefined, (0, $c8506ce9a0d29c95$export$f24673b80d65051c)).find((0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34));
    if (!decoration) return ()=>{};
    let rafId = requestAnimationFrame(()=>{
        rafId = null;
        // @ts-expect-error - decoration.type is not typed public API
        if (decoration.spec.decorationType === 'widget' && decoration?.type?.toDOM) {
            // @ts-expect-error - decoration.type is not typed public API
            const widgetDom = decoration.type.toDOM;
            // Always scroll to the top of this decoration even if it's in view already
            $0a56d7ce3dd9c790$var$scrollToSelection(widgetDom);
        } else {
            const targetNode = view.nodeDOM(decoration?.from);
            const node = targetNode instanceof Element ? targetNode : view.domAtPos(decoration?.from)?.node;
            if (node instanceof HTMLElement) // Always scroll to the top of this decoration even if it's in view already
            $0a56d7ce3dd9c790$var$scrollToSelection(node);
        }
    });
    return ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
};
const $0a56d7ce3dd9c790$export$58319fce2ad9953a = (view, decorations, activeIndex)=>{
    const decoration = decorations[activeIndex];
    if (!decoration) return ()=>{};
    let rafId = requestAnimationFrame(()=>{
        rafId = null;
        if ((0, $c8506ce9a0d29c95$export$c9bc510aa0f85e34)(decoration) && decoration.spec.decorationType === 'widget') {
            // @ts-expect-error - decoration.type is not typed public API
            const widgetDom = decoration?.type?.toDOM;
            $0a56d7ce3dd9c790$var$scrollToSelection(widgetDom);
        } else {
            const targetNode = view.nodeDOM(decoration?.from);
            const node = targetNode instanceof Element ? targetNode : view.domAtPos(decoration?.from)?.node;
            $0a56d7ce3dd9c790$var$scrollToSelection(node);
        }
    });
    return ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
};


const $c205fa97f273a3e1$export$cc8ba64700247b36 = new (0, $kCECX.PluginKey)('showDiffPlugin');
const $c205fa97f273a3e1$export$ae829ec7b2625219 = (config, getIntl, api)=>{
    (0, $c3b673b22464e106$export$b180cb547184e48c)();
    const nodeViewSerializer = new (0, $2dfa9b84b3c8f00b$export$314a8d5cfa8a18e6)({});
    const setNodeViewSerializer = (editorView)=>{
        nodeViewSerializer.init({
            editorView: editorView
        });
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $c205fa97f273a3e1$export$cc8ba64700247b36,
        state: {
            init (_, _state) {
                // We do initial setup after we setup the editor view
                return {
                    steps: [],
                    originalDoc: undefined,
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    isDisplayingChanges: false,
                    ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)() ? {
                        isInverted: false,
                        diffType: 'inline',
                        hideDeletedDiffs: false,
                        showIndicators: false,
                        diffDescriptors: []
                    } : {}
                };
            },
            apply: (tr, currentPluginState, oldState, newState)=>{
                const meta = tr.getMeta($c205fa97f273a3e1$export$cc8ba64700247b36);
                let newPluginState = currentPluginState;
                if (meta) {
                    if (meta?.action === 'SHOW_DIFF') {
                        // Update the plugin state with the new metadata
                        newPluginState = {
                            ...currentPluginState,
                            ...meta,
                            isDisplayingChanges: true,
                            activeIndex: undefined
                        };
                        // Calculate and store decorations in state
                        const { decorations: decorations, diffDescriptors: diffDescriptors } = (0, $ccec9bbe1ed9722a$export$aa7cf3ccfb5d875f)({
                            state: newState,
                            pluginState: newPluginState,
                            nodeViewSerializer: nodeViewSerializer,
                            colorScheme: config?.colorScheme,
                            intl: getIntl(),
                            activeIndexPos: newPluginState.activeIndexPos,
                            api: api,
                            ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState?.diffType) ? {
                                isInverted: newPluginState?.isInverted,
                                diffType: newPluginState?.diffType,
                                hideDeletedDiffs: newPluginState?.hideDeletedDiffs,
                                showIndicators: newPluginState?.showIndicators,
                                smartThresholds: newPluginState?.smartThresholds,
                                deletedDiffPlacement: newPluginState?.deletedDiffPlacement
                            } : {}
                        });
                        // Update the decorations and their ids
                        newPluginState.decorations = decorations;
                        if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState?.diffType)) newPluginState.diffDescriptors = diffDescriptors;
                    } else if (meta?.action === 'HIDE_DIFF') newPluginState = {
                        ...currentPluginState,
                        ...meta,
                        decorations: (0, $8nvEM.DecorationSet).empty,
                        isDisplayingChanges: false,
                        activeIndex: undefined,
                        /**
               * Reset isInverted & diffType state when hiding diffs
               * Otherwise this should persist for the diff-showing session
               */ ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(currentPluginState.diffType) ? {
                            isInverted: false,
                            diffType: 'inline',
                            hideDeletedDiffs: false,
                            diffDescriptors: []
                        } : {}
                    };
                    else if (meta?.action === 'SCROLL_TO_NEXT' || meta?.action === 'SCROLL_TO_PREVIOUS') {
                        // Update the active index in plugin state and recalculate decorations
                        const decorations = (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(currentPluginState.decorations, newState.doc, newPluginState?.diffType);
                        if (decorations.length > 0) {
                            // Initialize to -1 if undefined so that the first "next" scroll takes us to index 0 (first change).
                            // This allows the UI to start with no selection and only highlight on first user interaction.
                            let nextIndex = currentPluginState.activeIndex ?? -1;
                            if (meta.action === 'SCROLL_TO_NEXT') nextIndex = (nextIndex + 1) % decorations.length;
                            else // Handle scrolling backwards from the uninitialized state.
                            // If at -1 (no selection), wrap to the last decoration.
                            if (nextIndex === -1) nextIndex = decorations.length - 1;
                            else nextIndex = (nextIndex - 1 + decorations.length) % decorations.length;
                            const activeDecoration = decorations[nextIndex];
                            newPluginState = {
                                ...currentPluginState,
                                activeIndex: nextIndex,
                                activeIndexPos: activeDecoration ? {
                                    from: activeDecoration.from,
                                    to: activeDecoration.to
                                } : undefined
                            };
                            // Recalculate decorations with the new active index
                            const { decorations: updatedDecorations, diffDescriptors: updatedDiffDescriptors } = (0, $ccec9bbe1ed9722a$export$aa7cf3ccfb5d875f)({
                                state: newState,
                                pluginState: newPluginState,
                                nodeViewSerializer: nodeViewSerializer,
                                colorScheme: config?.colorScheme,
                                intl: getIntl(),
                                activeIndexPos: newPluginState.activeIndexPos,
                                api: api,
                                ...(0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState.diffType) ? {
                                    isInverted: newPluginState.isInverted,
                                    diffType: newPluginState.diffType,
                                    hideDeletedDiffs: newPluginState.hideDeletedDiffs,
                                    showIndicators: newPluginState.showIndicators,
                                    smartThresholds: newPluginState.smartThresholds,
                                    deletedDiffPlacement: newPluginState.deletedDiffPlacement
                                } : {}
                            });
                            newPluginState.decorations = updatedDecorations;
                            if ((0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(newPluginState.diffType)) newPluginState.diffDescriptors = updatedDiffDescriptors;
                        }
                    } else newPluginState = {
                        ...currentPluginState,
                        ...meta
                    };
                }
                return {
                    ...newPluginState,
                    decorations: newPluginState.decorations.map(tr.mapping, tr.doc)
                };
            }
        },
        view (editorView) {
            setNodeViewSerializer(editorView);
            let isFirst = true;
            let previousActiveIndex;
            let cancelPendingScrollToDecoration = null;
            return {
                update (view) {
                    // If we're using configuration to show diffs we initialise here once we setup the editor view
                    if (config?.originalDoc && config?.steps && config.steps.length > 0 && isFirst) {
                        isFirst = false;
                        view.dispatch(view.state.tr.setMeta($c205fa97f273a3e1$export$cc8ba64700247b36, {
                            action: 'SHOW_DIFF',
                            steps: config.steps.map((step)=>(0, $5aU9U.Step).fromJSON(view.state.schema, step)),
                            originalDoc: (0, $5Qi6J.processRawValue)(view.state.schema, config.originalDoc)
                        }));
                    }
                    const pluginState = $c205fa97f273a3e1$export$cc8ba64700247b36.getState(view.state);
                    // Scroll to the first decoration when scrollIntoView was requested
                    if (pluginState?.scrollIntoView && (0, $e85d9b72d1bb97d7$export$e9c2274564cfd3df)(pluginState?.diffType)) {
                        cancelPendingScrollToDecoration?.();
                        cancelPendingScrollToDecoration = (0, $0a56d7ce3dd9c790$export$8c2c2fbc53afef61)(view, pluginState.decorations);
                        // Reset the flag so we don't scroll again on subsequent updates
                        view.dispatch(view.state.tr.setMeta($c205fa97f273a3e1$export$cc8ba64700247b36, {
                            scrollIntoView: false
                        }));
                    }
                    // Check for any potential scroll side-effects
                    const activeIndexChanged = pluginState?.activeIndex !== undefined && pluginState.activeIndex !== previousActiveIndex;
                    previousActiveIndex = pluginState?.activeIndex;
                    if (pluginState?.activeIndex !== undefined && activeIndexChanged) {
                        cancelPendingScrollToDecoration?.();
                        const scrollableDecorations = (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(pluginState.decorations, view.state.doc, pluginState?.diffType);
                        const activeDecoration = scrollableDecorations[pluginState.activeIndex];
                        if (activeDecoration && api?.expand?.commands?.toggleExpandRange) api?.core.actions.execute(api.expand.commands.toggleExpandRange(activeDecoration.from, activeDecoration.to, true));
                        cancelPendingScrollToDecoration = (0, $0a56d7ce3dd9c790$export$58319fce2ad9953a)(view, scrollableDecorations, pluginState.activeIndex);
                    }
                },
                destroy () {
                    cancelPendingScrollToDecoration?.();
                    cancelPendingScrollToDecoration = null;
                }
            };
        },
        props: {
            decorations: (state)=>{
                const pluginState = $c205fa97f273a3e1$export$cc8ba64700247b36.getState(state);
                return pluginState?.decorations;
            }
        }
    });
};


/* IndicatorBarContentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $3k5Tv = parcelRequire("3k5Tv");


/* IndicatorBar.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");


const $a83541013b9d489a$var$barStyles = null;
function $a83541013b9d489a$export$9541970bb1a2b56c({ anchorTop: anchorTop, anchorBottom: anchorBottom, anchorLeft: anchorLeft, anchorLeftFallback: anchorLeftFallback }) {
    const leftAnchors = [
        anchorLeft,
        anchorLeftFallback,
        (0, $c8506ce9a0d29c95$export$bc2e1517d52e2060)
    ].filter(Boolean).map((anchor)=>`anchor(--${anchor} left)`).join(', ');
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": "diff-indicator-bar",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            left: `min(${leftAnchors})`,
            top: `anchor(--${anchorTop} top)`,
            bottom: `anchor(--${anchorBottom} bottom)`
        },
        className: (0, $hekY6.default)([
            "_2rko1rr0 _kqswstnw _1bsb1l7b _bfhkvbh5 _lcxvglyw _18u0mgjw _17c61i8t _19pk196n _otyr196n"
        ])
    });
}


const $018a8bbdd67e90a0$var$renderIndicatorBar = (descriptor)=>{
    switch(descriptor.type){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a83541013b9d489a$export$9541970bb1a2b56c), {
                key: descriptor.id,
                anchorTop: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).from
                }),
                anchorBottom: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).to
                }),
                anchorLeft: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
                })
            });
        case 'block':
            {
                // The block anchor is a single element (keyed by diffId with no
                // anchorType) sized to the full height of the block node, so top,
                // bottom and left all resolve against it.
                const blockAnchor = (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a83541013b9d489a$export$9541970bb1a2b56c), {
                    key: descriptor.id,
                    anchorTop: blockAnchor,
                    anchorBottom: blockAnchor,
                    anchorLeft: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                        diffId: descriptor.id,
                        anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
                    })
                });
            }
        case 'widget':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a83541013b9d489a$export$9541970bb1a2b56c), {
                key: descriptor.id,
                anchorTop: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                }),
                anchorBottom: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                }),
                anchorLeft: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id,
                    anchorType: (0, $c8506ce9a0d29c95$export$fa63aa0289bee17d).left
                }),
                anchorLeftFallback: (0, $c8506ce9a0d29c95$export$c580b39c28f817bd)({
                    diffId: descriptor.id
                })
            });
        default:
            return null;
    }
};
const $018a8bbdd67e90a0$export$6b19438129810c85 = ({ api: api })=>{
    const { showIndicators: showIndicators, isDisplayingChanges: isDisplayingChanges, diffDescriptors: diffDescriptors } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'showDiff'
    ], (state)=>{
        return {
            showIndicators: state.showDiffState?.showIndicators,
            isDisplayingChanges: state.showDiffState?.isDisplayingChanges,
            diffDescriptors: state.showDiffState?.diffDescriptors
        };
    });
    if (!showIndicators || !isDisplayingChanges || !diffDescriptors?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, diffDescriptors.map($018a8bbdd67e90a0$var$renderIndicatorBar));
};


const $7a6c101d54699cc6$export$b025b000fc343096 = ({ api: api, config: config })=>({
        name: 'showDiff',
        commands: {
            showDiff: (params)=>({ tr: tr })=>{
                    if ((0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) api?.userIntent?.commands.setCurrentUserIntent('viewingDiff')({
                        tr: tr
                    });
                    return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                        ...params,
                        action: 'SHOW_DIFF'
                    });
                },
            hideDiff: ({ tr: tr })=>{
                if ((0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                    steps: [],
                    action: 'HIDE_DIFF'
                });
            },
            scrollToNext: ({ tr: tr })=>{
                return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                    action: 'SCROLL_TO_NEXT'
                });
            },
            scrollToPrevious: ({ tr: tr })=>{
                return tr.setMeta((0, $c205fa97f273a3e1$export$cc8ba64700247b36), {
                    action: 'SCROLL_TO_PREVIOUS'
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'showDiffPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $c205fa97f273a3e1$export$ae829ec7b2625219)(config, getIntl, api)
                }
            ];
        },
        contentComponent: ()=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $018a8bbdd67e90a0$export$6b19438129810c85), {
                api: api
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                activeIndex: undefined,
                ...(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                    diffDescriptors: []
                } : {}
            };
            const pluginState = (0, $c205fa97f273a3e1$export$cc8ba64700247b36).getState(editorState);
            const decorationCount = (0, $8dbcf03441d7dc2f$export$c459ab16dd3c3d79)(pluginState?.decorations, editorState.doc);
            return {
                isDisplayingChanges: decorationCount.length > 0,
                activeIndex: pluginState?.activeIndex,
                numberOfChanges: decorationCount.length,
                ...(0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                    diffDescriptors: pluginState?.diffDescriptors,
                    showIndicators: pluginState?.showIndicators
                } : {}
            };
        }
    });
module.exports["showDiffPlugin"] = $7a6c101d54699cc6$export$b025b000fc343096;

});

parcelRegister("7pyfy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2nOF5 = parcelRequire("2nOF5");


var $1KOhB = parcelRequire("1KOhB");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $dvybL = parcelRequire("dvybL");


var $krYZG = parcelRequire("krYZG");


var $6SJ6d = parcelRequire("6SJ6d");







function $ba9e453592b72692$export$a76b6d56e2272140(symptom, detectionLayer) {
    // ─── Parser-detected symptoms ────────────────────────────────────────
    // The streaming-JSON parser (in ai-model-io / ADFStreamer) is the
    // detector here, but the *cause* in every case is upstream — the model
    // produced output that the parser had to reject or repair. Detection
    // point ≠ ownership: we attribute to the backend.
    // Parser detecting malformed final ADF → backend generated bad output.
    // High confidence because the parser does not modify content — if the
    // final ADF is invalid, it's invalid as emitted by the model.
    if (detectionLayer === 'parser' && symptom === 'final_adf_invalid') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Parser had to repair JSON → backend streamed invalid JSON. Medium
    // confidence because some JSON-repair recoveries are triggered by
    // transport-level glitches (truncation, re-ordering) rather than true
    // model-output errors.
    if (detectionLayer === 'parser' && symptom === 'final_json_repaired') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // ─── Orchestrator-detected symptoms ──────────────────────────────────
    // The orchestrator is responsible for translating streamed ADF into
    // ProseMirror transactions and managing session lifecycle. Symptoms it
    // detects can split between frontend bugs (apply logic, lifecycle) and
    // backend bugs (the model emitted ADF that doesn't conform to the
    // schema or references a node that doesn't exist).
    // Orchestrator session lifecycle error → frontend issue. The session
    // machine itself is FE-owned; lifecycle errors are almost always our
    // bugs.
    if (detectionLayer === 'orchestrator' && symptom === 'session_lifecycle_error') return {
        attribution: 'frontend_apply_logic',
        confidence: 'high'
    };
    // Apply step failed with ProseMirror transaction error → FE apply
    // logic. The transaction was constructed by our code; if PM rejects
    // it, our construction is wrong.
    if (detectionLayer === 'orchestrator' && symptom === 'apply_failed_pm_error') return {
        attribution: 'frontend_apply_logic',
        confidence: 'high'
    };
    // Apply step failed because incoming ADF node had schema errors →
    // backend. The orchestrator only attempts to apply what the model
    // emitted; if the schema check fails, the model is at fault.
    if (detectionLayer === 'orchestrator' && symptom === 'apply_failed_adf_schema_error') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Target node not found → LLM hallucinated a localId. The orchestrator
    // looks up the target by the model-supplied localId; if no such node
    // exists in the doc, the model invented an identifier.
    if (detectionLayer === 'orchestrator' && symptom === 'local_id_not_found') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Node disappeared that wasn't the explicit target → frontend apply
    // side effect. Medium confidence because a poorly-formed transaction
    // can collateral-damage a sibling, but it could also be backend asking
    // for a structural change that we translated correctly into a
    // destructive transaction.
    if (detectionLayer === 'orchestrator' && symptom === 'unexpected_node_removal') return {
        attribution: 'frontend_apply_logic',
        confidence: 'medium'
    };
    // Tool call applied successfully but produced no document change.
    // Highest-likelihood cause is the model emitting content identical to
    // what already exists in the document (redundant generation). Medium
    // confidence rather than high because frontend apply-layer normalisation
    // can also silently collapse a transaction to a no-op (e.g. ProseMirror
    // merging adjacent identical text runs). A future refinement comparing
    // pre/post node-content hashes could upgrade this to high confidence
    // when the replacement content is byte-identical to the existing content.
    if (detectionLayer === 'orchestrator' && symptom === 'no_document_change') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // User / UI explicitly aborted the session. Origin is opaque to
    // telemetry (could be intentional cancel, navigation away, etc.) so we
    // can't confidently attribute the cause — only the fact of the abort
    // itself.
    if (detectionLayer === 'orchestrator' && symptom === 'session_aborted') return {
        attribution: 'unknown',
        confidence: 'high'
    };
    // Stream stalled: no further commands arrived within the orchestrator's
    // queue timeout. The most common cause is the backend halting its
    // stream (network slowness, model latency, or upstream error) so we
    // attribute to backend generation quality with medium confidence —
    // frontend bugs can also stall the stream, so this is not high
    // confidence.
    if (detectionLayer === 'orchestrator' && symptom === 'session_timeout') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // Post-apply analyzer detected a top-level node removed that no tool
    // call had explicitly targeted. When the analyzer used the precise
    // backend-supplied selection set we can confidently attribute to the
    // model. The proxy-fallback path (no backend selection) is handled at
    // the call site, where it returns unknown/low instead.
    if (detectionLayer === 'post_apply' && symptom === 'unexpected_content_removal') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Post-apply analyzer detected text content of a top-level node changed
    // that no tool call had explicitly targeted. Heuristic-driven (uses
    // character-count inequality with a `±1` ProseMirror normalisation
    // tolerance) so low-confidence — the caller is expected to also flag
    // the event with `experimental: true`. Same-length rewrites are silent
    // false negatives by design (out of scope for v1).
    if (detectionLayer === 'post_apply' && symptom === 'unintended_text_modification') return {
        attribution: 'unknown',
        confidence: 'low'
    };
    // Mutating tool calls ran but the document is effectively unchanged.
    // Highest-likelihood cause is a model that emitted commands targeting
    // the wrong node or producing no-op transactions; medium confidence
    // because frontend bugs (e.g. apply-layer no-op merges) can also
    // produce this signal.
    if (detectionLayer === 'post_apply' && symptom === 'no_meaningful_effect') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // Inferred intent doesn't match structural delta (e.g. APPEND intent
    // but net node removal). Heuristic-driven and so low-confidence — the
    // caller is expected to also flag the event with `experimental: true`.
    if (detectionLayer === 'post_apply' && symptom === 'semantic_mismatch') return {
        attribution: 'unknown',
        confidence: 'low'
    };
    // Default: unknown.
    return {
        attribution: 'unknown',
        confidence: 'low'
    };
}



var $1w4hj = parcelRequire("1w4hj");

const $a04a7145bc1aceaa$export$d4371db4dc3f8b5f = [
    'replaceDoc',
    'replaceNode',
    'removeNode',
    'removeNodes',
    'moveNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'appendNodeToEnd',
    'setAttrs',
    'wrap',
    'wrapNode',
    'appendNode'
];
 // #endregion


function $a7955f6a2f01a095$export$6bf900bab6a4720d(api) {
    let doc;
    // Quick and dirty way to get the doc
    api?.core.actions.execute(({ tr: tr })=>{
        doc = tr.doc;
        return null;
    });
    return doc;
}


function $e357a3431509036d$export$f85aff2979b590a7(command) {
    return [
        'replaceDoc',
        'replaceNode',
        'insertNodeBefore',
        'insertNodeAfter',
        'appendNode',
        'appendNodeToEnd'
    ].includes(command.type);
}














function $fa9ee0382ce8619d$export$1bd732ee2c8aaeb(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (nodeResult) return false;
        if (node.attrs.localId === localId) nodeResult = {
            node: node,
            pos: pos,
            parent: parent
        };
        return !nodeResult;
    });
    return nodeResult;
}
function $fa9ee0382ce8619d$export$a3fa3f6695d8b421(doc) {
    const ids = new Set();
    if (!doc) return ids;
    doc.descendants((node)=>{
        const localId = node.attrs?.localId;
        if (typeof localId === 'string' && localId.length > 0) ids.add(localId);
        return true;
    });
    return ids;
}
function $fa9ee0382ce8619d$export$c1cb5b5eb3aab3e3(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (node.attrs.localId === localId) {
            nodeResult = {
                node: node,
                pos: pos,
                parent: parent
            };
            return false;
        }
        return true;
    });
    return nodeResult;
}
function $fa9ee0382ce8619d$export$b7b4fc0a0195a016(api, localId) {
    if (!localId) return undefined;
    let foundNode;
    api?.core.actions.execute(({ tr: tr })=>{
        foundNode = $fa9ee0382ce8619d$export$1bd732ee2c8aaeb(tr.doc, localId)?.node;
        return null;
    });
    return foundNode;
}
function $fa9ee0382ce8619d$export$aadcc3ba2430b(api, tr, localId, callback, reversed) {
    const result = (reversed ? $fa9ee0382ce8619d$export$c1cb5b5eb3aab3e3 : $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(tr.doc, localId);
    if (result) {
        api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
        callback(result);
    }
    if (!result) {
        const localIdState = api?.localId?.sharedState.currentState();
        let localIdStatus;
        if (!localIdState) localIdStatus = 'localIdPluginMissing';
        else if (!localIdState.localIdWatchmenEnabled) localIdStatus = 'localIdWatchmenDisabled';
        else localIdStatus = localIdState.localIdStatus?.get(localId) ?? 'notFound';
        let docSize;
        // Quick and dirty way to get the node size - do not copy this pattern, use `requestDocument`
        api?.core.actions.execute(({ tr: tr })=>{
            docSize = tr.doc.nodeSize;
            return null;
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).LOCAL_ID_NOT_FOUND,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                localIdLength: localId?.length,
                docSize: docSize,
                scrubbedLocalId: (0, $dvybL.scrubStr)(localId),
                localIdStatus: (0, $ixfCV.fg)('platform_editor_ai_aifc_localid_error_reporting') ? localIdStatus : 'unavailable',
                localIdStatusSize: localIdState?.localIdStatus?.size ?? 0
            }
        });
        return null;
    }
    return tr;
}



var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

function $f2384266701dbede$export$7b6c9d9d26e2f428(api, response) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!schema || !response) return {
        adfDoc: response
    };
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $eOaGc.Transform)(doc);
        const node = (0, $aPdNQ.Node).fromJSON(schema, response);
        const newDoc = transform.replaceWith(0, 2, node).doc;
        return {
            doc: newDoc,
            // The "doc" response can cause nesting issues (ie. by wrapping a taskItem in doc -> taskList -> taskItem)
            // We should use the response, but for now only use it for `replaceNode` since it causes some edge cases with other commands
            // that need to be resolved separately
            adfDoc: response
        };
    } catch  {
        return {
            adfDoc: response
        };
    }
}


function $c9ae6183f2e7bf15$export$450b2ad108e2e506(api, initialNode, finalNode) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!initialNode || !finalNode || !schema || !initialNode.attrs.localId) return false;
    const finalPMDoc = (0, $f2384266701dbede$export$7b6c9d9d26e2f428)(api, finalNode)?.doc;
    if (!finalPMDoc) return false;
    const finalPMNode = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(finalPMDoc, initialNode.attrs.localId)?.node;
    return (finalPMNode && !initialNode.eq(finalPMNode) && (0, $6SJ6d.areNodesEqualIgnoreAttrs)(initialNode, finalPMNode)) ?? false;
}


function $800cd9937abd732b$export$6dcba6b9d3966cf9({ api: api, isCreateAction: isCreateAction, traceId: traceId, promptVersion: promptVersion }) {
    return (event)=>{
        const commonAttributes = {
            traceId: traceId,
            ...promptVersion && (0, $ixfCV.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                promptVersion: promptVersion
            } : {},
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction
            }
        };
        if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                ...commonAttributes,
                errorMessage: event.message,
                errorData: event.data
            }
        });
        else api?.analytics?.actions.fireAnalyticsEvent({
            action: 'info',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                ...commonAttributes,
                message: event.message,
                data: event.data
            }
        });
    };
}
function $800cd9937abd732b$export$7535a054b27a27c4({ api: api, initialNode: initialNode, lastDoc: lastDoc }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'replaceNodeAction',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'orchestratorReplaceNode',
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            attributeOnlyChange: (0, $c9ae6183f2e7bf15$export$450b2ad108e2e506)(api, initialNode, lastDoc),
            nodeName: initialNode?.type.name
        }
    });
}
// Validates the command is valid ()
const $800cd9937abd732b$var$validateCommandType = (cmd)=>cmd?.type && (0, $a04a7145bc1aceaa$export$d4371db4dc3f8b5f).includes(cmd.type) ? cmd.type : 'invalid';
function $800cd9937abd732b$export$276ecd5322451ab4({ api: api, docBeforeStreaming: docBeforeStreaming, command: command, traceId: traceId }) {
    const docAfterStreaming = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(api);
    if (docBeforeStreaming && docAfterStreaming) {
        const isSameDoc = docBeforeStreaming.eq(docAfterStreaming);
        const isSameDocIgnoreAttrs = (0, $6SJ6d.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming);
        if (isSameDoc || isSameDocIgnoreAttrs) api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).NO_DOC_CHANGE_FOUND,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                command: $800cd9937abd732b$var$validateCommandType(command),
                isSameDoc: isSameDoc,
                isSameDocIgnoreAttrs: isSameDocIgnoreAttrs,
                traceId: traceId
            }
        });
        // Attribution-first `toolCallAnomaly { symptom: 'no_document_change' }` for
        // streamable commands. The call site (streamCommandQueue) defers this call until
        // after handleFinalize's commit transaction lands (via an isStreaming subscription),
        // so by the time this runs, getPmDoc() reflects the committed doc.
        // isSameDoc is therefore accurate: true only when the stream genuinely produced
        // no structural change.
        //
        // The legacy NO_DOC_CHANGE_FOUND event above keeps the broader isSameDoc ||
        // isSameDocIgnoreAttrs check for dashboard continuity.
        if (command !== undefined && (0, $e357a3431509036d$export$f85aff2979b590a7)(command) && (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            if ((0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch1')) {
                // CCI-16980: For the toolCallAnomaly path we use a narrower comparator that
                // ignores only `localId` attributes. `replaceNode` always produces replacement
                // nodes with fresh localIds (CCI-16968 pattern), so `isSameDoc` alone would
                // miss genuine no-ops. However, the old `isSameDocIgnoreAttrs` was too broad
                // — it ignored ALL attributes including meaningful ones like heading `level`,
                // `panelType`, `background` etc., causing false positives when a replaceNode
                // intentionally changed only those attributes.
                //
                // `areNodesEqualIgnoreAttrs(…, ['localId'])` strips only localId before
                // comparing, so attribute-only changes to level/panelType/background etc. are
                // still detected as real edits and will NOT fire no_document_change.
                //
                // Short-circuit on isSameDoc: if docs are byte-for-byte identical the
                // localId-only traversal is redundant (isSameDoc ⊆ isSameDocIgnoreLocalIdsOnly).
                const isSameDocIgnoreLocalIdsOnly = isSameDoc || (0, $6SJ6d.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming, [
                    'localId'
                ]);
                if (isSameDocIgnoreLocalIdsOnly) $800cd9937abd732b$export$4d196ad3126dbf0c({
                    api: api,
                    traceId: traceId,
                    commandType: command.type,
                    result: 'anomaly',
                    symptom: 'no_document_change'
                });
                else $800cd9937abd732b$export$4d196ad3126dbf0c({
                    api: api,
                    traceId: traceId,
                    commandType: command.type,
                    result: 'success'
                });
            } else // Gate OFF: reuse already-computed isSameDocIgnoreAttrs (line 139) to avoid
            // a redundant doc traversal.
            if (isSameDoc || isSameDocIgnoreAttrs) $800cd9937abd732b$export$4d196ad3126dbf0c({
                api: api,
                traceId: traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'no_document_change'
            });
            else $800cd9937abd732b$export$4d196ad3126dbf0c({
                api: api,
                traceId: traceId,
                commandType: command.type,
                result: 'success'
            });
        }
    }
}
function $800cd9937abd732b$export$8b7d4483ec260574({ api: api, sessionStarted: sessionStarted, endSessionCallCount: endSessionCallCount, lastEndedSessionId: lastEndedSessionId, isDoubleCall: isDoubleCall }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreamingEndSession',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            sessionStarted: sessionStarted,
            endSessionCallCount: endSessionCallCount,
            lastEndedSessionId: lastEndedSessionId,
            isDoubleCall: isDoubleCall
        }
    });
}
function $800cd9937abd732b$export$121949ee4a6ce5f6({ api: api, backendEndToPacerCompleteMs: backendEndToPacerCompleteMs, backlogCharsAtBackendEnd: backlogCharsAtBackendEnd, charsPerTickAtComplete: charsPerTickAtComplete, terminalType: terminalType, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'completed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'streamFlowPacerCompletion',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            backendEndToPacerCompleteMs: backendEndToPacerCompleteMs,
            backlogCharsAtBackendEnd: backlogCharsAtBackendEnd,
            charsPerTickAtComplete: charsPerTickAtComplete,
            terminalType: terminalType,
            traceId: traceId
        }
    });
}
function $800cd9937abd732b$export$4b84cbb6abceadd2({ api: api, sessionId: sessionId, traceId: traceId, promptVersion: promptVersion }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionStart',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'userFlow',
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            aiGroupId: sessionId,
            actionTaken: undefined,
            editCount: 0,
            aiSessionId: '',
            traceIds: traceId ? [
                traceId
            ] : undefined,
            ...promptVersion && (0, $ixfCV.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                promptVersion: promptVersion
            } : {}
        }
    });
}
function $800cd9937abd732b$export$2197bcc2a00f4a51({ api: api, command: command, actionId: actionId, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'captured',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'toolCall',
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            actionId: actionId,
            commandType: $800cd9937abd732b$var$validateCommandType(command),
            contentType: 'contentType' in command ? command.contentType : undefined,
            traceId: traceId
        }
    });
}
function $800cd9937abd732b$export$f31b302ceb439402({ api: api, traceId: traceId, outcomeClass: outcomeClass, detectionLayer: detectionLayer, symptom: symptom, finalJsonInvalid: finalJsonInvalid, finalJsonRepaired: finalJsonRepaired, finalAdfInvalid: finalAdfInvalid, finalAdfRepaired: finalAdfRepaired, unintendedRegionRemoved: unintendedRegionRemoved, unintendedRegionModified: unintendedRegionModified, noMeaningfulEffect: noMeaningfulEffect, intentEffectMismatch: intentEffectMismatch, removedNodeCount: removedNodeCount, totalNodeDelta: totalNodeDelta, textCharacterDelta: textCharacterDelta, commandTypeCounts: commandTypeCounts, selectionLocalIdsAvailable: selectionLocalIdsAvailable, heuristicInferred: heuristicInferred }) {
    // When no symptom is reported (e.g. clean_success) the routing table
    // returns `unknown`/`low`, which is the correct contract value for "no
    // detectable failure to attribute".
    const { attribution: attribution, confidence: confidence } = (0, $ba9e453592b72692$export$a76b6d56e2272140)(symptom ?? '', detectionLayer);
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionOutcome',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            traceId: traceId,
            outcomeClass: outcomeClass,
            attribution: attribution,
            confidence: confidence,
            detectionLayer: detectionLayer,
            symptom: symptom,
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired,
            ...unintendedRegionRemoved !== undefined ? {
                unintendedRegionRemoved: unintendedRegionRemoved
            } : {},
            ...unintendedRegionModified !== undefined ? {
                unintendedRegionModified: unintendedRegionModified
            } : {},
            ...noMeaningfulEffect !== undefined ? {
                noMeaningfulEffect: noMeaningfulEffect
            } : {},
            ...intentEffectMismatch !== undefined ? {
                intentEffectMismatch: intentEffectMismatch
            } : {},
            ...removedNodeCount !== undefined ? {
                removedNodeCount: removedNodeCount
            } : {},
            ...totalNodeDelta !== undefined ? {
                totalNodeDelta: totalNodeDelta
            } : {},
            ...textCharacterDelta !== undefined ? {
                textCharacterDelta: textCharacterDelta
            } : {},
            ...commandTypeCounts !== undefined ? {
                commandTypeCounts: commandTypeCounts
            } : {},
            ...selectionLocalIdsAvailable !== undefined ? {
                selectionLocalIdsAvailable: selectionLocalIdsAvailable
            } : {},
            ...heuristicInferred !== undefined ? {
                heuristicInferred: heuristicInferred
            } : {}
        }
    });
}
function $800cd9937abd732b$export$c20b86820b0850bf({ api: api, command: command, traceId: traceId, isCreateAction: isCreateAction, error: error }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'toolCallError',
            errorData: {
                commandType: command?.type,
                commandReason: command?.type === 'endStream' ? command?.reason : undefined,
                errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
            },
            traceId: traceId,
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction ?? false
            }
        }
    });
}
function $800cd9937abd732b$export$4d196ad3126dbf0c(args) {
    const { api: api, traceId: traceId, commandType: commandType, result: result } = args;
    const symptom = args.result === 'anomaly' ? args.symptom : undefined;
    const errorMessage = args.result === 'anomaly' ? args.errorMessage : undefined;
    const targetLocalId = args.result === 'anomaly' ? args.targetLocalId : undefined;
    const removedLocalIds = args.result === 'anomaly' ? args.removedLocalIds : undefined;
    const routed = result === 'anomaly' && symptom !== undefined && symptom !== 'no_document_change' ? (0, $ba9e453592b72692$export$a76b6d56e2272140)(symptom, 'orchestrator') : undefined;
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'toolCallResult',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            result: result,
            commandType: commandType,
            detectionLayer: 'orchestrator',
            traceId: traceId,
            ...symptom !== undefined && {
                symptom: symptom
            },
            ...routed !== undefined && {
                attribution: routed.attribution,
                confidence: routed.confidence
            },
            ...errorMessage !== undefined && {
                errorMessage: errorMessage
            },
            ...targetLocalId !== undefined && {
                scrubbedTargetLocalId: (0, $dvybL.scrubStr)(targetLocalId)
            },
            ...removedLocalIds !== undefined && {
                scrubbedRemovedLocalIds: removedLocalIds.map((id)=>(0, $dvybL.scrubStr)(id))
            }
        }
    });
}
function $800cd9937abd732b$export$50f05d3d56fe90a9({ api: api, commandType: commandType }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'anomaly',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'resumeAbortedToolCallFallback',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            commandType: commandType
        }
    });
}



var $cXtTj = parcelRequire("cXtTj");


var $9kYSx = parcelRequire("9kYSx");

function $69782acbd729286a$var$isNumber(value) {
    return typeof value === 'number';
}
function $69782acbd729286a$var$isRamp(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    return $69782acbd729286a$var$isNumber(v.initialDelaySec) && $69782acbd729286a$var$isNumber(v.stepDelaySec) && $69782acbd729286a$var$isNumber(v.flushDelaySec) && $69782acbd729286a$var$isNumber(v.growthFactor);
}
function $69782acbd729286a$var$getExperimentValue(key, defaultValue) {
    return (0, $cXtTj.default).getExperimentValue('platform-editor-ai-streaming-speed', key, defaultValue, {
        typeGuard: $69782acbd729286a$var$isNumber
    });
}
function $69782acbd729286a$export$9ea8217d5ec56f82(enabled) {
    if (enabled === false) return null;
    const backlogRampThreshold = $69782acbd729286a$var$getExperimentValue('backlogRampThreshold', 100);
    const initialCharsPerTick = $69782acbd729286a$var$getExperimentValue('initialCharsPerTick', 8);
    const maxCharsPerTick = $69782acbd729286a$var$getExperimentValue('maxCharsPerTick', 1000);
    const tickMs = $69782acbd729286a$var$getExperimentValue('tickMs', 41);
    const ramp = (0, $cXtTj.default).getExperimentValue('platform-editor-ai-streaming-speed', 'ramp', {
        initialDelaySec: 6,
        stepDelaySec: 3,
        flushDelaySec: 0.5,
        growthFactor: 1.5
    }, {
        typeGuard: $69782acbd729286a$var$isRamp
    });
    // These settings are copied from the ai plugins pacer -> platform/packages/editor/editor-plugin-ai/src/ui/utils/request/stream-flow-pacer.ts
    return new (0, $9kYSx.StreamFlowPacer)({
        backlogRampThreshold: backlogRampThreshold,
        initialCharsPerTick: initialCharsPerTick,
        maxCharsPerTick: maxCharsPerTick,
        ramp: ramp,
        tickMs: tickMs
    });
}





var $iLrhi = parcelRequire("iLrhi");








var $aAERY = parcelRequire("aAERY");





var $hEuOY = parcelRequire("hEuOY");


var $j2p1x = parcelRequire("j2p1x");




const $5a1197e1a8fb1986$var$reset = '\x1b[0m';
const $5a1197e1a8fb1986$var$red = '\x1b[31m';
const $5a1197e1a8fb1986$var$magenta = '\x1b[35m';
const $5a1197e1a8fb1986$var$green = '\x1b[32m';
const $5a1197e1a8fb1986$var$blue = '\x1b[34m';
class $5a1197e1a8fb1986$export$21e6cc849c1dc1ab {
    add(log) {
        if ((0, $ixfCV.fg)('platform_editor_editor_debugging_panel')) {
            try {
                if (window.top?.__aifcDebuggerEnabled__) {
                    const { type: type, message: message } = log;
                    // eslint-disable-next-line no-console
                    console.log(`${$5a1197e1a8fb1986$var$magenta}[AIFC]:EditorStreamQueue${$5a1197e1a8fb1986$var$reset} ${type === 'Public' ? $5a1197e1a8fb1986$var$green : type === 'Queue' ? $5a1197e1a8fb1986$var$blue : $5a1197e1a8fb1986$var$red}${type}${$5a1197e1a8fb1986$var$reset} ${message}`, log);
                }
            } catch  {
            // Ignore cross-origin errors
            }
            this.logs.push({
                type: log.type,
                message: log.message,
                timestamp: log.timestamp
            });
            if (this.logs.length > this.MAX_LENGTH) this.logs.shift(); // Remove the oldest log to maintain a max log
        }
    }
    logPublic(message, data) {
        this.add({
            type: 'Public',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logError(message, data) {
        this.add({
            type: 'Error',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logQueueState(message, data) {
        this.add({
            type: 'Queue',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    // Current ADF at the time of logging so we can recreate the scenario
    getAdf() {
        if (!this.api) return undefined;
        let doc;
        this.api.core.actions.execute(({ tr: tr })=>{
            doc = tr.doc.toJSON();
            return null;
        });
        return doc;
    }
    getDebugInformation() {
        return {
            logs: this.logs,
            adf: this.getAdf(),
            selection: this.api?.selection?.actions.getSelectionFragment() ?? undefined,
            localIds: this.api?.selection?.actions.getSelectionLocalIds() ?? undefined
        };
    }
    constructor(api){
        this.api = api;
        this.logs = [];
        this.MAX_LENGTH = 100;
        if ((0, $ixfCV.fg)('platform_editor_editor_debugging_panel')) {
            if (window.top) try {
                window.top.__aifcEditorDebugData__ = ()=>this.getDebugInformation();
            } catch  {
            // Ignore cross-origin errors
            }
        }
    }
}






/**
 * Walk the document once and collect everything the analyzer needs:
 * `byLocalId` (top-level node text-length lookup), `totalNodesTopLevel`,
 * `totalNodesRecursive` (used by `noMeaningfulEffect`), `totalTextLength`,
 * and `attrFingerprints` (multiset for `attrSignaturesEqual`).
 */ function $ea65a4b3d3a11c9b$var$snapshotDoc(doc) {
    const byLocalId = new Map();
    // Multiset (fingerprint → count) — catches compositional swaps with
    // matching unique fingerprints but different multiplicities.
    const attrFingerprints = new Map();
    // nested localId → top-level localId, built during the existing walk.
    const nestedToTopLevel = new Map();
    let totalNodesTopLevel = 0;
    let totalNodesRecursive = 0;
    let totalTextLength = 0;
    const content = doc.content;
    if (!Array.isArray(content)) return {
        byLocalId: byLocalId,
        totalNodesTopLevel: totalNodesTopLevel,
        totalNodesRecursive: totalNodesRecursive,
        totalTextLength: totalTextLength,
        attrFingerprints: attrFingerprints,
        nestedToTopLevel: nestedToTopLevel
    };
    for (const child of content){
        if (child === null || typeof child !== 'object') continue;
        totalNodesTopLevel += 1;
        const node = child;
        const localId = typeof node.attrs?.localId === 'string' ? node.attrs.localId : undefined;
        const { textLength: textLength, descendantCount: descendantCount } = $ea65a4b3d3a11c9b$var$collectSubtreeMetrics(node, attrFingerprints, localId, nestedToTopLevel);
        // `descendantCount` includes the root node itself.
        totalNodesRecursive += descendantCount;
        totalTextLength += textLength;
        if (localId !== undefined) byLocalId.set(localId, {
            localId: localId,
            textLength: textLength
        });
    }
    return {
        byLocalId: byLocalId,
        totalNodesTopLevel: totalNodesTopLevel,
        totalNodesRecursive: totalNodesRecursive,
        totalTextLength: totalTextLength,
        attrFingerprints: attrFingerprints,
        nestedToTopLevel: nestedToTopLevel
    };
}
/**
 * True when `doc` is an "empty" starting document — a single top-level
 * empty paragraph (no child content) and nothing else.
 *
 * The editor seeds a brand-new / fully-cleared page with one placeholder
 * paragraph. That placeholder carries no `localId`, so it counts as an
 * unlabelled top-level node. When `appendNodeToEnd` (or any additive
 * command) writes labelled content into such a page, the apply layer drops
 * the now-redundant placeholder paragraph — a benign, expected side effect,
 * NOT content loss.
 *
 * The unlabelled-node removal accounting in `analyzeOutcome` would otherwise
 * see `postUnlabelledCount (0) < preUnlabelledCount (1)` and raise a
 * false-positive `unintendedRegionRemoved` / `unexpected_content_removal`.
 * See CCI-17328.
 */ function $ea65a4b3d3a11c9b$var$isEmptyStartingDocument(doc) {
    const content = doc.content;
    if (!Array.isArray(content) || content.length !== 1) return false;
    const only = content[0];
    if (only === null || typeof only !== 'object') return false;
    const node = only;
    if (node.type !== 'paragraph') return false;
    // Empty paragraph: missing or empty `content` array.
    return !Array.isArray(node.content) || node.content.length === 0;
}
/**
 * Attrs excluded from the per-node fingerprint: `localId` (regenerated on
 * every streaming insert) and any `__`-prefixed key (editor-internal / UI-only
 * state, e.g. `__expanded`, `__autoSize`).
 */ function $ea65a4b3d3a11c9b$var$isIgnoredAttr(key) {
    return key === 'localId' || key.startsWith('__');
}
/**
 * Stable string fingerprint of a node's identity: `type` + sorted filtered
 * `attrs` + sorted marks. Used by `attrSignaturesEqual`.
 */ function $ea65a4b3d3a11c9b$var$buildNodeAttrFingerprint(node) {
    const type = typeof node.type === 'string' ? node.type : '?';
    const attrs = node.attrs;
    let attrsPart = '';
    if (attrs !== null && typeof attrs === 'object') {
        const keys = Object.keys(attrs).filter((k)=>!$ea65a4b3d3a11c9b$var$isIgnoredAttr(k)).sort();
        if (keys.length > 0) {
            const pairs = [];
            for (const key of keys){
                const value = attrs[key];
                pairs.push(`${key}=${JSON.stringify(value)}`);
            }
            attrsPart = `|${pairs.join(',')}`;
        }
    }
    // Fold marks into the fingerprint (each mark contributes type + attrs).
    const marks = node.marks;
    let marksPart = '';
    if (Array.isArray(marks) && marks.length > 0) {
        const markStrings = [];
        for (const mark of marks)if (mark !== null && typeof mark === 'object') markStrings.push($ea65a4b3d3a11c9b$var$buildNodeAttrFingerprint(mark));
        markStrings.sort();
        marksPart = `|marks=${markStrings.join(';')}`;
    }
    return `${type}${attrsPart}${marksPart}`;
}
/**
 * Estimated displayed-text contribution of atomic inline nodes that store
 * their user-visible text in attributes rather than child `text` nodes.
 *
 * Without this accounting the analyzer's `textCharacterDelta` would view
 * a legitimate user-requested conversion (e.g. "Notion" → status lozenge
 * labelled "Notion") as a large negative delta and incorrectly flag the
 * session with `unintendedTextModification`. See CCI-16817.
 *
 * The values returned are intentionally a coarse estimate — the analyzer
 * only consumes them as a `±1` tolerance proxy for "this region's text
 * length changed meaningfully". Sub-character precision is not required.
 *
 * Per-type rationale:
 * - `status`      — `attrs.text` is the lozenge label (e.g. "Notion").
 * - `date`        — rendered as a localised date badge; we have no access
 *                   to the formatter, so use a fixed `10` character estimate
 *                   (matches common short-date renderings like
 *                   "Jan 1, 2024").
 * - `mention`     — `attrs.text` (e.g. "@John Doe"); falls back to `0` if
 *                   absent (mention text is optional in the schema).
 * - `emoji`       — `attrs.text` (the rendered glyph) when present;
 *                   otherwise `attrs.shortName` (e.g. ":smile:").
 * - `inlineCard`  — renders as a link. URL-based cards expose
 *                   `attrs.url`; datasource-based cards (e.g. Jira
 *                   issue inline smart links) expose `attrs.data`
 *                   instead. We prefer `attrs.url` length when
 *                   present, otherwise fall back to
 *                   `JSON.stringify(attrs.data).length` so datasource
 *                   cards also contribute a non-zero text estimate
 *                   and don't re-trigger the
 *                   `unintendedTextModification` false-positive this
 *                   analyzer change is fixing. If neither attr is
 *                   present (malformed / unknown shape) we fall back
 *                   to a fixed `10` char estimate, mirroring `date`.
 * - `placeholder` — `attrs.text` is the placeholder string.
 */ function $ea65a4b3d3a11c9b$var$getAtomicInlineNodeTextLength(type, attrs) {
    // `date`'s estimate is independent of attrs content — it must return
    // the fixed value even when attrs is absent or non-object. Handled
    // before the `attrs === undefined` guard so a malformed-ADF `date`
    // node (missing attrs) does not silently fall through to `0` and
    // re-trigger the very false positive this analyzer change is
    // fixing. Short-date renderings are typically ~10 chars
    // ("Jan 1, 2024"); the exact value isn't important — the goal is
    // to absorb the text-delta of the conversion, not to match what
    // the renderer ultimately displays.
    if (type === 'date') return 10;
    if (attrs === undefined) return 0;
    switch(type){
        case 'status':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        case 'mention':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        case 'emoji':
            {
                const text = attrs.text;
                if (typeof text === 'string' && text.length > 0) return text.length;
                const shortName = attrs.shortName;
                return typeof shortName === 'string' ? shortName.length : 0;
            }
        case 'inlineCard':
            {
                const url = attrs.url;
                if (typeof url === 'string' && url.length > 0) return url.length;
                // Datasource-based inline cards (e.g. Jira-issue inline
                // smart links) carry no `url` attr — their content lives
                // in `attrs.data`. Serialise it to JSON to get a coarse
                // non-zero estimate so a text-to-datasource-inlineCard
                // conversion doesn't reintroduce the very false positive
                // CCI-16817 is fixing. The exact length is unimportant —
                // the analyzer only needs a ±1-tolerance proxy.
                const data = attrs.data;
                if (data !== undefined && data !== null) try {
                    return JSON.stringify(data).length;
                } catch  {
                // Circular refs or unserialisable values fall
                // through to the fixed estimate below.
                }
                // Last-resort fixed estimate — matches the rationale used
                // for `date` (locale-rendered content with no plain text
                // in the ADF). Avoids returning 0 for malformed/unknown
                // inlineCard shapes that would otherwise re-trigger the
                // false positive.
                return 10;
            }
        case 'placeholder':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        default:
            return 0;
    }
}
/**
 * Single recursive walk: returns `textLength` + `descendantCount`,
 * accumulates fingerprints into the passed-in multiset, and — as a free
 * byproduct of the traversal — records every descendant node's `localId`
 * into `nestedToTopLevel` mapped to `topLevelLocalId`. O(N) per snapshot.
 *
 * `textLength` counts characters from both regular `text` nodes AND from
 * atomic inline nodes that store their displayed text in attributes
 * (e.g. `status.text`, `mention.text`). See `getAtomicInlineNodeTextLength`
 * for the per-type contribution and CCI-16817 for the rationale.
 *
 * `topLevelLocalId` is `undefined` for the top-level node itself (which is
 * the ancestor, not a descendant) and for top-level nodes that lack a
 * `localId` (unlabelled nodes can't be looked up anyway). Only descendants
 * of a labelled top-level node are added to the map.
 */ function $ea65a4b3d3a11c9b$var$collectSubtreeMetrics(node, attrFingerprints, topLevelLocalId, nestedToTopLevel) {
    if (node === null || typeof node !== 'object') return {
        textLength: 0,
        descendantCount: 0
    };
    const n = node;
    let textLength = 0;
    let descendantCount = 1; // this node + its descendants below
    if (n.type === 'text' && typeof n.text === 'string') textLength += n.text.length;
    else if (typeof n.type === 'string') {
        const attrs = n.attrs !== null && typeof n.attrs === 'object' ? n.attrs : undefined;
        textLength += $ea65a4b3d3a11c9b$var$getAtomicInlineNodeTextLength(n.type, attrs);
    }
    const fingerprint = $ea65a4b3d3a11c9b$var$buildNodeAttrFingerprint(n);
    attrFingerprints.set(fingerprint, (attrFingerprints.get(fingerprint) ?? 0) + 1);
    if (Array.isArray(n.content)) for (const child of n.content){
        // Record the child's localId → top-level ancestor before recursing.
        // We do this here (at the child level, not the node level) so that
        // the top-level node itself is never added as its own descendant.
        if (topLevelLocalId !== undefined && child !== null && typeof child === 'object') {
            const childNode = child;
            const childLocalId = typeof childNode.attrs?.localId === 'string' ? childNode.attrs.localId : undefined;
            if (childLocalId !== undefined) nestedToTopLevel.set(childLocalId, topLevelLocalId);
        }
        const childMetrics = $ea65a4b3d3a11c9b$var$collectSubtreeMetrics(child, attrFingerprints, topLevelLocalId, nestedToTopLevel);
        textLength += childMetrics.textLength;
        descendantCount += childMetrics.descendantCount;
    }
    return {
        textLength: textLength,
        descendantCount: descendantCount
    };
}
function $ea65a4b3d3a11c9b$export$6cc6bb4851b62689(toolCalls) {
    const ids = new Set();
    for (const record of toolCalls){
        if (record.targetLocalId !== undefined) ids.add(record.targetLocalId);
        if (Array.isArray(record.targetLocalIds)) for (const id of record.targetLocalIds)ids.add(id);
    }
    return ids;
}
function $ea65a4b3d3a11c9b$export$61c69a2d86d8e0fe(doc) {
    return $ea65a4b3d3a11c9b$var$snapshotDoc(doc).nestedToTopLevel;
}
const $ea65a4b3d3a11c9b$var$APPEND_INTENT_COMMANDS = new Set([
    'append',
    'appendNode',
    'appendNodeToEnd',
    'insertNodeAfter',
    'insertNodeBefore'
]);
const $ea65a4b3d3a11c9b$var$REWRITE_INTENT_COMMANDS = new Set([
    'replaceNode',
    'setAttrs',
    'wrap',
    'wrapNode'
]);
const $ea65a4b3d3a11c9b$var$REMOVE_INTENT_COMMANDS = new Set([
    'removeNode',
    'removeNodes',
    'moveNode'
]);
const $ea65a4b3d3a11c9b$export$55aaf9e829063b88 = 0.7;
function $ea65a4b3d3a11c9b$var$inferSessionIntent(toolCalls) {
    let hasAppend = false;
    let hasRewrite = false;
    let hasRemove = false;
    for (const call of toolCalls){
        if ($ea65a4b3d3a11c9b$var$APPEND_INTENT_COMMANDS.has(call.commandType)) hasAppend = true;
        else if ($ea65a4b3d3a11c9b$var$REWRITE_INTENT_COMMANDS.has(call.commandType)) hasRewrite = true;
        else if ($ea65a4b3d3a11c9b$var$REMOVE_INTENT_COMMANDS.has(call.commandType)) hasRemove = true;
    }
    const categoryCount = (hasAppend ? 1 : 0) + (hasRewrite ? 1 : 0) + (hasRemove ? 1 : 0);
    if (categoryCount !== 1) // Either zero recognised categories (no signal) or two-or-more
    // (genuinely mixed — heuristic too noisy to apply).
    return 'mixed';
    if (hasAppend) return 'append';
    if (hasRewrite) return 'rewrite';
    return 'remove';
}
/**
 * Decide whether the top-level structural delta contradicts the inferred
 * intent. Uses the **top-level** node delta (not recursive) because the
 * heuristic targets root-shape contradictions and its `±1` tolerance was
 * tuned to the top-level scale.
 *
 * Threshold rationale:
 * - `'append'`  — any net removal (`topLevelNodeDelta < 0`) is a mismatch.
 *                  Net delta of `0` is allowed: a `replaceNode`-shaped
 *                  command can produce zero delta even with append intent
 *                  (this case is rare but not a contradiction).
 * - `'rewrite'` — `|topLevelNodeDelta| ≥ 2` is a mismatch. The `±1` window
 *                  absorbs single trailing whitespace / newline / paragraph
 *                  normalisation that can shift the top-level count by 1
 *                  without indicating a real structural change.
 * - `'remove'`  — `topLevelNodeDelta ≥ 0` is a mismatch (the apply layer
 *                  didn't actually remove anything despite remove intent).
 */ /**
 * Returns true when the session's inferred intent contradicts the observed
 * structural delta — a heuristic signal that something unexpected happened.
 *
 * @param intent - Inferred from the mix of tool-call types in the session.
 * @param topLevelNodeDelta - post minus pre top-level node count.
 * @param totalNodeDelta - post minus pre recursive node count (CCI-16969 P1).
 * @param anyAffectedLocalIdDisappearedPostApply - true when a targeted top-level
 *   node is absent from the post-doc (CCI-16969 P2): a replaceNode that expands
 *   one container into many top-level nodes produces a large topLevelNodeDelta
 *   that is intentional, not anomalous.
 */ function $ea65a4b3d3a11c9b$var$detectIntentEffectMismatch(intent, topLevelNodeDelta, totalNodeDelta, anyAffectedLocalIdDisappearedPostApply) {
    switch(intent){
        case 'append':
            return topLevelNodeDelta < 0;
        case 'rewrite':
            // CCI-16969 P2: when the targeted node itself disappeared from the
            // post-doc, the expansion is intentional (e.g. bulletList → headed
            // sections, expand → inline content). Skip the topLevelDelta check.
            if (anyAffectedLocalIdDisappearedPostApply) return false;
            return Math.abs(topLevelNodeDelta) >= 2;
        case 'remove':
            // CCI-16969 P1: removeNodes targeting nested nodes (e.g. tableRows
            // inside a table) leaves topLevelNodeDelta at 0 even though content
            // was legitimately removed. Use recursive totalNodeDelta instead,
            // which correctly captures nested removals.
            return totalNodeDelta >= 0;
        case 'mixed':
        default:
            return false;
    }
}
function $ea65a4b3d3a11c9b$export$9aa9db1056f785bc({ preSessionAdf: preSessionAdf, postSessionAdf: postSessionAdf, toolCalls: toolCalls, selectionLocalIds: selectionLocalIds }) {
    const pre = $ea65a4b3d3a11c9b$var$snapshotDoc(preSessionAdf);
    const post = $ea65a4b3d3a11c9b$var$snapshotDoc(postSessionAdf);
    const affectedLocalIds = $ea65a4b3d3a11c9b$export$6cc6bb4851b62689(toolCalls);
    if (Array.isArray(selectionLocalIds)) for (const id of selectionLocalIds)affectedLocalIds.add(id);
    // For any targeted localId that belongs to a nested node
    // (e.g. a paragraph inside a table cell), also add the top-level
    // ancestor's localId to `affectedLocalIds`. Without this, the
    // modification-detection loop below flags the top-level container
    // (table, panel, expand, etc.) as "unintentionally modified" even
    // though the change was entirely within the tool call's intended target.
    //
    // `pre.nestedToTopLevel` is built as a free byproduct of the
    // `snapshotDoc` walk above — no additional document traversal.
    // Snapshot the set before iterating so that newly added ancestor IDs are
    // not re-examined. Mutating a Set during for-of is valid JS (new entries
    // ARE visited), but snapshotting makes the intent explicit and removes the
    // dependency on that spec detail.
    for (const targetId of [
        ...affectedLocalIds
    ]){
        const topLevelAncestorId = pre.nestedToTopLevel.get(targetId);
        if (topLevelAncestorId !== undefined) affectedLocalIds.add(topLevelAncestorId);
    }
    /**
   * True when at least one targeted localId is absent from the post-doc.
   *
   * This happens when `replaceNode` (or similar) creates replacement nodes
   * with fresh localIds — the targeted node has been genuinely replaced, not
   * silently dropped. Using this guard prevents two classes of false positives:
   *
   * - CCI-16968: `noMeaningfulEffect` fires because `totalNodeDelta === 0`
   *   and `|textCharacterDelta| <= 1`, even though real content was rewritten
   *   (the targeted node's content is now under a different localId).
   *
   * - CCI-16969 (P2): `intentEffectMismatch` fires for 'rewrite' intent when
   *   `|topLevelNodeDelta| >= 2` because one container was replaced by many
   *   top-level nodes (e.g. a bulletList expanded into headed sections). The
   *   large top-level delta is intentional — the targeted node is gone and new
   *   nodes took its place.
   *
   * Known limitation: `pre.byLocalId` contains only top-level nodes, so this
   * check does not fire when a `replaceNode` targets a nested node (e.g. a
   * paragraph inside a table cell) and produces fresh localIds. In practice
   * the other `noMeaningfulEffect` conditions (`|textCharacterDelta| <= 1`)
   * rarely hold simultaneously for nested rewrites, so the gap is low-impact.
   */ const anyAffectedLocalIdDisappearedPostApply = [
        ...affectedLocalIds
    ].some((id)=>pre.byLocalId.has(id) && !post.byLocalId.has(id));
    // CCI-16970: replaceDoc replaces the entire document with HTML-streamed
    // content that goes through an HTML→ADF parser, which always assigns fresh
    // localIds to every node. As a result:
    //   • All pre-session localIds disappear from the post-doc, regardless of
    //     how much content the model actually preserved.
    //   • `affectedLocalIds` is always empty for replaceDoc (it has no
    //     `targetLocalId`).
    // Running the localId-based removal loop below would therefore flag every
    // pre-doc node as "unintendedly removed" on every replaceDoc session —
    // a guaranteed false positive even when the model faithfully rewrote the
    // entire document.
    //
    // Instead, for replaceDoc sessions we skip the localId loops entirely and
    // use a proportional text-loss check: the model genuinely truncated the
    // document only when the post-doc retains less than 70% of the pre-doc
    // text length.
    //
    // Threshold validation: tested against 11 production examples —
    //   7 false positives all had ≥96% text retention (well above 70%)
    //   4 true positives all had ≤52% text retention (well below 70%)
    // A 70% threshold cleanly separates the two populations.
    const hasReplaceDoc = (0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch1') && toolCalls.some((tc)=>tc.commandType === 'replaceDoc');
    let removedNodeCount = 0;
    let unintendedRegionRemoved = false;
    if (hasReplaceDoc) // Proportional text-loss check for replaceDoc sessions.
    // Only meaningful when the pre-doc had text to begin with; empty
    // documents are silently skipped to avoid division-by-zero edge cases.
    {
        if (pre.totalTextLength > 0 && post.totalTextLength < pre.totalTextLength * $ea65a4b3d3a11c9b$export$55aaf9e829063b88) {
            unintendedRegionRemoved = true;
            // Use the pre-doc top-level count so dashboards can see how many
            // nodes were effectively dropped (the post-doc nodes are all new).
            removedNodeCount = pre.totalNodesTopLevel;
        }
    } else {
        for (const [localId] of pre.byLocalId)if (!post.byLocalId.has(localId)) {
            removedNodeCount += 1;
            if (!affectedLocalIds.has(localId)) unintendedRegionRemoved = true;
        }
        // Account for unlabelled top-level nodes (no `localId` attr).
        // These can't be targeted by any tool call (every command keys off
        // `localId`), so a net drop in unlabelled-node count is by definition
        // unintended collateral damage. Tracking it here keeps
        // `removedNodeCount` consistent with `totalNodeDelta` and surfaces
        // the most clearly-anomalous removals on the `unintendedRegionRemoved`
        // flag.
        //
        // Known limitation: an equal-count swap (one unlabelled node removed
        // AND one unlabelled node added in the same session) is invisible to
        // this counter. Detecting it would require position/content matching,
        // which the analyzer intentionally avoids for cost reasons. Net delta
        // is sufficient for current dashboard needs.
        // Unlabelled-node accounting uses the top-level count: only top-level
        // nodes are keyed in `byLocalId`, so the comparison must be against
        // `totalNodesTopLevel` to keep the subtraction meaningful.
        const preUnlabelledCount = pre.totalNodesTopLevel - pre.byLocalId.size;
        const postUnlabelledCount = post.totalNodesTopLevel - post.byLocalId.size;
        // CCI-17328: appending labelled content to an empty starting document
        // (a single unlabelled placeholder paragraph) drops that placeholder.
        // That is a benign, expected removal — not content loss — so do not
        // count it towards `removedNodeCount` / `unintendedRegionRemoved`.
        // Guarded behind the telemetry patch3 gate; legacy behaviour is
        // preserved exactly when the gate is off.
        const benignEmptyDocPlaceholderRemoval = (0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch3') && $ea65a4b3d3a11c9b$var$isEmptyStartingDocument(preSessionAdf);
        if (postUnlabelledCount < preUnlabelledCount && !benignEmptyDocPlaceholderRemoval) {
            const unlabelledRemoved = preUnlabelledCount - postUnlabelledCount;
            removedNodeCount += unlabelledRemoved;
            unintendedRegionRemoved = true;
        }
    }
    // Modification detection uses total text-length inequality as a cheap
    // proxy for "this node's text changed". A `±1` character tolerance is
    // applied per node to absorb ProseMirror normalisation artefacts
    // (single trailing whitespace, newline, punctuation injection/strip
    // on block close) — same rationale as the session-wide
    // `noMeaningfulEffect` derivation. Same-length rewrites are still a
    // silent false negative — see the JSDoc on
    // `OutcomeAnalysis.unintendedRegionModified` for the known limitation.
    let unintendedRegionModified = false;
    for (const [localId, preRecord] of pre.byLocalId){
        const postRecord = post.byLocalId.get(localId);
        if (postRecord === undefined) continue;
        if (Math.abs(preRecord.textLength - postRecord.textLength) > 1 && !affectedLocalIds.has(localId)) {
            unintendedRegionModified = true;
            break;
        }
    }
    // Recursive count for `noMeaningfulEffect` — catches depth-only changes
    // (blank column added, empty rows removed, nested reorders). See CCI-16816.
    const totalNodeDelta = post.totalNodesRecursive - pre.totalNodesRecursive;
    // Top-level count for `intentEffectMismatch` — the heuristic's ±1
    // tolerance was tuned to top-level scale; recursive would be too noisy.
    const topLevelNodeDelta = post.totalNodesTopLevel - pre.totalNodesTopLevel;
    const intent = $ea65a4b3d3a11c9b$var$inferSessionIntent(toolCalls);
    const intentEffectMismatch = $ea65a4b3d3a11c9b$var$detectIntentEffectMismatch(intent, topLevelNodeDelta, totalNodeDelta, anyAffectedLocalIdDisappearedPostApply);
    // Multiset equality on per-node fingerprints. Catches attribute-only
    // changes and compositional swaps that node count + text length miss.
    let attrSignaturesEqual = pre.attrFingerprints.size === post.attrFingerprints.size;
    if (attrSignaturesEqual) {
        for (const [fingerprint, preCount] of pre.attrFingerprints)if (post.attrFingerprints.get(fingerprint) !== preCount) {
            attrSignaturesEqual = false;
            break;
        }
    }
    return {
        totalNodeDelta: totalNodeDelta,
        removedNodeCount: removedNodeCount,
        textCharacterDelta: post.totalTextLength - pre.totalTextLength,
        affectedLocalIds: affectedLocalIds,
        unintendedRegionModified: unintendedRegionModified,
        unintendedRegionRemoved: unintendedRegionRemoved,
        protectedContentRemoved: false,
        intentEffectMismatch: intentEffectMismatch,
        attrSignaturesEqual: attrSignaturesEqual,
        anyAffectedLocalIdDisappearedPostApply: anyAffectedLocalIdDisappearedPostApply
    };
}



var $kCECX = parcelRequire("kCECX");

const $ff56e6956d0962e2$export$47c18b0b568dba43 = (api, resume)=>{
    const live = api.aiExperience.actions.getAbortedToolCallPosition?.(resume.toolCallId);
    // The aborted tool call is being resumed now; drop its stored position so it
    // is not remapped again by subsequent resumes' transactions.
    api.aiExperience.actions.clearAbortedToolCallPosition?.(resume.toolCallId);
    if (live) return {
        fromPos: live.startPos,
        toPos: live.aiContentEndPos
    };
    return undefined;
};
const $ff56e6956d0962e2$export$b49478c44446ab49 = (api)=>(from, to)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            const docSize = tr.doc.content.size;
            const safeFrom = Math.max(0, Math.min(from, docSize));
            const safeTo = Math.max(safeFrom, Math.min(to, docSize));
            const selection = (0, $kCECX.TextSelection).create(tr.doc, safeFrom, safeTo);
            return tr.setSelection(selection).scrollIntoView();
        });
    };


/**
 * Classifies an error caught by the orchestrator's apply pipeline into one of
 * three normalized symptom strings, used by `fireToolCallApplyFailed` to drive
 * the shared `attributeError` routing table.
 *
 * The classification is intentionally conservative: definitive ProseMirror
 * `ReplaceError` instances and message-pattern-matched ADF schema validation
 * errors are routed to specific symptoms; anything ambiguous falls back to the
 * generic `apply_failed`, which routes to `unknown`/`low` so dashboards do not
 * incorrectly attribute fault to either layer.
 *
 * Pure function — no side effects, no logging, no external dependencies.
 */ /**
 * Patterns thrown by `prosemirror-model`'s `Node.fromJSON` /
 * `Mark.fromJSON` / `Fragment.fromJSON` when the incoming ADF describes a
 * node-type, mark-type, content-type, or shape that the local schema cannot
 * accept. These are caused by the *incoming* model output, not by the
 * orchestrator's apply logic — so they route to backend-quality attribution.
 *
 * See prosemirror-model/dist/index.cjs throw-sites for the canonical list.
 */ /* eslint-disable require-unicode-regexp -- The orchestrator's tsconfig
   targets ES5, which does not support the `u` flag in regex literals
   (TS1501). None of these patterns use Unicode-specific features, so
   the flag is not needed at runtime. */ const $47926c3fe91d7830$var$ADF_SCHEMA_ERROR_PATTERNS = [
    /^Invalid content for node type/,
    /^There is no (?:node|mark) type/,
    /^Invalid mark data for /,
    /^Empty text nodes are not allowed/,
    /^Invalid input for (?:Mark|Node|Fragment|Slice)\.fromJSON/,
    /^Invalid collection of marks for node /,
    /^Invalid text node in JSON/
];
/**
 * `RangeError` messages emitted by `prosemirror-model` and
 * `prosemirror-transform` from transaction-mechanics throw sites
 * (positions, replace/wrap/lift/join validation, slice resolution).
 *
 * Anything matching this list is a frontend apply-logic concern.
 *
 * Anything that is a `RangeError` but does NOT match either this list
 * OR the ADF schema list above is treated as ambiguous — native JS
 * also throws `RangeError` for non-PM reasons (e.g. "Maximum call
 * stack size exceeded", "Invalid array length", `Intl` constructor
 * failures, third-party libraries) and we deliberately route those
 * to `apply_failed` (`unknown`/`low`) so dashboards do not
 * misattribute them to either layer.
 */ const $47926c3fe91d7830$var$PM_TRANSACTION_ERROR_PATTERNS = [
    /^Position [0-9]+ out of range/,
    /^Inserted content deeper than insertion position/,
    /^Cannot (?:insert|replace|delete|wrap|join|split|lift|unwrap)/i,
    /^Selected node can't be replaced by content/,
    /can't (?:join|wrap|fit|lift|split)/i,
    /^Removing non-flat range/,
    /^Cannot find a valid cursor position/,
    /^Wrap (?:depth|range) /,
    /^Lifted range/,
    /^Tried to (?:lift|wrap|join|step)/,
    /^Step result has /,
    /^Invalid (?:position|step|content) for /
];
function $47926c3fe91d7830$export$e36a42623b7e8456(error) {
    if (!(error instanceof Error)) return {
        symptom: 'apply_failed'
    };
    // `ReplaceError` is exported by prosemirror-model and extends `Error`.
    // We match by `.name === 'ReplaceError'` rather than `instanceof` to
    // avoid a runtime dependency on prosemirror-model and to remain robust
    // across multiple loaded copies of the module.
    if (error.name === 'ReplaceError') return {
        symptom: 'apply_failed_pm_error'
    };
    if (error instanceof RangeError) {
        for (const pattern of $47926c3fe91d7830$var$ADF_SCHEMA_ERROR_PATTERNS){
            if (pattern.test(error.message)) return {
                symptom: 'apply_failed_adf_schema_error'
            };
        }
        for (const pattern of $47926c3fe91d7830$var$PM_TRANSACTION_ERROR_PATTERNS){
            if (pattern.test(error.message)) return {
                symptom: 'apply_failed_pm_error'
            };
        }
    // Unmatched `RangeError` — could be a JS-engine error (e.g.
    // "Maximum call stack size exceeded"), an `Intl`/Date/Number
    // validation throw, or a third-party library throw. Route to
    // `apply_failed` so dashboards stay conservative and do not
    // misattribute non-PM faults to the apply layer.
    }
    return {
        symptom: 'apply_failed'
    };
}



/**
 * The set of command types whose targeted subtree is genuinely
 * removed from the doc. For these, descendant `localId`s of the
 * target are also expected to disappear from the post-apply snapshot
 * and must be added to the exclusion set so they don't fire
 * `unexpected_node_removal` spuriously.
 *
 * Commands like `moveNode`, `wrap`, and `wrapNode` are deliberately
 * NOT in this set: they relocate/nest the targeted subtree but the
 * descendants remain in the doc. If a descendant of a moved or
 * wrapped node disappears, that IS a genuine anomaly worth surfacing
 * — so we leave it to `unexpected_node_removal` to fire.
 */ const $6718584366a375eb$var$COMMAND_TYPES_THAT_REMOVE_SUBTREE = new Set([
    'removeNode',
    'removeNodes',
    'replaceNode'
]);
function $6718584366a375eb$export$30ebe6cd1aac119d(command, preApplyDoc) {
    const ids = new Set();
    switch(command.type){
        case 'removeNode':
        case 'moveNode':
        case 'replaceNode':
            ids.add(command.localId);
            break;
        case 'removeNodes':
            for (const id of command.localIds)ids.add(id);
            break;
        case 'wrap':
        case 'wrapNode':
            ids.add(command.localId);
            break;
        default:
            break;
    }
    // Expand each direct target to include its descendant `localId`s
    // from the pre-apply doc, but ONLY for commands whose intent is to
    // remove the targeted subtree entirely. For moveNode/wrap/wrapNode
    // the subtree is preserved (relocated or nested), so its
    // descendants must still appear in the post-apply snapshot — if
    // they don't, that is a genuine anomaly we want to surface.
    if (preApplyDoc !== undefined && ids.size > 0 && $6718584366a375eb$var$COMMAND_TYPES_THAT_REMOVE_SUBTREE.has(command.type)) {
        // Snapshot the direct targets up-front because we're about to
        // mutate `ids` while iterating.
        const directTargets = Array.from(ids);
        for (const targetId of directTargets){
            const result = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(preApplyDoc, targetId);
            if (!result) continue;
            result.node.descendants((descendant)=>{
                const descendantLocalId = descendant.attrs?.localId;
                if (typeof descendantLocalId === 'string' && descendantLocalId.length > 0) ids.add(descendantLocalId);
                return true;
            });
        }
    }
    return ids;
}






function $9e7aabb2e4516310$export$c48ec1bf46060d54(commandsToProcess) {
    const mergedCommands = [];
    for (const command of commandsToProcess){
        const lastCommand = mergedCommands[mergedCommands.length - 1];
        // Check if we can merge the current command with the last one
        if (command.type === 'streamCommand' && lastCommand && lastCommand.type === 'streamCommand' && command.actionId === lastCommand.actionId) lastCommand.chunk = command.chunk;
        else // Otherwise, just push the command to mergedCommands
        mergedCommands.push(command);
    }
    return mergedCommands;
}


function $452730881cb932a3$export$6c44330c7facd24b(promise, options) {
    const { timeout: timeout, onTimeout: onTimeout, onCleanup: onCleanup } = options;
    let timeoutHandle;
    let timeoutResolve;
    let isCompleted = false;
    // Function to start/restart the timeout
    const resetTimeout = ()=>{
        if (isCompleted) return;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(()=>{
            if (!isCompleted) {
                onTimeout();
                timeoutResolve?.();
            }
        }, timeout);
    };
    const timeoutPromise = new Promise((resolve)=>{
        timeoutResolve = resolve;
    });
    resetTimeout();
    // Race the original promise against the timeout
    const wrappedPromise = Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>{
        isCompleted = true;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        onCleanup?.();
    });
    return {
        resetTimeout: resetTimeout,
        promise: wrappedPromise
    };
}



var $jTt8P = parcelRequire("jTt8P");

function $286950ef0f6e1392$export$ab173b3d1046c711(adfResponse, type, schema) {
    if (!adfResponse || type !== 'insertNodeAfter') return {
        updatedResponse: adfResponse,
        localId: undefined
    };
    const indexMap = [];
    let newLocalId = crypto.randomUUID();
    const depthToCheckAgainst = 0;
    // First pass just to get the node to update
    (0, $jTt8P.traverse)(adfResponse, {
        any: (_n, _p, index, depth)=>{
            if (depth === depthToCheckAgainst) indexMap.push(index);
        }
    });
    // Update the localId of the last node
    let localIdUpdated = false;
    const newAdfResponse = (0, $jTt8P.traverse)({
        ...adfResponse
    }, {
        any: (node, _p, index, depth)=>{
            if (depth === depthToCheckAgainst && indexMap[indexMap.length - 1] === index && !!schema?.nodes[node.type]?.spec?.attrs?.localId) {
                localIdUpdated = true;
                if (!!node?.attrs?.localId) newLocalId = node?.attrs?.localId;
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        localId: newLocalId
                    }
                };
            }
        }
    });
    return {
        updatedResponse: newAdfResponse ? newAdfResponse : adfResponse,
        localId: localIdUpdated ? newLocalId : undefined
    };
}








const $43211781682ae73a$export$9e6d85a71b01d30 = (api)=>()=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let selection;
            if ((0, $iLrhi.isEmptyDocument)(tr.doc)) selection = (0, $kCECX.Selection).atEnd(tr.doc);
            else {
                const $pos = tr.doc.resolve(tr.doc.content.size);
                tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
                selection = (0, $kCECX.TextSelection).create(tr.doc, $pos.pos + 1);
            }
            if (!selection) throw new Error('Failed to create selection');
            api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
            tr.setSelection(selection).scrollIntoView();
            return tr;
        });
    };






var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $bAYhP = parcelRequire("bAYhP");





const $e7ae99ec7aab8b89$var$nodeNamesToSkipInsertParagraph = [
    'listItem',
    'taskItem',
    'decisionItem'
];
const $e7ae99ec7aab8b89$export$d4ccce03e5361e34 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node, parent: parent })=>{
                if (node.type.name === 'tableRow' && parent) {
                    const tableMap = (0, $8Z43Z.TableMap).get(parent);
                    const $pos = tr.doc.resolve(pos);
                    const tableStart = $pos.start($pos.depth);
                    const rect = tableMap.findCell(pos - tableStart + 1);
                    const tableContext = {
                        map: tableMap,
                        table: parent,
                        tableStart: tableStart
                    };
                    (0, $bAYhP.addRow)(tr, tableContext, rect.bottom);
                    const $newPos = tr.doc.resolve(pos);
                    const table = $newPos.node($newPos.depth);
                    const newTableMap = (0, $8Z43Z.TableMap).get(table);
                    // Not considering merged cells
                    const cells = newTableMap.mapByRow[rect.bottom];
                    const selection = (0, $8HW7o.CellSelection).rowSelection(tr.doc.resolve(cells[0] + tableStart), tr.doc.resolve(cells[cells.length - 1] + tableStart));
                    tr.setSelection(selection).scrollIntoView();
                } else if ($e7ae99ec7aab8b89$var$nodeNamesToSkipInsertParagraph.includes(node.type.name) && parent) {
                    /**
						 * Not creating new paragraph node when inserting node after list item.
						 * Because when inserting new list item, it will add new list item in new list.
						 */ const selection = (0, $kCECX.TextSelection).create(tr.doc, pos + node.nodeSize);
                    tr.setSelection(selection).scrollIntoView();
                } else {
                    let insertPos = Math.min(pos + node.nodeSize, tr.doc.content.size);
                    while(insertPos < tr.doc.content.size){
                        const $pos = tr.doc.resolve(insertPos);
                        let nextNode = null;
                        // For top-level nodes (depth 0 = document), check document children directly
                        // For nested nodes, use nodeAfter which works at higher depths
                        if ($pos.depth === 0) {
                            // At document root level, find the next top-level child
                            const childIndex = $pos.indexAfter(0);
                            if (childIndex < tr.doc.childCount) nextNode = tr.doc.child(childIndex);
                        } else // For nested structures, nodeAfter works correctly
                        nextNode = $pos.nodeAfter;
                        // Skip nodes without localId (from previous AI insertions)
                        // This prevents sequential insertions from overriding each other
                        if (nextNode && !nextNode.attrs.localId) insertPos += nextNode.nodeSize;
                        else break;
                    }
                    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') insertPos--;
                    if ((0, $ieeJu.expValEquals)('platform_editor_ai_fix_insert_after_selection', 'isEnabled', true)) {
                        if (insertPos + 1 <= tr.doc.content.size) tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                        const selection = (0, $kCECX.TextSelection).create(tr.doc, Math.min(insertPos + 1, tr.doc.content.size));
                        tr.setSelection(selection).scrollIntoView();
                    } else {
                        tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                        const selection = (0, $kCECX.TextSelection).create(tr.doc, insertPos + 1);
                        tr.setSelection(selection).scrollIntoView();
                    }
                }
            }, // Inserting after should always look for the last node with a matching localid. This will ensure that we
            // always insert AFTER.
            true);
        });
    };






const $e260d991e2f29ec5$export$1226208ece997066 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos })=>{
                const selection = new (0, $kCECX.TextSelection)(tr.doc.resolve(pos));
                tr.setSelection(selection).scrollIntoView();
            });
        });
    };


















const $fdf8819bcf43bc0d$var$doesNodeContain = ({ start: start, nodeSize: nodeSize }, pos)=>pos > start && pos < start + nodeSize;
const $fdf8819bcf43bc0d$var$unsupportedTableStructureNodeTypes = new Set([
    'tableRow',
    'tableCell',
    'tableHeader'
]);
const $fdf8819bcf43bc0d$var$isUnsupportedTableStructureNode = (nodeTypeName)=>$fdf8819bcf43bc0d$var$unsupportedTableStructureNodeTypes.has(nodeTypeName);
const $fdf8819bcf43bc0d$var$isValidRelationship = (relationship)=>relationship === 'before' || relationship === 'after';
const $fdf8819bcf43bc0d$var$getFragmentTypes = (node)=>node.content.content.map((child)=>child.type.name);
const $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics = ({ api: api, reason: reason, sourceNodeType: sourceNodeType, anchorNodeType: anchorNodeType, sourceParentNodeType: sourceParentNodeType, destinationParentNodeType: destinationParentNodeType, parentNodeType: parentNodeType, fragments: fragments })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).INVALID_COMMAND_FOUND,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            success: false,
            repaired: false,
            errorMessage: 'moveNodeValidationFailed',
            validationReason: reason,
            sourceNodeType: sourceNodeType,
            anchorNodeType: anchorNodeType,
            sourceParentNodeType: sourceParentNodeType,
            destinationParentNodeType: destinationParentNodeType,
            parentNodeType: parentNodeType,
            fragments: fragments
        }
    });
};
const $fdf8819bcf43bc0d$export$731ead7592859425 = (api)=>(command)=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_move_node', 'isEnabled', true)) return false;
        return api.core.actions.execute(({ tr: tr })=>{
            const reportMissingLocalId = (localId)=>{
                // `findNodeByLocalId` owns the existing LOCAL_ID_NOT_FOUND analytics payload,
                // so we intentionally re-run it on miss even though we already did a pure lookup.
                (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, localId, ()=>{});
            };
            const nodeToMove = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(tr.doc, command.localId);
            if (!nodeToMove) {
                reportMissingLocalId(command.localId);
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'sourceNotFound'
                });
                return null;
            }
            const anchorNode = (0, $fa9ee0382ce8619d$export$1bd732ee2c8aaeb)(tr.doc, command.anchorLocalId);
            if (!anchorNode) {
                reportMissingLocalId(command.anchorLocalId);
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'anchorNotFound',
                    sourceNodeType: nodeToMove.node.type.name
                });
                return null;
            }
            if (command.localId === command.anchorLocalId) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'sameNode',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if (!$fdf8819bcf43bc0d$var$isValidRelationship(command.relationship)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidRelationship',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if ($fdf8819bcf43bc0d$var$isUnsupportedTableStructureNode(nodeToMove.node.type.name) || $fdf8819bcf43bc0d$var$isUnsupportedTableStructureNode(anchorNode.node.type.name)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'unsupportedTableStructure',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if ($fdf8819bcf43bc0d$var$doesNodeContain({
                start: nodeToMove.pos,
                nodeSize: nodeToMove.node.nodeSize
            }, anchorNode.pos)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'anchorInsideSource',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            const $sourcePos = tr.doc.resolve(nodeToMove.pos);
            const sourceIndex = $sourcePos.index();
            if (!$sourcePos.parent.canReplace(sourceIndex, sourceIndex + 1, (0, $aPdNQ.Fragment).empty)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidSourceParent',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name,
                    sourceParentNodeType: $sourcePos.parent.type.name,
                    parentNodeType: $sourcePos.parent.type.name
                });
                return null;
            }
            const slice = tr.doc.slice(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize, false);
            const insertPos = command.relationship === 'before' ? anchorNode.pos : anchorNode.pos + anchorNode.node.nodeSize;
            const validationTransform = new (0, $eOaGc.Transform)(tr.doc);
            validationTransform.delete(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize);
            const mappedInsertPos = validationTransform.mapping.map(insertPos);
            const $mappedInsertPos = validationTransform.doc.resolve(mappedInsertPos);
            const insertIndex = $mappedInsertPos.index();
            if (!$mappedInsertPos.parent.canReplace(insertIndex, insertIndex, slice.content)) {
                $fdf8819bcf43bc0d$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidDestination',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name,
                    destinationParentNodeType: $mappedInsertPos.parent.type.name,
                    parentNodeType: $mappedInsertPos.parent.type.name,
                    fragments: $fdf8819bcf43bc0d$var$getFragmentTypes(slice.content.firstChild ?? nodeToMove.node)
                });
                return null;
            }
            api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                isFinal: true
            });
            // [CCI-17297] Capture the moved node so we can record reviewable
            // segments. move is non-streamable: it mutates the doc directly here and
            // never reaches `buildCommitTransaction`. A move is modelled as a
            // "remove" at the source (zero-width after deletion) plus an "add" at the
            // destination. No-op when the New AIFC experience is OFF.
            const movedSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodeToMove.node), 0, 0);
            const sourceFrom = tr.mapping.map(nodeToMove.pos);
            tr.delete(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize);
            const appliedInsertPos = tr.mapping.map(insertPos);
            tr.replace(appliedInsertPos, appliedInsertPos, slice);
            const collapsedSource = tr.mapping.map(sourceFrom);
            api.aiExperience?.actions.recordAIContentSegments(tr, [
                {
                    startPos: collapsedSource,
                    endPos: collapsedSource,
                    originalUserContentSlice: movedSlice,
                    newSlice: (0, $aPdNQ.Slice).empty,
                    kind: 'remove'
                },
                {
                    startPos: appliedInsertPos,
                    endPos: appliedInsertPos + slice.size,
                    originalUserContentSlice: (0, $aPdNQ.Slice).empty,
                    newSlice: movedSlice,
                    kind: 'add'
                }
            ]);
            if ((0, $kCECX.NodeSelection).isSelectable(nodeToMove.node)) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, appliedInsertPos));
            else tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(appliedInsertPos)));
            tr.scrollIntoView();
            return tr;
        });
    };






const $1e600f514eaf34c7$export$9a6ccf2338830d60 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
                // Record a coarse "remove" segment so the Post Stream
                // Review modal can review / undo / redo this deletion. removeNode is
                // non-streamable: it mutates the doc directly here and never reaches
                // `buildCommitTransaction`, so we must record the segment ourselves.
                // The removed node becomes `originalUserContentSlice`; the segment
                // collapses to a zero-width range at the deletion point (`newSlice`
                // is empty). `recordAIContentSegments` is a no-op when the New AIFC
                // experience is OFF.
                const removedSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0);
                tr.delete(pos, pos + node.nodeSize).scrollIntoView();
                // Map the original position through the delete step to get the
                // collapsed (zero-width) position at the deletion point.
                const collapsedPos = tr.mapping.map(pos);
                api.aiExperience.actions.recordAIContentSegments(tr, [
                    {
                        startPos: collapsedPos,
                        endPos: collapsedPos,
                        originalUserContentSlice: removedSlice,
                        newSlice: (0, $aPdNQ.Slice).empty,
                        kind: 'remove'
                    }
                ]);
            });
        });
    };



const $c1ee154d5cff80f2$export$b932a8906dc70a6a = (api)=>(command)=>{
        const removeNode = (0, $1e600f514eaf34c7$export$9a6ccf2338830d60)(api);
        for (const localId of command.localIds)removeNode({
            type: 'removeNode',
            localId: localId
        });
        return true;
    };









const $e92a5a98bc795abf$export$8077407ea1dae01f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node })=>{
                // Record the exact located node so `buildMountTransaction` can rebuild
                // an accurate single-node `originalUserContentSlice`. Slicing the doc
                // range can return a different shape (e.g. listItem children of a
                // bulletList). The optional call on `recordOriginalNode` itself makes
                // this a no-op when the new AIFC experience gate is off or the action
                // is not present on the resolved AI experience API.
                api.aiExperience?.actions.recordOriginalNode?.(tr, node);
                let selection = null;
                if ((0, $kCECX.NodeSelection).isSelectable(node)) selection = (0, $kCECX.NodeSelection).create(tr.doc, pos);
                else {
                    const role = node.type.spec.tableRole;
                    if (role === 'cell' || role === 'header_cell') selection = (0, $8HW7o.CellSelection).create(tr.doc, pos);
                    else if (role === 'row') {
                        // There's always a cell after the row
                        const $cell = tr.doc.resolve(pos + 1);
                        selection = (0, $8HW7o.CellSelection).rowSelection($cell, $cell, true);
                    } else {
                        const $pos = tr.doc.resolve(pos);
                        const $end = tr.doc.resolve(pos + node.nodeSize);
                        selection = (0, $kCECX.TextSelection).between($pos, $end);
                    }
                }
                if (selection) tr.setSelection(selection).scrollIntoView();
            });
        });
    };








const $bb185a965101a71b$export$4e08a85ccc8f26d0 = (api)=>(_command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            if ((0, $ixfCV.fg)('platform_editor_ai_replace_doc_use_all_selection')) return tr.setSelection(new (0, $kCECX.AllSelection)(tr.doc)).scrollIntoView();
            const $start = tr.doc.resolve(0);
            const $end = tr.doc.resolve(tr.doc.content.size);
            return tr.setSelection((0, $kCECX.TextSelection).between($start, $end)).scrollIntoView();
        });
    };









const $88130d0c8e66d82d$var$getValidAttributes = (attrs, nodeSpec)=>{
    const validAttrs = {};
    for(const key in attrs)if (nodeSpec.attrs?.hasOwnProperty(key)) validAttrs[key] = attrs[key];
    return validAttrs;
};
const $88130d0c8e66d82d$export$3c4e918a3d6ca42f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let shouldExecute = false;
            (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                if (node) {
                    const attrs = command.attrs;
                    if (!attrs || typeof attrs !== 'object') return;
                    const validAttrs = $88130d0c8e66d82d$var$getValidAttributes(attrs, node.type.spec);
                    node.type.spec.attrs;
                    api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                        isFinal: true
                    });
                    // [CCI-17297] Capture the node BEFORE the attr change as the
                    // segment's original content; setAttrs is non-streamable so we
                    // record the reviewable "update" segment ourselves.
                    const originalSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0);
                    const from = tr.mapping.map(pos);
                    tr.setNodeMarkup(pos, node.type, {
                        ...node.attrs,
                        ...validAttrs
                    });
                    tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(pos)));
                    // Capture the node AFTER the attr change as the new content and
                    // record a coarse "update" segment spanning it. No-op when the
                    // New AIFC experience is OFF.
                    const mappedFrom = tr.mapping.map(from);
                    const updatedNode = tr.doc.nodeAt(mappedFrom);
                    if (updatedNode) api.aiExperience?.actions.recordAIContentSegments(tr, [
                        {
                            startPos: mappedFrom,
                            endPos: mappedFrom + updatedNode.nodeSize,
                            originalUserContentSlice: originalSlice,
                            newSlice: new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(updatedNode), 0, 0),
                            kind: 'update'
                        }
                    ]);
                    shouldExecute = true;
                }
            });
            return shouldExecute ? tr : null;
        });
    };



var $8hfTK = parcelRequire("8hfTK");


var $yQ01u = parcelRequire("yQ01u");





var $57Rmq = parcelRequire("57Rmq");














const $fa8ab6765ce29d9d$var$panelTypes = new (0, $8hfTK.default)((0, $yQ01u.panel).props.attrs.props.panelType.values);
function $fa8ab6765ce29d9d$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $fa8ab6765ce29d9d$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
function $fa8ab6765ce29d9d$var$getAncestorTypes($to) {
    const ancestors = [];
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        ancestors.push(ancestor.type.name);
    }
    return ancestors;
}
function $fa8ab6765ce29d9d$var$getChildTypes(fragment) {
    return fragment.content.map((node)=>node.type.name);
}
const $fa8ab6765ce29d9d$export$2c6212a0adabc271 = (api)=>(command)=>{
        let success = false;
        let error;
        let repaired = false;
        let ancestors = [];
        let fragments = [];
        api.core.actions.execute(({ tr: tr })=>{
            try {
                (0, $fa9ee0382ce8619d$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                    const $from = tr.doc.resolve(pos);
                    const $to = tr.doc.resolve(pos + node.nodeSize);
                    const range = $from.blockRange($to);
                    if (range) {
                        // [CCI-17297] Capture the pre-wrap content so we can record a
                        // reviewable "update" segment. wrap is non-streamable: it mutates
                        // the doc directly here and never reaches `buildCommitTransaction`.
                        const originalSlice = new (0, $aPdNQ.Slice)(tr.doc.slice(range.$from.pos, range.$to.pos).content, 0, 0);
                        const wrapFrom = tr.mapping.map(range.$from.pos);
                        const type = command.wrapperType === 'panel' && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.pickPanelTypeForInsertion)(range.$from) : tr.doc.type.schema.nodes[command.wrapperType];
                        const attrs = command.wrapperAttrs;
                        // TODO: EDITOR-1371 - Validate attributes for all nodes
                        if (command.wrapperType === 'panel' && attrs.panelType !== undefined) {
                            const panelType = command.wrapperAttrs.panelType;
                            const panelTypeResult = $fa8ab6765ce29d9d$var$panelTypes.search(panelType);
                            if (panelTypeResult.length) attrs.panelType = panelTypeResult[0].item;
                            else attrs.panelType = 'info';
                        }
                        try {
                            // NOTE: `wrapping` will be empty ([]) when it fits directly
                            const wrapping = (0, $eOaGc.findWrapping)(range, type, attrs);
                            if (wrapping !== null) {
                                tr.wrap(range, wrapping).scrollIntoView();
                                success = true;
                            } else {
                                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                                const fragment = slice.content;
                                let node = type.createAndFill(attrs, fragment);
                                if (!node) node = $fa8ab6765ce29d9d$var$wrapChild(fragment, type, attrs);
                                if (node) {
                                    const insertPos = $fa8ab6765ce29d9d$var$findPosForNode(node, $to);
                                    if (insertPos !== null) {
                                        tr.insert(insertPos, node).scrollIntoView();
                                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $aPdNQ.Slice).empty);
                                        success = true;
                                        repaired = true;
                                    }
                                }
                                ancestors = $fa8ab6765ce29d9d$var$getAncestorTypes($to);
                                fragments = $fa8ab6765ce29d9d$var$getChildTypes(fragment);
                            }
                        } catch (e) {
                            error = e;
                            // TODO: EDITOR-1370 - Log the error
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                        // [CCI-17297] Record a reviewable "update" segment for the wrap.
                        // After a successful wrap the new wrapper node sits at `wrapFrom`;
                        // the segment's original content is the pre-wrap slice captured
                        // above. No-op when the New AIFC experience is OFF.
                        if (success) {
                            const mappedWrapFrom = tr.mapping.map(wrapFrom);
                            const wrappedNode = tr.doc.nodeAt(mappedWrapFrom);
                            if (wrappedNode) api.aiExperience.actions.recordAIContentSegments(tr, [
                                {
                                    startPos: mappedWrapFrom,
                                    endPos: mappedWrapFrom + wrappedNode.nodeSize,
                                    originalUserContentSlice: originalSlice,
                                    newSlice: new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(wrappedNode), 0, 0),
                                    kind: 'update'
                                }
                            ]);
                        }
                    }
                });
                api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
            } catch (e) {
                error = e;
                // TODO: EDITOR-1370 - Log the error
                // eslint-disable-next-line no-console
                console.error(e);
            }
            return tr;
        });
        if (!success || repaired) {
            // Log the error
            const errorMessage = (0, $1w4hj.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) errorStack = error.stack || '';
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).INVALID_COMMAND_FOUND,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    success: // Disable for now #hot-122604
                    // command,
                    success,
                    repaired: repaired,
                    ancestors: ancestors,
                    fragments: fragments,
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        }
        return success;
    };


function $33e0a97ce57d98ef$export$a0774277976bc21f(api) {
    return {
        replaceDoc: (0, $bb185a965101a71b$export$4e08a85ccc8f26d0)(api),
        replaceNode: (0, $e92a5a98bc795abf$export$8077407ea1dae01f)(api),
        insertNodeBefore: (0, $e260d991e2f29ec5$export$1226208ece997066)(api),
        insertNodeAfter: (0, $e7ae99ec7aab8b89$export$d4ccce03e5361e34)(api),
        removeNode: (0, $1e600f514eaf34c7$export$9a6ccf2338830d60)(api),
        removeNodes: (0, $c1ee154d5cff80f2$export$b932a8906dc70a6a)(api),
        moveNode: (0, $fdf8819bcf43bc0d$export$731ead7592859425)(api),
        appendNode: (0, $43211781682ae73a$export$9e6d85a71b01d30)(api),
        appendNodeToEnd: (0, $43211781682ae73a$export$9e6d85a71b01d30)(api),
        wrap: (0, $fa8ab6765ce29d9d$export$2c6212a0adabc271)(api),
        wrapNode: (0, $fa8ab6765ce29d9d$export$2c6212a0adabc271)(api),
        setAttrs: (0, $88130d0c8e66d82d$export$3c4e918a3d6ca42f)(api)
    };
}


/**
 * Returns the wire-name of the streaming command associated with a failed
 * apply attempt, suitable for the `commandType` attribute on
 * `tool_call_apply_failed` events.
 *
 * Prefers the active `StreamingCommand` (e.g. `'replaceNode'`,
 * `'appendNodeToEnd'`) when available, falling back to the queue-level
 * discriminant (`'streamCommand'`, `'endStream'`, `'initStream'`) and finally
 * to `'unknown'`.
 */ function $e3512170c06603fc$var$extractCommandType(queuedCommand, activeCommand) {
    if (queuedCommand?.type === 'initStream') return queuedCommand.command.type;
    if (activeCommand?.type) return activeCommand.type;
    return queuedCommand?.type ?? 'unknown';
}
/**
 * Returns the `localId` of the node targeted by a failed apply attempt, if
 * one can be derived from the active command. Returns `undefined` for
 * commands that operate without a target node (e.g. `appendNodeToEnd`,
 * `getPageContent`) or when no command is in flight.
 */ function $e3512170c06603fc$var$extractTargetLocalId(queuedCommand, activeCommand) {
    const command = queuedCommand?.type === 'initStream' ? queuedCommand.command : activeCommand;
    if (command && 'localId' in command && typeof command.localId === 'string') return command.localId;
    return undefined;
}
/**
 * Command types whose execution mutates the document. Used by the post-apply
 * outcome analyzer to decide whether `noMeaningfulEffect` should fire — a
 * session that ran nothing but read-only commands cannot be flagged for "no
 * meaningful effect" because no effect was ever requested.
 */ const $e3512170c06603fc$var$MUTATING_COMMAND_TYPES = new Set([
    'append',
    'appendNode',
    'appendNodeToEnd',
    'replaceNode',
    'removeNode',
    'removeNodes',
    'setAttrs',
    'wrap',
    'wrapNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'moveNode'
]);
/**
 * Returns the `localId` field for a streaming command that targets a
 * single existing node, or `undefined` for commands without one
 * (`appendNode`, `appendNodeToEnd`) or whose target uses a different
 * shape (`removeNodes` uses `localIds[]` plural, not a single `localId`).
 *
 * Used by the pre-apply target-resolution check so we only fire
 * `local_id_not_found` when the command actually expected a node
 * by ID.
 */ function $e3512170c06603fc$var$getTargetLocalId(command) {
    if ('localId' in command && typeof command.localId === 'string') return command.localId;
    return undefined;
}
/**
 * Convert a `StreamingCommand` into the condensed `ToolCallRecord` shape
 * consumed by `analyzeOutcome`. Captures the command type and any localId
 * targets (single or list-shaped). Used to build the per-session tool-call
 * record so the analyzer can distinguish intentional removals/modifications
 * from collateral damage.
 */ function $e3512170c06603fc$var$toToolCallRecord(command) {
    const targetLocalId = $e3512170c06603fc$var$getTargetLocalId(command);
    const targetLocalIds = 'localIds' in command && Array.isArray(command.localIds) ? command.localIds.filter((id)=>typeof id === 'string') : undefined;
    return {
        commandType: command.type,
        ...targetLocalId !== undefined ? {
            targetLocalId: targetLocalId
        } : {},
        ...targetLocalIds !== undefined && targetLocalIds.length > 0 ? {
            targetLocalIds: targetLocalIds
        } : {}
    };
}
class $e3512170c06603fc$export$f3feb8728b17a0a9 {
    isActorReady() {
        try {
            const currentState = this.api.aiExperience.sharedState.currentState();
            if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
                // Check if actor exists and is in streaming state
                const actor = this.api.aiExperience.actions.getAiExperienceActor();
                return actor && currentState?.isStreaming === true;
            }
            return currentState?.isStreaming === true;
        } catch  {
            return false;
        }
    }
    commandToProcess(commandToProcess) {
        const { type: type, actionId: actionId, chunk: chunk } = commandToProcess;
        if (type === 'initStream') return this.initStreamPromise(commandToProcess.command, commandToProcess.options);
        else if (type === 'endStream') return this.endExperiencePromise(commandToProcess);
        else return this.processStreamCommandPromise(actionId, chunk);
    }
    async processQueue() {
        if (this.processingQueue) return;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.processingQueue = true;
        let commandsToProcess = [
            ...this.queue
        ].filter((cmd)=>cmd.actionId === this.currentAction?.id);
        this.inProcessing = [
            ...new Set(commandsToProcess.map((cmd)=>cmd.actionId))
        ];
        this.queue = this.queue.filter((cmd)=>!commandsToProcess.includes(cmd));
        let currentCommand = null;
        try {
            commandsToProcess = (0, $9e7aabb2e4516310$export$c48ec1bf46060d54)(commandsToProcess);
            for (const commandToProcess of commandsToProcess){
                currentCommand = commandToProcess;
                if (this.aborted.includes(commandToProcess.actionId)) {
                    // If we abort the last stream let's move onto the next stream
                    if (commandToProcess.type === 'endStream') this.resolvePendingQueue(true);
                    continue;
                }
                await this.wrapInTimeout(this.commandToProcess(commandToProcess), commandToProcess);
            }
        } catch (error) {
            if ((0, $ieeJu.expValEquals)('platform_editor_ai_fix_insert_after_selection', 'isEnabled', true)) {
                (0, $800cd9937abd732b$export$c20b86820b0850bf)({
                    api: this.api,
                    traceId: this.traceId,
                    command: currentCommand,
                    isCreateAction: this.currentAction?.isCreateAction,
                    error: error
                });
                // Fire the unified tool_call_anomaly event in parallel —
                // keeps the existing fireCommandError event flowing for
                // legacy dashboards while attribution-first dashboards
                // consume the new event.
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true) && this.telemetryEventsEnabled) {
                    const { symptom: symptom } = (0, $47926c3fe91d7830$export$e36a42623b7e8456)(error);
                    (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                        api: this.api,
                        traceId: this.traceId,
                        commandType: $e3512170c06603fc$var$extractCommandType(currentCommand, this.currentCommand),
                        targetLocalId: $e3512170c06603fc$var$extractTargetLocalId(currentCommand, this.currentCommand),
                        errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error),
                        result: 'anomaly',
                        symptom: symptom
                    });
                }
            } else throw error;
        } finally{
            // Reset the processing queue flag
            this.processingQueue = false;
            const lastCommand = commandsToProcess.pop();
            this.inProcessing = [];
            if (lastCommand?.type === 'endStream') this.checkAndResolveEmptyQueue();
        }
        // If commands have been added to the queue during async operations, process them now
        if (this.queue.filter((cmd)=>cmd.actionId === this.currentAction?.id).length > 0) this.processQueue();
        else if (this.queue.length > 0) this.queueTimeout = setTimeout(()=>{
            this.logger.logError(`Current stream queue timed out while starting next`, {
                actionId: this.currentAction?.id ?? undefined
            });
            this.resolvePendingQueue(true);
            this.processQueue();
        }, this.CURRENT_QUEUE_TIMEOUT);
    }
    onEmptyQueue() {
        const promise = new Promise((resolve)=>{
            this.onEmptyQueueResolve = resolve;
        });
        this.checkAndResolveEmptyQueue();
        return promise;
    }
    async wrapInTimeout(promise, cmd) {
        const { promise: wrappedPromise, resetTimeout: resetTimeout } = (0, $452730881cb932a3$export$6c44330c7facd24b)(promise, {
            timeout: this.COMMAND_TIMEOUT,
            onTimeout: ()=>{
                this.logger.logError(`Stream command timed out ${cmd.type}`, {
                    actionId: cmd.actionId,
                    chunk: cmd.chunk
                });
            },
            onCleanup: ()=>{
                this.currentCommandTimeoutReset = null;
                if (cmd.type === 'endStream') this.checkAndResolveEmptyQueue();
                this.resolvePendingQueue();
            }
        });
        this.currentCommandTimeoutReset = resetTimeout;
        await wrappedPromise;
    }
    /**
   * End the AI experience
   */ endStreamCommand(actionId, options) {
        // duplicated endStreamCommand will kill accept reject screen prematurely
        if (this.endedActionIds.includes(actionId)) {
            this.logger.logPublic('End Stream Command Ignored', {
                actionId: actionId
            });
            return;
        }
        this.endedActionIds.push(actionId);
        if (this.endedActionIds.length > 10) this.endedActionIds.shift();
        this.logger.logPublic('End Stream Command', {
            actionId: actionId
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endCurrentStream',
            forceAbortedToolCallId: options?.forceAbortedToolCallId
        });
        this.processQueue();
    }
    endExperience() {
        // if it's isFinalStream
        // - when auto accept AI changes is on, editor-plugin-ai will end itself
        // - when auto accept AI changes is off, the accept reject screen will be shown
        // if it's not isFinalStream, the endAIExperience is used to kill a previous AI modal
        // - which can be the previous accept reject screen
        // - or the command palette screen (followed by rovo free-gen screen)
        if (!this.isFinalStream) {
            this.logger.logQueueState('End AI Experience');
            this.api.aiExperience.actions.endAIExperience();
        }
        this.isFinalStream = false;
        this.adfStreamer?.reset();
        this.streamFlowPacer?.reset();
        this.subscription?.();
    }
    resolvePendingQueue(timeout = false) {
        if (timeout || this.isPendingResolveQueue) {
            const currentAction = this.queue.find((cmd)=>cmd.type === 'initStream') ?? null;
            this.logger.logQueueState('Resolve Pending Queue', {
                actionId: currentAction?.actionId,
                reason: timeout ? 'timeout' : 'isPendingResolveQueue'
            });
            if (timeout && (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) // Queue-stall timeout fired (no further commands arrived).
            // Idempotent via `fireSessionOutcomeOnce`'s once-per-session guard.
            this.fireSessionOutcomeOnce({
                lifecycleSymptom: 'session_timeout'
            });
            this.currentAction = currentAction ? {
                id: currentAction.actionId,
                isCreateAction: (currentAction.command.type === 'appendNode' || currentAction.command.type === 'appendNodeToEnd') && currentAction.command.streamingType === 'create',
                initialNode: (0, $fa9ee0382ce8619d$export$b7b4fc0a0195a016)(this.api, // replaceDoc has no localId — only replaceNode needs one here.
                currentAction.command.type === 'replaceNode' && currentAction.command.localId),
                type: currentAction.command.type
            } : null;
            this.isPendingResolveQueue = false;
        }
    }
    checkAndResolveEmptyQueue() {
        if (this.queue.length === 0 && this.inProcessing.length === 0) this.onEmptyQueueResolve?.();
    }
    endNonStreamble() {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.api.aiExperience.actions.dispatchAIEvent({
            type: 'complete',
            adfResponse: undefined
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            send({
                type: 'complete',
                markdown: '',
                adfResponse: undefined,
                cacheKey: '',
                modelInput: {}
            });
        }
    }
    async endExperiencePromise(command) {
        const { actionId: actionId, reason: reason } = command;
        this.logger.logQueueState('End Experience', {
            actionId: actionId,
            reason: reason
        });
        // Carry the force-aborted tool call id onto the terminal `complete` event
        // (emitted by finalStream below) so `buildCommitTransaction` can persist its
        // final positions for resume.
        this.pendingForceAbortedToolCallId = command.forceAbortedToolCallId;
        this.isPendingResolveQueue = reason === 'endCurrentStream';
        // should not check empty queue if the end command is triggered by the initStreamCommand
        // which is used to close a previous AI modal
        // because there are more commands to process even if the queue is empty
        // and this.isPendingResolveQueue will be reset, so use a different flag here
        const shouldCheckEmptyQueue = reason === 'endCurrentStream';
        const isStreamingCommand = !(this.currentAction?.type && !(0, $e357a3431509036d$export$f85aff2979b590a7)({
            type: this.currentAction?.type
        }));
        if (this.isStreaming && isStreamingCommand) {
            await this.processStreamCommandPromise(actionId, '', true);
            if (this.currentAction?.type === 'replaceNode') (0, $800cd9937abd732b$export$7535a054b27a27c4)({
                api: this.api,
                initialNode: this.currentAction.initialNode,
                lastDoc: this.adfStreamer?.getLastDoc()
            });
            this.scheduleDeferredNoDocChangeAnalytics();
        } else if (!isStreamingCommand) this.isFinalStream = true;
        return new Promise((resolve)=>{
            const endNow = ()=>{
                this.endExperience();
                // After we end the experience there are a number of React re-renders that occur immediately after
                // This causes the state to flick between streaming and not streaming, it's not pretty
                // but wrap this in a `requestAnimationFrame` to delay our check until this clears.
                // To fix this properly we probably need to decouple the state with React
                const checkStreaming = ()=>{
                    const resolveAndEndStream = ()=>{
                        resolve();
                        this.logger.logQueueState('End Experience Resolved', {
                            actionId: actionId,
                            reason: reason
                        });
                        this.resolvePendingQueue();
                        shouldCheckEmptyQueue && this.checkAndResolveEmptyQueue();
                    };
                    if (!isStreamingCommand) {
                        this.endNonStreamble();
                        resolveAndEndStream();
                        return;
                    }
                    if (!this.api.aiExperience?.sharedState.currentState()?.isStreaming) {
                        resolveAndEndStream();
                        return;
                    }
                    const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (!nextSharedState.isStreaming) {
                            unsubscribe();
                            resolveAndEndStream();
                        }
                    });
                };
                setTimeout(checkStreaming, 0);
            };
            // If we're not running the pacer or its a non-streamable command, end immediately
            if (!this.streamFlowPacer?.isRunning() || this.currentAction?.type && !(0, $e357a3431509036d$export$f85aff2979b590a7)({
                type: this.currentAction?.type
            })) endNow();
            else this.streamFlowPacer.onComplete(()=>{
                // Need to be careful not to end the experience too soon. We need to give the xstate and react time to process
                // the final stream events before we kill the experience. Otherwise you will see an unfinished stream in the doc.
                setTimeout(endNow, 100);
            });
        });
    }
    /**
   * Streams the AI experience
   */ /**
   * Called by the orchestrator plugin when the chunk strategy detects that
   * ADF schema content was rejected (e.g. blockCard inside listItem).
   * Fires a toolCallResult anomaly and suppresses the deferred success event.
   */ notifySchemaContentRejection(actionId, errorMessage) {
        if (this.toolCallResultFiredForCurrentCommand) return;
        const command = this.currentCommand;
        const traceId = this.traceId;
        if (!command || !traceId) return;
        this.toolCallResultFiredForCurrentCommand = true;
        (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
            api: this.api,
            traceId: traceId,
            commandType: command.type,
            result: 'anomaly',
            symptom: 'apply_failed_adf_schema_error',
            errorMessage: errorMessage
        });
    }
    queueStreamCommand(actionId, chunk) {
        this.logger.logPublic('Stream Command', {
            actionId: actionId,
            chunk: chunk
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'streamCommand',
            actionId: actionId,
            chunk: chunk
        });
        if (this.isActorReady()) this.processQueue();
        else {
            // if there are multiple sequential queueStreamCommand calls
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api?.aiExperience.sharedState.onChange(()=>{
                if (this.isActorReady()) {
                    unsubscribe?.();
                    this.processQueue();
                }
            });
        }
    }
    hasChangedDocument(latestDoc) {
        if (!this.previousValidDoc && latestDoc) return true;
        const nodesAreNotEqual = !this.previousValidDoc?.doc || !latestDoc?.doc || !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(this.previousValidDoc?.doc, latestDoc.doc);
        if (this.streamFlowPacer === null) {
            // replaceDoc is allowed to produce an empty document (e.g. "delete entire page"),
            // so we skip the isEmptyDocument guard for that action type.
            const isReplaceDoc = this.currentAction?.type === 'replaceDoc';
            if (isReplaceDoc) // For replaceDoc, latestDoc.doc may be undefined when the streamed content is
            // empty HTML (the adfStreamer returns undefined for empty input). We treat
            // "undefined → previous doc exists" as a change so the empty-page intent
            // is honoured — the final stream path will supply the empty-paragraph fallback.
            return Boolean(nodesAreNotEqual);
            return Boolean(nodesAreNotEqual && latestDoc.doc && !(0, $iLrhi.isEmptyDocument)(latestDoc.doc));
        }
        const latestCount = this.streamFlowPacer?.adfTextLen(latestDoc?.adfDoc);
        return Boolean(nodesAreNotEqual && latestDoc.adfDoc && this.previousValidDoc?.adfDoc && latestCount.chars > 0 && // Ensure we only stream changes if the stream flow pacer detects semantic changes
        !this.streamFlowPacer?.adfTextLen(this.previousValidDoc?.adfDoc).gte(latestCount));
    }
    createCallback(usePush) {
        if (usePush) return (evt)=>{
            const fullEvent = (0, $hEuOY.normaliseAIExperienceEvent)(evt);
            this?.streamFlowPacer?.push(fullEvent);
        };
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return (evt)=>{
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        };
        // Legacy path: send to actor with padded defaults
        const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
        return (evt)=>{
            const payload = (0, $hEuOY.normaliseAIExperienceEvent)(evt);
            send(payload);
        };
    }
    processStreamCommand(actionId, chunk, finalStream = false) {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.streamFlowPacer?.setEmit((evt)=>{
            // While the stream flow pacer is doing work reset the timeout
            this.currentCommandTimeoutReset?.();
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            this.streamFlowPacer?.setEmit((evt)=>{
                // While the stream flow pacer is doing work reset the timeout
                this.currentCommandTimeoutReset?.();
                send(evt);
            });
        }
        // Bypass the pacer when noStream is set (e.g. pre-computed results from semantic tool calls)
        const noStream = (0, $ieeJu.expValEquals)('platform_editor_ai_no_stream_skip_pacer', 'isEnabled', true) && this.currentAction?.type && 'noStream' in this.currentAction && this.currentAction.noStream;
        const callback = this.createCallback(!!this.streamFlowPacer?.push && !noStream);
        // Initialize streamer if needed
        if (!this.adfStreamer) {
            const schema = this.api.core.sharedState.currentState()?.schema;
            this.adfStreamer = schema ? new (0, $aAERY.ADFStreamer)(schema, (0, $800cd9937abd732b$export$6dcba6b9d3966cf9)({
                api: this.api,
                isCreateAction: this.currentAction?.isCreateAction ?? false,
                traceId: this.traceId,
                promptVersion: this.promptVersion
            })) : undefined;
        }
        if (finalStream) {
            const lastDocResult = (0, $f2384266701dbede$export$7b6c9d9d26e2f428)(this.api, this.adfStreamer?.getLastDoc());
            let adfResponseBefore = lastDocResult.adfDoc;
            // replaceDoc with an empty value (e.g. "delete entire page") produces either no
            // ADF or a bare { type:"doc" } with no content from the streamer. Substitute a
            // minimal empty document so the downstream insertion path actually clears the
            // editor content rather than silently no-oping.
            const isFinalEffectivelyEmptyDoc = !adfResponseBefore || !adfResponseBefore.content || adfResponseBefore.content.length === 0;
            if (isFinalEffectivelyEmptyDoc && this.currentAction?.type === 'replaceDoc') adfResponseBefore = {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            };
            const schema = this.api.core.sharedState.currentState()?.schema;
            const { updatedResponse: updatedResponse, localId: localId } = (0, $286950ef0f6e1392$export$ab173b3d1046c711)(adfResponseBefore, this.currentAction?.type, schema);
            const adfResponse = updatedResponse;
            this.insertAfterQueueLocalId = localId;
            const repairSignals = this.adfStreamer?.endStreamingSession({
                hasProcessedFinalResponse: true
            });
            if (repairSignals && (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) // A session may contain multiple streaming actions. Aggregate
            // repair signals across them so the final `sessionOutcome` event
            // correctly reflects the worst per-action outcome:
            // - `*Invalid`: OR — any invalid action means the session saw
            //   that layer fail at least once.
            // - `unrepaired*Count`: count actions whose invalid layer was
            //   NOT recovered. The session is only considered "fully
            //   repaired" if this count is zero. A naive OR over the
            //   per-action `*Repaired` flags would incorrectly mask a
            //   later irrecoverable failure when an earlier action had
            //   recovered.
            this.sessionRepairSignals = {
                anyJsonInvalid: this.sessionRepairSignals.anyJsonInvalid || repairSignals.finalJsonInvalid,
                anyAdfInvalid: this.sessionRepairSignals.anyAdfInvalid || repairSignals.finalAdfInvalid,
                unrepairedJsonCount: this.sessionRepairSignals.unrepairedJsonCount + (repairSignals.finalJsonInvalid && !repairSignals.finalJsonRepaired ? 1 : 0),
                unrepairedAdfCount: this.sessionRepairSignals.unrepairedAdfCount + (repairSignals.finalAdfInvalid && !repairSignals.finalAdfRepaired ? 1 : 0)
            };
            this.logger.logQueueState('Final Stream', {
                actionId: actionId,
                adf: adfResponse,
                finalStream: true
            });
            const forceAbortedToolCallId = this.pendingForceAbortedToolCallId;
            this.pendingForceAbortedToolCallId = undefined;
            callback({
                type: 'complete',
                adfResponse: adfResponse,
                ...forceAbortedToolCallId ? {
                    forceAbortedToolCallId: forceAbortedToolCallId
                } : {}
            });
            return true;
        }
        // Resetting because we are going to get full ADF as chunk
        this.adfStreamer?.reset();
        this.adfStreamer?.processChunk(chunk);
        const latestDoc = (0, $f2384266701dbede$export$7b6c9d9d26e2f428)(this.api, noStream ? this.adfStreamer?.getLastDoc() : this.adfStreamer?.getLastDocWithoutLastLeafNode());
        const changed = this.hasChangedDocument(latestDoc);
        this.previousValidDoc = latestDoc;
        // We compare the before/after docs because if nothing has changed then it will not trigger a react update (because the adfResponse needs to be different)
        // which means the chunkNumber will never update and the processStreamCommandPromise Promise will never resolve.
        // This cause the wrapInTimeout 1sec delay to occur before the next chunk is processed. This means we can end up in a situation
        // where we're recieving a lot of chunks, but nothing in the view is changed and everything starts taking a lot of time
        // because of the sequential 1sec failovers.
        if (changed) {
            // For replaceDoc with an empty value (e.g. "delete entire page"), the adfStreamer
            // returns either undefined or a bare { type:"doc" } with no content — fall back to
            // a minimal empty document so the editor content is actually cleared.
            const isEffectivelyEmptyDoc = !latestDoc.adfDoc || !latestDoc.adfDoc.content || latestDoc.adfDoc.content.length === 0;
            const streamAdfResponse = isEffectivelyEmptyDoc && this.currentAction?.type === 'replaceDoc' ? {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            } : latestDoc.adfDoc;
            callback({
                type: 'stream',
                adfResponse: streamAdfResponse
            });
            return true;
        }
        return false;
    }
    processStreamCommandPromise(actionId, chunk, finalStream = false) {
        this.logger.logQueueState('Streaming Command', {
            actionId: actionId,
            chunk: chunk,
            finalStream: finalStream
        });
        this.isStreaming = !finalStream;
        this.isFinalStream = finalStream;
        return new Promise((resolve)=>{
            // do not wrap the code in setTimeout, it will pause the streaming when the tab is in background
            const chunkBefore = this.api.aiExperience?.sharedState.currentState()?.chunkNumber;
            if (!this.processStreamCommand(actionId, chunk, finalStream)) {
                // If nothing was processed then we should be able to end immediately since we will never get a chuckNumber update
                // this means the next chunk can be processed straight away.
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            if (chunkBefore !== this.api.aiExperience?.sharedState.currentState()?.chunkNumber) {
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            // if there are multiple sequential queueStreamCommand calls and one of them timeout
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (nextSharedState?.chunkNumber !== prevSharedState?.chunkNumber) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState('Streaming Command Resolved', {
                        actionId: actionId,
                        chunk: chunk,
                        finalStream: finalStream
                    });
                }
            });
        });
    }
    /**
   * Streams the AI experience
   */ initStreamCommand(actionId, command, options) {
        this.logger.logPublic('Init Command', {
            actionId: actionId,
            command: command
        });
        this.isAborted = false;
        // Track tool call captured for analytics
        if ((0, $ixfCV.fg)('platform_editor_ai_tool_call_received_analytics')) (0, $800cd9937abd732b$export$2197bcc2a00f4a51)({
            api: this.api,
            command: command,
            actionId: actionId,
            traceId: this.traceId
        });
        if (!this.currentAction) this.currentAction = {
            id: actionId,
            isCreateAction: (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create',
            initialNode: (0, $fa9ee0382ce8619d$export$b7b4fc0a0195a016)(this.api, // replaceDoc has no localId — only pass localId for replaceNode.
            command.type === 'replaceNode' && command.localId),
            type: command.type
        };
        // If we're already running end the stream and restart
        if (this.api.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.isRunning) this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endPreviousStream'
        });
        this.queue.push({
            type: 'initStream',
            actionId: actionId,
            chunk: undefined,
            command: command,
            options: options
        });
        this.processQueue();
    }
    applyCommand(command) {
        const insertAfterQueue = this.currentCommand?.type === 'insertNodeAfter' && command.type === 'insertNodeAfter' && command.localId === this.currentCommand?.localId;
        this.currentCommand = command;
        if ((0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch2')) this.toolCallResultFiredForCurrentCommand = false;
        this.docBeforeStreaming = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        let isSuccessful = true;
        // Apply-anomaly diagnostics: see runPre/PostApplyDiagnostics for
        // the symptoms detected. Gated to keep the snapshot/diff cost
        // (and any associated bookkeeping) out of the hot path entirely
        // when the experiment is off.
        const normalizedTelemetryEnabled = (0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true);
        // Record this tool call so end-of-session `analyzeOutcome` can
        // distinguish intentional removals/modifications from collateral
        // damage. Only collected when the experiment is on.
        if (normalizedTelemetryEnabled) this.sessionToolCalls.push($e3512170c06603fc$var$toToolCallRecord(command));
        // The localId the apply path will actually attempt to act on.
        // `insertAfterQueue` commands rewrite the localId at apply time
        // so that consecutive `insertNodeAfter` calls chain correctly
        // (see the apply branch below). Diagnostics must use the same
        // effective localId so target-resolution checks match the apply
        // path's actual behaviour — otherwise we get false positives
        // (command.localId missing but insertAfterQueueLocalId valid) and
        // false negatives (the inverse).
        const effectiveTargetLocalId = normalizedTelemetryEnabled ? insertAfterQueue && this.insertAfterQueueLocalId ? this.insertAfterQueueLocalId : $e3512170c06603fc$var$getTargetLocalId(command) : undefined;
        const preApplyResult = normalizedTelemetryEnabled ? this.runPreApplyDiagnostics(command, effectiveTargetLocalId) : undefined;
        // If we have subsequent "insertAfter" commands with the same localId, instead point to the end of the
        // previous insertion. This is because the AI will "insertAfter" in a logical order, but that puts the content
        // into the document backwards.
        if (insertAfterQueue && this.insertAfterQueueLocalId) // If for some reason the localId doesn't exist in the document fallback to the original stream command
        try {
            isSuccessful = this.streamingCommands[command.type]({
                ...command,
                localId: this.insertAfterQueueLocalId
            });
        } catch  {
            isSuccessful = this.streamingCommands[command.type](command);
        }
        else isSuccessful = this.streamingCommands[command.type](command);
        const postApplyAnomalyDetected = normalizedTelemetryEnabled && preApplyResult !== undefined && !preApplyResult.anomalyDetected ? this.runPostApplyDiagnostics(command, preApplyResult.preApplyLocalIds, effectiveTargetLocalId) : false;
        // Fire success only if no anomaly detected and not a streamable
        // command. Streamable commands defer success/anomaly to
        // checkAndFireNoDocumentChangeAnalytics once streaming completes, since
        // the doc change arrives via chunks after applyCommand returns.
        if (normalizedTelemetryEnabled && this.telemetryEventsEnabled) {
            const preApplyAnomalyDetected = preApplyResult?.anomalyDetected ?? false;
            if (!preApplyAnomalyDetected && !postApplyAnomalyDetected && !(0, $e357a3431509036d$export$f85aff2979b590a7)(command)) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'success'
            });
        }
        return isSuccessful;
    }
    /**
   * Apply-anomaly diagnostics: pre-apply phase. Snapshots full-depth
   * localIds and fires `local_id_not_found` if the command targets
   * a localId that doesn't exist. Returns the snapshot for reuse by the
   * post-apply phase.
   *
   * Caller is responsible for the experiment gate check, and for
   * computing `effectiveTargetLocalId` so it reflects what the apply
   * path will actually act on (e.g. the substituted
   * `insertAfterQueueLocalId` for chained `insertNodeAfter` calls).
   */ runPreApplyDiagnostics(command, effectiveTargetLocalId) {
        const preApplyLocalIds = (0, $fa9ee0382ce8619d$export$a3fa3f6695d8b421)(this.docBeforeStreaming ?? undefined);
        // Use the live PM doc lookup (same walk every command uses) so
        // detection is ground-truth equivalent to the apply layer.
        if (effectiveTargetLocalId !== undefined && (0, $fa9ee0382ce8619d$export$b7b4fc0a0195a016)(this.api, effectiveTargetLocalId) === undefined) {
            if (this.telemetryEventsEnabled) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'local_id_not_found',
                targetLocalId: effectiveTargetLocalId
            });
            return {
                anomalyDetected: true,
                preApplyLocalIds: preApplyLocalIds
            };
        }
        return {
            anomalyDetected: false,
            preApplyLocalIds: preApplyLocalIds
        };
    }
    /**
   * Apply-anomaly diagnostics: post-apply phase. Diffs the post-apply
   * full-depth localId snapshot against the pre-apply snapshot (both
   * built via `collectAllLocalIds`, so every depth is included) and
   * fires:
   * - `unexpected_node_removal` when nodes disappeared that the command
   *   wasn't supposed to remove/relocate. Reports
   *   `effectiveTargetLocalId` so the dashboard reader sees the localId
   *   the apply path actually acted on.
   * - `no_document_change` when a mutating command produced no document
   *   change at all.
   * Caches the post-apply snapshot for reuse by the next applyCommand.
   *
   * Caller is responsible for the experiment gate check, and for
   * computing `effectiveTargetLocalId` so it reflects what the apply
   * path actually acted on (see `runPreApplyDiagnostics`).
   */ runPostApplyDiagnostics(command, preApplyLocalIds, effectiveTargetLocalId) {
        const postApplyDoc = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        if (postApplyDoc === undefined) // Editor view unavailable post-apply (teardown race). Skip
        // the diff — can't distinguish "everything removed" from
        // "couldn't observe post-apply state".
        return false;
        // Full-depth snapshot so the diff catches collateral removals
        // nested inside layouts, expand blocks, panels, table cells, etc.
        const postApplyLocalIds = (0, $fa9ee0382ce8619d$export$a3fa3f6695d8b421)(postApplyDoc);
        // Pass `docBeforeStreaming` so the helper can expand each direct
        // target to include its descendant `localId`s. Required since
        // the diff above (`collectAllLocalIds`) is full-depth — removing
        // a container would otherwise spuriously fire
        // `unexpected_node_removal` for every nested descendant.
        const explicitTargets = (0, $6718584366a375eb$export$30ebe6cd1aac119d)(command, this.docBeforeStreaming ?? undefined);
        const removedLocalIds = [];
        preApplyLocalIds.forEach((id)=>{
            if (!postApplyLocalIds.has(id) && !explicitTargets.has(id)) removedLocalIds.push(id);
        });
        if (removedLocalIds.length > 0) {
            if (this.telemetryEventsEnabled) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'unexpected_node_removal',
                targetLocalId: effectiveTargetLocalId,
                removedLocalIds: removedLocalIds
            });
            return true;
        }
        // Streamable commands (`replaceNode`, `replaceDoc`,
        // `insertNodeBefore`, `insertNodeAfter`, `appendNode`,
        // `appendNodeToEnd`) are two-phase: the apply call only sets a
        // selection (and sometimes inserts a placeholder paragraph), and
        // the actual content change arrives later via streaming chunks.
        // At apply time the document has legitimately not changed yet, so
        // firing `no_document_change` here would produce false positives
        // for every streamable command. The deferred check fires from
        // `checkAndFireNoDocumentChangeAnalytics` in `endExperiencePromise`
        // once all stream chunks have been applied.
        if (!(0, $e357a3431509036d$export$f85aff2979b590a7)(command) && this.docBeforeStreaming && postApplyDoc.eq(this.docBeforeStreaming)) {
            if (this.telemetryEventsEnabled) (0, $800cd9937abd732b$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'no_document_change'
            });
            return true;
        }
        return false;
    }
    /**
   * Resume-mode counterpart of {@link applyCommand}.
   *
   * Unlike `applyCommand`, it does NOT invoke a tool-call action (which would set
   * the selection to end-of-doc and re-insert a placeholder, landing content in
   * the wrong place). Instead it sets the selection to the stored, mapped
   * positions via `reapply`, so the subsequent `openAIModal` (which reads its
   * range from `state.selection` when `isExternal` is set) fills the original
   * range.
   *
   * Kept as a dedicated method (rather than simply skipping `applyCommand`) so we
   * have a single home for resume/reapply telemetry.
   */ reapplyCommand(command, resume) {
        this.currentCommand = command;
        this.docBeforeStreaming = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        // Intentionally no tool-call action and no apply-anomaly diagnostics here:
        // resume re-applies into an explicit, already-resolved range. We set the
        // selection to the stored, transaction-mapped positions so that the
        // subsequent `openAIModal` (which reads its range from `state.selection`
        // when `isExternal` is set) re-applies the content where the aborted call
        // left off.
        //
        // The position is resolved at apply time from the toolCallId by reading the
        // LATEST (transaction-remapped) stored position; see `resolveResumePositions`
        // for the full rationale (multiple aborted tool calls resumed in sequence
        // must each anchor to their own remapped range).
        const resolved = (0, $ff56e6956d0962e2$export$47c18b0b568dba43)(this.api, resume);
        if (!resolved) // No stored position (shouldn't happen): re-run the command so content is
        // not lost. resumeAction already fires the fallback anomaly event.
        return this.applyCommand(command);
        return this.reapply(resolved.fromPos, resolved.toPos);
    }
    initStream(command, options) {
        const resume = options?.resume;
        // Resume mode: skip the tool-call action (which would re-resolve to end-of-doc)
        // and re-apply at the stored, mapped positions instead.
        const applied = resume ? this.reapplyCommand(command, resume) : this.applyCommand(command);
        // If we couldn't apply the command (ie. broken localId) add it to the abort cache so we don't apply anymore commands
        if (!applied) {
            // Never start the stream and resolve immediately
            if (this.currentAction?.id) this.updateAbortedCache([
                this.currentAction?.id
            ]);
            return true;
        }
        this.streamFlowPacer?.reset();
        this.adfStreamer?.reset();
        // We have to set an empty callback before starting otherwise the flow pacer wont start. We need to cleanup the flow pacer
        // and make it more generic.
        this.streamFlowPacer?.setEmit(()=>{});
        this.streamFlowPacer?.start();
        // Fire a simple operational event measuring the gap between the backend
        // finishing its stream and the pacer finishing draining it (HTML+ lag).
        this.streamFlowPacer?.onPacerCompletionGap((info)=>{
            (0, $800cd9937abd732b$export$121949ee4a6ce5f6)({
                api: this.api,
                backendEndToPacerCompleteMs: info.backendEndToPacerCompleteMs,
                backlogCharsAtBackendEnd: info.backlogCharsAtBackendEnd,
                charsPerTickAtComplete: info.charsPerTickAtComplete,
                terminalType: info.terminalType,
                traceId: this.traceId
            });
        });
        const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
        this.logger.logQueueState('Open AI Modal', {
            command: command
        });
        this.api.aiExperience.actions.openAIModal({
            invokedFrom: 'streamingApi',
            configItem: (0, $j2p1x.UNSTABLE_configItems).freeGenerateAifcConfigItem,
            withStreamingHighlight: !isCreate,
            // don't show accept reject screen for staging first-time creation streaming
            withAcceptReject: !isCreate,
            hideLoadingScreen: ((0, $ixfCV.fg)('platform_editor_tmp_hide_loader') && options?.hideLoadingScreen) ?? false,
            traceId: this.traceId,
            singleInstrumentationId: this.singleInstrumentationId,
            isCreate: isCreate,
            promptVersion: this.promptVersion
        });
        if (!(0, $e357a3431509036d$export$f85aff2979b590a7)(command)) (0, $800cd9937abd732b$export$276ecd5322451ab4)({
            api: this.api,
            command: this.currentCommand,
            docBeforeStreaming: this.docBeforeStreaming,
            traceId: this.traceId
        });
        return false;
    }
    async initStreamPromise(command, options) {
        await new Promise((resolve)=>{
            this.logger.logQueueState(`Init Command ${command.type}`, {
                command: command
            });
            if (this.initStream(command, options)) {
                resolve();
                this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                    command: command
                });
                return;
            }
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState.aiDecorationExperiencePluginState.isRunning) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                        command: command
                    });
                }
            });
        });
    }
    startSession(sessionId, traceId, singleInstrumentationId, promptVersion) {
        this.traceId = traceId;
        (0, $800cd9937abd732b$export$4b84cbb6abceadd2)({
            api: this.api,
            sessionId: sessionId,
            traceId: traceId,
            promptVersion: promptVersion
        });
        this.singleInstrumentationId = singleInstrumentationId;
        this.promptVersion = (0, $ixfCV.fg)('platform_editor_ai_promptversion_in_analytics') ? promptVersion : undefined;
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            this.resetSessionOutcomeState();
            // Capture the doc as it was before any streaming command runs.
            // `analyzeOutcome` will diff this against the post-session doc
            // at end-of-session to compute structural-delta fields.
            this.preSessionDoc = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        }
        this.logger.logPublic('Start Session', {
            sessionId: sessionId,
            singleInstrumentationId: singleInstrumentationId
        });
    }
    queueEndSession(sessionId) {
        this.logger.logPublic('Queue End Session', {
            sessionId: sessionId
        });
    }
    endSession(sessionId) {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            this.runPostApplyOutcomeAnalysis();
            this.fireSessionOutcomeOnce();
        }
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        this.promptVersion = undefined;
        this.currentCommand = undefined;
        this.logger.logPublic('End Session', {
            sessionId: sessionId
        });
    }
    /**
   * Fire the authoritative `sessionOutcome` analytics event for the current
   * session. Idempotent — calling this multiple times within the same session
   * results in at most a single event being fired.
   *
   * If `lifecycleSymptom` is supplied, it overrides any repair-derived
   * symptom and forces `outcome_class: 'failure'` — a session that never
   * reached end-of-stream cannot be a success.
   */ fireSessionOutcomeOnce(options = {}) {
        if (this.sessionOutcomeFired) return;
        this.sessionOutcomeFired = true;
        const { lifecycleSymptom: lifecycleSymptom } = options;
        const { anyJsonInvalid: anyJsonInvalid, anyAdfInvalid: anyAdfInvalid, unrepairedJsonCount: unrepairedJsonCount, unrepairedAdfCount: unrepairedAdfCount } = this.sessionRepairSignals;
        // Derive the session-level repair-signal contract reported on the
        // outcome event:
        // - `finalJsonInvalid` / `finalAdfInvalid`: did any action see that
        //   layer become invalid at all?
        // - `finalJsonRepaired` / `finalAdfRepaired`: was every invalid
        //   occurrence in the session recovered? (i.e. AND over the per-action
        //   `repaired` flags for actions where invalid=true). False when the
        //   layer was never invalid, matching the per-action semantic.
        const finalJsonInvalid = anyJsonInvalid;
        const finalAdfInvalid = anyAdfInvalid;
        const finalJsonRepaired = anyJsonInvalid && unrepairedJsonCount === 0;
        const finalAdfRepaired = anyAdfInvalid && unrepairedAdfCount === 0;
        // Post-apply analysis flags. Read from the analyzer result computed
        // in `runPostApplyOutcomeAnalysis`. Each flag drives one suspicious-
        // signal event AND (if the session would otherwise have succeeded)
        // upgrades the outcome class to `success_but_suspicious`.
        //
        // `noMeaningfulEffect` only counts when the session actually ran a
        // mutating tool call — a read-only session that happens to leave
        // the doc unchanged is not suspicious, it's expected.
        const analysis = this.lastOutcomeAnalysis;
        const hadMutatingToolCall = this.sessionToolCalls.some((tc)=>$e3512170c06603fc$var$MUTATING_COMMAND_TYPES.has(tc.commandType));
        const unintendedRegionRemoved = analysis !== undefined && analysis.unintendedRegionRemoved;
        const unintendedRegionModified = analysis !== undefined && analysis.unintendedRegionModified;
        // `textCharacterDelta` tolerance: we treat ±1 character as
        // negligible because the apply layer can legitimately inject or
        // strip a single trailing whitespace / newline / punctuation
        // character during ProseMirror normalisation (e.g. closing a block
        // node, collapsing adjacent whitespace, trimming a trailing space
        // the model emitted). Strict equality to 0 would generate
        // false-positive `noMeaningfulEffect` events for sessions whose
        // only effect was a one-character normalisation artefact. A wider
        // tolerance would risk hiding real (but tiny) edits.
        //
        // `attrSignaturesEqual` catches attribute-only edits (e.g. cell
        // background, panel type, heading level) that node count + text
        // length miss. See CCI-16816.
        // CCI-16968: when a replaceNode creates replacement nodes with fresh
        // localIds, the targeted node disappears from the post-doc top-level
        // snapshot. In that case the totalNodeDelta and textCharacterDelta
        // metrics are coincidentally 0/±1 even though real content was
        // rewritten — the content just moved to a new localId. Suppress
        // noMeaningfulEffect when any targeted top-level node is absent from
        // the post-doc (the replacement genuinely happened).
        const noMeaningfulEffect = analysis !== undefined && hadMutatingToolCall && analysis.totalNodeDelta === 0 && Math.abs(analysis.textCharacterDelta) <= 1 && analysis.attrSignaturesEqual && !analysis.anyAffectedLocalIdDisappearedPostApply;
        const intentEffectMismatch = analysis !== undefined && analysis.intentEffectMismatch;
        // Outcome class derivation per the design doc (Phase 1 + 3):
        // - failure                : any layer (ADF or JSON) was invalid and
        //                            could not be repaired, OR the session
        //                            ended via a lifecycle event (abort /
        //                            timeout)
        // - success_with_repairs   : a layer was invalid but every invalid
        //                            occurrence was recovered
        // - clean_success          : no repair signals fired at all
        // - success_but_suspicious : the session would otherwise have been
        //                            clean_success or success_with_repairs
        //                            but the post-apply analyzer flagged
        //                            one or more suspicious signals
        // `failure` is never overridden by a suspicious signal — an
        // unrecovered apply error is more important than "looks fishy".
        const adfFailed = finalAdfInvalid && !finalAdfRepaired;
        const jsonFailed = finalJsonInvalid && !finalJsonRepaired;
        const anySuspiciousSignal = unintendedRegionRemoved || unintendedRegionModified || noMeaningfulEffect || intentEffectMismatch;
        let outcomeClass;
        if (lifecycleSymptom !== undefined || adfFailed || jsonFailed) outcomeClass = 'failure';
        else if (anySuspiciousSignal) outcomeClass = 'success_but_suspicious';
        else if (finalAdfRepaired || finalJsonRepaired) outcomeClass = 'success_with_repairs';
        else outcomeClass = 'clean_success';
        // Compute a small histogram of command types to help debug
        // no-effect sessions ("what was being attempted?"). Keys are
        // orchestrator command-type constants (not user content). Scoped
        // deliberately to `noMeaningfulEffect` sessions — avoids inflating
        // every sessionOutcome payload with histogram data that is only
        // useful when the session produced no meaningful change.
        let commandTypeCounts;
        if (noMeaningfulEffect) {
            commandTypeCounts = {};
            for (const tc of this.sessionToolCalls)commandTypeCounts[tc.commandType] = (commandTypeCounts[tc.commandType] ?? 0) + 1;
        }
        // True when any of the suspicious signals that fired came from a
        // heuristic rather than a backend-supplied label. Currently always
        // true for `unintendedRegionModified` (text-length proxy) and
        // `intentEffectMismatch` (intent inferred from tool-call mix).
        // Lets dashboards filter the noisier inferred signals out of
        // headline KPIs.
        const heuristicInferred = unintendedRegionModified || intentEffectMismatch ? true : undefined;
        // Pick the worst (symptom, detectionLayer) we observed: lifecycle >
        // unrecovered failure > successful repair > clean. `detectionLayer`
        // names where the symptom was *first surfaced* (parser for repair
        // signals, orchestrator for apply / lifecycle), not where this
        // event is fired. Unmapped pairs fall back to `unknown`/`low`.
        let detectionLayer = 'orchestrator';
        let symptom;
        if (lifecycleSymptom !== undefined) {
            // Lifecycle symptoms are orchestrator-owned (abort / timeout).
            detectionLayer = 'orchestrator';
            symptom = lifecycleSymptom;
        } else if (adfFailed) {
            // The orchestrator surfaced an unrecovered ADF schema failure
            // when it tried to apply the streamed ADF.
            detectionLayer = 'orchestrator';
            symptom = 'apply_failed_adf_schema_error';
        } else if (jsonFailed) {
            // Parser-layer detection. There is no dedicated routing-table
            // entry for an unrecovered JSON failure today; we still attach
            // the symptom so dashboards can see it, and it routes to
            // `unknown`/`low` until the routing table grows an entry
            // covering this case.
            detectionLayer = 'parser';
            symptom = 'final_json_invalid';
        } else if (finalAdfRepaired) {
            // ADF repair is the higher-severity success signal — checked
            // before JSON repair so a session that observed both still
            // surfaces the more impactful symptom (ADF/high) rather than
            // the weaker JSON/medium one. Preserves the "worst observed
            // signal wins" invariant.
            detectionLayer = 'parser';
            symptom = 'final_adf_invalid';
        } else if (finalJsonRepaired) {
            detectionLayer = 'parser';
            symptom = 'final_json_repaired';
        } else if (anySuspiciousSignal) {
            // Pick the highest-severity suspicious signal observed — worst
            // signal wins, matching the same invariant used for repair/failure
            // signals above. The four signals are checked in severity order:
            // unintendedRegionRemoved (content disappeared) > unintendedRegionModified
            // (content changed unexpectedly) > noMeaningfulEffect (no net change) >
            // intentEffectMismatch (structural delta contradicts inferred intent).
            detectionLayer = 'post_apply';
            if (unintendedRegionRemoved) symptom = 'unexpected_content_removal';
            else if (unintendedRegionModified) symptom = 'unintended_text_modification';
            else if (noMeaningfulEffect) symptom = 'no_meaningful_effect';
            else // intentEffectMismatch
            symptom = 'semantic_mismatch';
        }
        if (!this.telemetryEventsEnabled) return;
        (0, $800cd9937abd732b$export$f31b302ceb439402)({
            api: this.api,
            traceId: this.traceId,
            outcomeClass: outcomeClass,
            detectionLayer: detectionLayer,
            symptom: symptom,
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired,
            // Forward the post-apply analyzer flags so dashboards can see
            // "what happened" and "why it was suspicious" on a single
            // event. Each is `undefined` when the analyzer didn't run
            // (e.g. session aborted before any apply).
            ...analysis !== undefined ? {
                unintendedRegionRemoved: unintendedRegionRemoved,
                unintendedRegionModified: unintendedRegionModified,
                noMeaningfulEffect: noMeaningfulEffect,
                intentEffectMismatch: intentEffectMismatch,
                // Raw deltas — only attached when the corresponding
                // suspicious flag is true, to avoid forwarding
                // meaningless zeros on clean sessions.
                ...unintendedRegionRemoved ? {
                    removedNodeCount: analysis.removedNodeCount,
                    totalNodeDelta: analysis.totalNodeDelta,
                    // Indicates whether unintendedRegionRemoved used
                    // backend-supplied selectionLocalIds (precise) or
                    // the proxy fallback. Backend plumbing arrives with
                    // CCI-15978; until then always false.
                    selectionLocalIdsAvailable: false
                } : {},
                ...unintendedRegionModified ? {
                    textCharacterDelta: analysis.textCharacterDelta
                } : {}
            } : {},
            ...commandTypeCounts !== undefined ? {
                commandTypeCounts: commandTypeCounts
            } : {},
            ...heuristicInferred !== undefined ? {
                heuristicInferred: heuristicInferred
            } : {}
        });
    }
    /**
   * Schedules the `no_document_change` toolCallAnomaly check for streamable commands.
   *
   * The check must not run immediately after `processStreamCommandPromise` resolves
   * because `handleFinalize` (which commits the final content via two `view.dispatch`
   * calls) runs in a later `view.update()` cycle triggered by `endAIExperience`.
   * Firing immediately gives a stale pre-finalize doc — a guaranteed false positive.
   *
   * Instead we subscribe to `aiExperience.sharedState` and fire only after
   * `isStreaming` transitions to `false`, which happens after `handleFinalize`'s
   * commit transaction has landed and `getPmDoc()` is accurate.
   *
   * No-op when:
   * - The normalized telemetry experiment is disabled.
   * - `aiExperience` plugin is absent (streaming state machine unavailable).
   */ scheduleDeferredNoDocChangeAnalytics() {
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true) || !this.telemetryEventsEnabled || !this.api.aiExperience || this.toolCallResultFiredForCurrentCommand && (0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch2')) return;
        const capturedCommand = this.currentCommand;
        const capturedDocBeforeStreaming = this.docBeforeStreaming;
        const capturedTraceId = this.traceId;
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = this.api.aiExperience.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState != null && !nextSharedState.isStreaming) {
                this.pendingNoDocChangeUnsubscribe?.();
                this.pendingNoDocChangeUnsubscribe = undefined;
                if (!(this.toolCallResultFiredForCurrentCommand && (0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch2'))) (0, $800cd9937abd732b$export$276ecd5322451ab4)({
                    api: this.api,
                    command: capturedCommand,
                    docBeforeStreaming: capturedDocBeforeStreaming,
                    traceId: capturedTraceId
                });
            }
        });
    }
    /**
   * Reset session-outcome bookkeeping so the next session starts from a clean
   * slate. Called from `startSession`, `destroy`, and `abort`.
   */ resetSessionOutcomeState() {
        this.sessionRepairSignals = {
            anyJsonInvalid: false,
            anyAdfInvalid: false,
            unrepairedJsonCount: 0,
            unrepairedAdfCount: 0
        };
        this.sessionOutcomeFired = false;
        // Post-apply outcome analyzer state. Cleared so the next session
        // starts with an empty tool-call record and no stale analysis.
        this.sessionToolCalls = [];
        this.lastOutcomeAnalysis = undefined;
        this.preSessionDoc = undefined;
    }
    /**
   * Compute the structural-delta analysis for the just-completed session
   * and stash it on `lastOutcomeAnalysis`. Called from `endSession`
   * (gated). `fireSessionOutcomeOnce` reads `lastOutcomeAnalysis` to
   * derive the `success_but_suspicious` outcome class and to fire the
   * three suspicious-signal session-scope events.
   *
   * Skips silently if either the pre-session or post-session doc is
   * unavailable (e.g. editor view torn down mid-stream) — partial-data
   * analysis would produce misleading deltas.
   */ runPostApplyOutcomeAnalysis() {
        const postDoc = (0, $a7955f6a2f01a095$export$6bf900bab6a4720d)(this.api);
        if (this.preSessionDoc === undefined || postDoc === undefined) return;
        this.lastOutcomeAnalysis = (0, $ea65a4b3d3a11c9b$export$9aa9db1056f785bc)({
            preSessionAdf: this.preSessionDoc.toJSON(),
            postSessionAdf: postDoc.toJSON(),
            toolCalls: this.sessionToolCalls
        });
    }
    destroy() {
        this.queue = [];
        this.adfStreamer = undefined;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        this.promptVersion = undefined;
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = undefined;
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) this.resetSessionOutcomeState();
    }
    /**
   * Abort the current streaming and end the experience
   * This is a hard abort and will clear the queue
   * This will only restart the experience when initStreamCommand is called again
   */ abort() {
        this.logger.logPublic('Abort');
        // Fire BEFORE any state teardown so `traceId` and
        // `singleInstrumentationId` are still set and the event can be
        // correlated in dashboards (matches the timeout / clean-drain paths).
        // We deliberately do NOT reset `sessionOutcomeFired` here — the
        // guard must persist through any follow-up `endSession` / timeout
        // for this same session; the next `startSession()` resets it.
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) this.fireSessionOutcomeOnce({
            lifecycleSymptom: 'session_aborted'
        });
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = undefined;
        const currentQueue = this.queue.map((cmd)=>cmd.actionId);
        this.queue = [];
        // Add new aborted action IDs to end of array
        this.updateAbortedCache([
            ...new Set(currentQueue),
            ...this.inProcessing
        ]);
        this.isAborted = true;
        this.endExperience();
        this.isPendingResolveQueue = false;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.currentAction = null;
        this.isFinalStream = false;
        this.currentCommand = undefined;
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
    }
    updateAbortedCache(actionIds) {
        this.aborted = [
            ...new Set([
                ...this.aborted,
                ...actionIds
            ])
        ];
        const maxAbortedCacheLength = 5;
        if (this.aborted.length > maxAbortedCacheLength) this.aborted = this.aborted.slice(-maxAbortedCacheLength);
    }
    constructor(api, streamFlowPacer = null, telemetryEventsEnabled = false){
        this.api = api;
        this.streamFlowPacer = streamFlowPacer;
        this.telemetryEventsEnabled = telemetryEventsEnabled;
        this.queue = [];
        this.adfStreamer = void 0;
        this.streamingCommands = void 0;
        // Resume-mode selection setter used by reapplyCommand().
        this.reapply = void 0;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.isStreaming = false;
        this.isFinalStream = false;
        this.aborted = [];
        this.subscription = null;
        this.previousValidDoc = null;
        this.logger = void 0;
        this.endedActionIds = [];
        this.currentAction = null;
        this.insertAfterQueueLocalId = undefined;
        /**
     * The traceId received in response header from AI api call
     * This is used to trace the AI experience through the backend to frontend.
     */ this.traceId = undefined;
        /**
     * The singleInstrumentationId for tracking the AI experience
     * This is used to correlate events across multiple stream processing passes
     */ this.singleInstrumentationId = undefined;
        /**
     * The promptVersion from action metadata
     * This is used to track which version of the prompt was used for analytics
     */ this.promptVersion = undefined;
        /**
     * Aggregated repair signals across every streaming action in the current
     * session, used to fire the authoritative `sessionOutcome` event exactly
     * once per session.
     *
     * `*Invalid` aggregates with OR (any action that observed an invalid layer
     * marks the session as having seen an invalid layer).
     *
     * `*UnrepairedCount` counts how many actions had an invalid layer that was
     * NOT recovered. From these we derive a correct session-level "repaired"
     * value as: `*Invalid && *UnrepairedCount === 0` — i.e. every invalid
     * occurrence in the session was recovered.
     *
     * This avoids a misleading `success_with_repairs` classification when an
     * earlier action repaired successfully but a later action failed to repair:
     * a naive OR over `*Repaired` would incorrectly flatten the irrecoverable
     * failure into a success.
     */ this.sessionRepairSignals = {
            anyJsonInvalid: false,
            anyAdfInvalid: false,
            unrepairedJsonCount: 0,
            unrepairedAdfCount: 0
        };
        /**
     * Tracks whether the `sessionOutcome` analytics event has already been fired
     * for the active session. Ensures the event fires at most once per session.
     */ this.sessionOutcomeFired = false;
        /** Cleanup handle for the deferred no_document_change analytics subscription. Cleared in abort/destroy. */ this.pendingNoDocChangeUnsubscribe = undefined;
        /**
     * Set to true when a toolCallResult event has already been fired for the current
     * command (e.g. apply_failed_adf_schema_error from repair signals). Prevents
     * scheduleDeferredNoDocChangeAnalytics from firing a second toolCallResult for
     * the same command.
     */ this.toolCallResultFiredForCurrentCommand = false;
        /**
     * Per-session record of every tool call processed by `applyCommand`.
     * Consumed at end-of-session by `analyzeOutcome` to compute
     * `affectedLocalIds`. Reset at all session boundaries. Only populated
     * when the `platform_editor_ai_normalized_telemetry` experiment is on.
     */ this.sessionToolCalls = [];
        /**
     * The most recent `analyzeOutcome` result, computed at end-of-session.
     * Read by `fireSessionOutcomeOnce` (added by CCI-15893) to enrich the
     * `sessionOutcome` event with structural-delta fields. Undefined until
     * the first end-of-session analysis runs in the active lifetime, and
     * reset at all session boundaries.
     */ this.lastOutcomeAnalysis = undefined;
        /**
     * Snapshot of the editor document at session start, captured by
     * `startSession`. Consumed at end-of-session by `analyzeOutcome` as
     * `preSessionAdf`. Distinct from `docBeforeStreaming`, which is
     * reassigned per command for the per-command repair-signal pipeline.
     * Reset at all session boundaries. Only populated when the
     * `platform_editor_ai_normalized_telemetry` experiment is on.
     */ this.preSessionDoc = undefined;
        this.processingQueue = false;
        this.inProcessing = [];
        // Id of a timeout-force-finished tool call being processed; read once when
        // emitting the terminal `complete` event so it rides to `buildCommitTransaction`.
        this.pendingForceAbortedToolCallId = undefined;
        this.queueTimeout = null;
        // This is only used *if* we have started receiving values with a different
        // action id (new stream) and we have nothing left in the current stream (ie. it hasn't finished)
        // Really this shouldn't be hit since this would only happen on the edge when we're wrapping up the old stream
        // and starting the next early
        this.CURRENT_QUEUE_TIMEOUT = 5000;
        this.currentCommandTimeoutReset = null;
        this.onEmptyQueueResolve = null;
        // 2 seconds - this is the maximum time to process a command before we abort it and continue
        // This can be longer if for example if a lot of commands have been processed, but the stream flow
        // pacer has a backlog (particularly for elements with lots of attributes / marks etc) and hasn't had
        // a chance to emit yet
        this.COMMAND_TIMEOUT = 2000;
        this.isPendingResolveQueue = false;
        this.isAborted = false;
        this.logger = new (0, $5a1197e1a8fb1986$export$21e6cc849c1dc1ab)(api);
        this.streamingCommands = (0, $33e0a97ce57d98ef$export$a0774277976bc21f)(api);
        this.reapply = (0, $ff56e6956d0962e2$export$b49478c44446ab49)(api);
    }
}


const $1ce24a8ae51aaef4$export$4010adcbb216eb38 = ({ api: api, config: config })=>{
    if (!api) throw new Error('api is not defined');
    let streamQueue;
    // Only allow one session to be active at a time
    let sessionId = null;
    // Tracking variables for debugging session lifecycle issues
    let hasSessionBeenStarted = false;
    let isEndingSession = false;
    let lastEndedSessionId = null;
    let endSessionCallCount = 0;
    let sessionAborted = false;
    const streamFlowPacer = (0, $69782acbd729286a$export$9ea8217d5ec56f82)(config?.streamFlowPacerEnabled);
    const telemetryEventsEnabled = config?.telemetryEventsEnabled === true;
    return {
        name: 'aiStreamingOrchestrator',
        actions: {
            startSession: (traceId, params)=>{
                sessionId = crypto.randomUUID() ?? (0, $2nOF5.uuid).generate();
                hasSessionBeenStarted = true;
                sessionAborted = false;
                streamQueue = new (0, $e3512170c06603fc$export$f3feb8728b17a0a9)(api, streamFlowPacer, telemetryEventsEnabled);
                streamQueue.startSession(sessionId, traceId, params?.singleInstrumentationId, (0, $ixfCV.fg)('platform_editor_ai_promptversion_in_analytics') ? params?.promptVersion : undefined);
                // agentInfo is already gated by the platform_editor_agent_mentions experiment
                // in update-command-processor — it will be undefined when the experiment is off,
                // so no additional gate is needed here.
                api.aiExperience.actions.startSession(sessionId, traceId, (0, $ixfCV.fg)('platform_editor_ai_promptversion_in_analytics') ? params?.promptVersion : undefined, params?.agentInfo);
                return sessionId;
            },
            endSession: async (error)=>{
                // In the session abort we end the session and no longer need to run this
                // On a new session we reset the state so this is safe to ignore
                if (sessionAborted) return;
                if (sessionId === null) {
                    (0, $800cd9937abd732b$export$8b7d4483ec260574)({
                        api: api,
                        sessionStarted: hasSessionBeenStarted,
                        endSessionCallCount: endSessionCallCount,
                        lastEndedSessionId: lastEndedSessionId,
                        isDoubleCall: isEndingSession
                    });
                    throw new Error(`endSession requires a session to be started first!`);
                }
                endSessionCallCount++;
                isEndingSession = true;
                const currentSessionId = sessionId;
                try {
                    streamQueue?.queueEndSession(currentSessionId);
                    if (error) {
                        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api.aiExperience.actions.dispatchAIEvent({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                        else {
                            const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                            send({
                                type: 'error',
                                errorInfo: {
                                    failureReason: error.failureReason,
                                    statusCode: error.statusCode
                                }
                            });
                        }
                    }
                    // Since `endSession` is going to be called after all the actions are invoked
                    // so we can basically wait for the queue to be empty
                    await streamQueue?.onEmptyQueue();
                    streamQueue?.endSession(currentSessionId);
                    // https://atlassian.slack.com/archives/C0962DYFLRL/p1759397599541949?thread_ts=1759366160.706849&cid=C0962DYFLRL
                    // streamQueue?.destroy();
                    api.aiExperience.actions.endSession(currentSessionId, {
                        type: error ? 'error' : 'finished'
                    });
                    hasSessionBeenStarted = false;
                    lastEndedSessionId = currentSessionId;
                    sessionId = null;
                } finally{
                    isEndingSession = false;
                }
            },
            abortSession: ()=>{
                // abortSession can be called multiple times from multiple command handlers
                if (!sessionId) return;
                const sessionToEnd = sessionId;
                lastEndedSessionId = sessionToEnd;
                sessionId = null;
                streamQueue?.abort();
                if (sessionToEnd) {
                    api.aiExperience.actions.endSession(sessionToEnd, {
                        type: 'abort'
                    });
                    sessionAborted = true;
                }
            },
            initAction: (command, options)=>{
                if (sessionId === null) throw new Error('initAction requires a session to be started first!');
                const actionId = crypto.randomUUID();
                streamQueue?.initStreamCommand(actionId, command, options);
                return actionId;
            },
            // Resume a tool call aborted by the queue timeout, re-applying its content
            // at the stored (mapped) position. Runs inside the still-open session by
            // driving initStream in resume mode, streaming the snapshot, then finishing.
            resumeAction: (toolCallId, command, fullValue)=>{
                if (sessionId === null) throw new Error('resumeAction requires a session to be started first!');
                const stored = api.aiExperience.actions.getAbortedToolCallPosition?.(toolCallId);
                const actionId = crypto.randomUUID();
                if (!stored) // Should not happen in practice (content is always streamed before a
                // timeout abort). Fire an anomaly so this degradation is observable in
                // production. The queue's resume path will itself fall back to
                // re-running the real command when no stored position is found.
                (0, $800cd9937abd732b$export$50f05d3d56fe90a9)({
                    api: api,
                    commandType: command.type
                });
                // Resume mode is keyed solely by `toolCallId`: the queue resolves the
                // LATEST (transaction-remapped) stored position at apply time. This
                // matters when multiple aborted tool calls are resumed in sequence —
                // each earlier resume mutates the document and shifts the not-yet-resumed
                // positions, so reading the up-to-date value at apply time keeps every
                // resume anchored to its own content instead of collapsing onto a stale,
                // shared range.
                streamQueue?.initStreamCommand(actionId, command, {
                    resume: {
                        toolCallId: toolCallId
                    }
                });
                streamQueue?.queueStreamCommand(actionId, fullValue);
                streamQueue?.endStreamCommand(actionId);
            },
            // We are sending the full document as a chunk for create actions
            streamValue: (actionId, chunk)=>{
                // Use the queue manager to handle streaming
                // This will either process immediately if actor is ready, or queue for later
                streamQueue?.queueStreamCommand(actionId, chunk);
            },
            // HTML+ v2 incremental tool-call streaming contract:
            // Each chunk is a full snapshot of the value, not a delta.
            //
            // IMPORTANT — REPLACE-NOT-APPEND INVARIANT:
            // At the queue layer this is currently equivalent to `streamValue`
            // because `streamCommandQueue.ts#processStreamCommand` resets the
            // internal ADFStreamer accumulator on every processed chunk before
            // parsing. **Two distinct public actions (`streamValue` and
            // `replaceValue`) depend on this single internal behaviour.** If
            // `streamValue` is ever migrated to append semantics for the v1
            // path, this `replaceValue` body MUST be rewired to a dedicated
            // `queueReplaceCommand` (or equivalent) on `StreamCommandQueue`
            // that preserves the replace-on-snapshot guarantee, otherwise v2
            // callers (`ToolCallProcessorV2`) will silently break — each
            // snapshot would be appended to the previous one instead of
            // replacing it, producing duplicated / concatenated ADF.
            //
            // See `streamCommandQueue.ts#processStreamCommand` for the
            // implementation detail this invariant relies on.
            replaceValue: (actionId, fullValue)=>{
                streamQueue?.queueStreamCommand(actionId, fullValue);
            },
            notifySchemaContentRejection: (actionId, errorMessage)=>{
                if ((0, $ixfCV.fg)('platform_editor_ai_normalized_telemetry_patch2')) streamQueue?.notifySchemaContentRejection(actionId, errorMessage);
            },
            finishAction: (actionId, error, options)=>{
                if (error) {
                    if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api.aiExperience.actions.dispatchAIEvent({
                        type: 'error',
                        errorInfo: {
                            failureReason: error.failureReason,
                            statusCode: error.statusCode
                        }
                    });
                    else {
                        const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                        send({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                    }
                }
                // On a timeout force-finish, pass the aborted tool call id through
                // endStreamCommand. It rides the terminal `complete` event so
                // `buildCommitTransaction` (the last write of the tool call's content)
                // persists its final positions for resume.
                streamQueue?.endStreamCommand(actionId, {
                    forceAbortedToolCallId: options?.abortedToolCallId
                });
            }
        },
        usePluginHook: ()=>{
            const prevStreamPausedRef = (0, $cozmU.useRef)(undefined);
            (0, $1KOhB.usePluginStateEffect)(api, [
                'aiExperience'
            ], ({ aiExperienceState: aiExperienceState })=>{
                const streamPaused = aiExperienceState?.aiSessionPluginState?.streamPaused;
                if (streamPaused !== prevStreamPausedRef.current) {
                    if (streamPaused) streamFlowPacer?.pause();
                    else streamFlowPacer?.resume();
                    prevStreamPausedRef.current = streamPaused;
                }
            }, {
                disabled: !(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
            });
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    streamQueue?.destroy();
                };
            }, []);
        }
    };
};
module.exports["aiStreamingOrchestratorPlugin"] = $1ce24a8ae51aaef4$export$4010adcbb216eb38;

});


//# sourceMappingURL=CommentEditor.cac081a3.js.map
